const en_US = {
  translations: {
    common: {
      copy: "Copy",
      yes: "Yes",
      no: "No",
    },
    menu_bar: {
      add_variables: "Add variables",
    },
    home: {
      message: "Hello World!",
    },
    page: {
      panels: {
        title: "Panels",
        edit: "To edit",
        search: "Search for a panel",
        add: "Add Painel",
        sync_confirm: {
          title: "Update data",
          description:
            "This panel's data will be reprocessed in the background, covering information up to the previous day. It may take a few minutes. Do you want to continue?",
          cancel: "Cancel",
          confirm: "Yes, update",
        },
        executions_modal: {
          title: "Panel data updates",
          running_alert:
            "There is already an update in progress for this panel. Follow the progress below.",
          running_tooltip: "Wait for the update in progress to finish",
          no_data: "No data updates registered for this panel.",
          sync: "Update data",
          close: "Close",
          of: "of",
        },
        sync_tooltip: "Update Data",
        refresh_tooltip: "Update Dashboard",
        confirm: {
          title: "Delete panel?",
          description:
            "This will permanently delete the panel, its dashboards and all the data.",
        },
        name: "Name",
        view_more: "View more",
        no_data: "No panel found",
        cancel_button: "Cancel",
        confirm_button: "Yes, delete",
        delete: "Delete",
      },
      reports: {
        title: "Reports",
        search: "Search for a report",
        code: "Code",
        name: "Name",
        type: "Type",
        description: "Description",
        no_data: "No reports found",
        editDescription: {
          title: "Edit description",
          visual: "Visual",
          html: "HTML code",
          htmlPlaceholder: "Paste or type the description HTML code",
          save: "Save",
          cancel: "Cancel",
        },
        execution: {
          title: "Report Execution",
          startDate: "Start Date",
          endDate: "End Date",
          ticketServices: "Ticket Services",
          ticketService: "Ticket service",
          workspaces: "Workspaces",
          channels: "Boards",
          users: "Users",
          attendants: "Attendants",
          created: "Created",
          automationCode: "Automations",
          automationCodeExcept: "Except Automations",
          establishments: "Establishments",
          esignRules: "Signature Rules",
          monthYear: "Month/Year",
          generate: "Generate Report",
          search: "Search",
          back: "Back",
          code: "Code",
          reportLabel: "Report",
          all: "All",
          loading: "Loading report...",
          noResultData: "No data found for the selected filters.",
          group: "Group",
          validation: {
            startDateRequired: "Start date is required",
            endDateRequired: "End date is required",
            createdRequired: "Select a month",
            ticketServicesRequired: "Select at least one ticket service",
            workspacesRequired: "Select at least one workspace",
            channelsRequired: "Select at least one board",
            invalidDateRange: "Start date cannot be later than end date",
          },
          period: {
            thisMonth: "Current month",
            lastMonth: "Last month",
            selectMonth: "Specify month",
          },
          header: {
            generatedAt: "Generation date and time",
            generatedBy: "User",
            generatedLine: "Generated on {{date}} by {{user}}",
          },
          actions: {
            print: "Print",
            exportExcel: "Excel",
          },
          metadata: {
            title: "Filters used",
            month: "Month",
            period: "Period",
            generatedAt: "Generated at",
          },
          table: {
            reason: "Reason",
            totalTickets: "Total Tickets",
            monthReference: "Reference Month",
            dateReference: "Reference Date",
            periodReference: "Reference Period",
            board: "Board",
            user: "Attendant",
            automation: "Automation",
            quantity: "Quantity",
            name: "Name",
            triggers: "Triggers",
            confirm: "Confirm",
            cancel: "Cancel",
            notMe: "Not me",
            yes: "Yes",
            no: "No",
            ok: "Ok",
            invalid: "Invalid",
            talkToAttendant: "Talk to Attendant",
            finish: "Finish",
            noResponse: "No Response",
            invalidResponse: "Invalid Response",
            establishment: "Establishment",
            client: "Client",
            sent: "Sent",
            received: "Received",
            total: "Total",
            ticketsQuantity: "Tickets Quantity",
            tokenName: "Token Name",
            service: "Service",
            displayOrder: "Display order",
            area: "Area",
            clicks: "Clicks",
          },
        },
      },
      edit_panel: {
        title: "Panel",
        subtitle: "New panel ",
        name: "Name",
      },
      under_construction: {
        title: "Under construction",
        subtitle:
          "  This section is under construction, while it is not finished visit one of the other sections",
        button: " Visit Generics Register",
      },
      login: {
        login: "Login",
        accessing: "Accessing",
        welcome: "Welcome back",
        rememberme: "Remember me",
        forget_password: "Forgot password?",
        username: "CPF",
        password: "Senha",
      },
      dashboardExecutions: {
        title: "Dashboard data updates",
        search_placeholder: "Search by panel name",
        view_details: "View details",
        code: "Code",
        panel: "Panel",
        origin: "Origin",
        status_label: "Status",
        all_status: "All",
        progress: "Progress",
        running_generates: "In progress",
        failed_generates: "Failed",
        created: "Requested at",
        finished_date: "Finished at",
        start_date: "Start date",
        end_date: "End date",
        failed_alert:
          "Some processings ran out of retries and will not be redone automatically. The remaining data has already been updated.",
        purged_alert:
          "The details of this update were removed by retention on {{date}}.",
        status: {
          queued: "Queued",
          processing: "Processing",
          failed: "Failed",
          finished: "Finished",
          finishedwitherror: "Finished with error",
        },
        detail: {
          header_title: "Update {{code}}",
          title: "Processings",
          reprocess_all: "Reprocess failures",
          reprocess_one: "Reprocess",
          reprocess_success: "{{count}} processing(s) sent to reprocess.",
          reprocess_nothing:
            "Nothing to reprocess: only processings that ran out of retries can be reprocessed.",
          reprocess_confirm: {
            title: "Reprocess",
            description_all:
              "All failed processings of this update will go back to the queue and the panel will stay updating until they finish. Do you want to continue?",
            description_one:
              "This processing will go back to the queue and the panel will stay updating until it finishes. Do you want to continue?",
            cancel: "Cancel",
            confirm: "Yes, reprocess",
          },
          search_placeholder: "Search by error",
          component: "Component",
          group_type: "Grouping",
          period: "Period",
          status: "Status",
          retries: "Retries",
          end_process_date: "Processed at",
          error: "Error",
        },
      },
      dashboardGenerateConfig: {
        title: "Data update configuration",
        subtitle: "Dashboard processing parameters",
        maxBatchSize: "Batch size",
        max_batch_size_helper: "Number of processings in each batch.",
        maxBatchNumbers: "Number of batches",
        max_batch_numbers_helper: "Number of batches per transaction.",
        maxRetries: "Max retries",
        max_retries_helper:
          "How many times a failed processing is retried before it is considered a failure.",
        maxPendingBatchTransactions: "Max pending transactions",
        max_pending_batch_transactions_helper:
          "How many transactions can be waiting for processing before a new batching.",
        retentionDaysReduced: "Finished retention (days)",
        retention_days_reduced_helper:
          "For how many days the details of finished processings are kept.",
        retentionDaysFailed: "Failure retention (days)",
        retention_days_failed_helper:
          "For how many days, counted from the last failure, a failed update stays open for correction before being closed.",
        alertEmails: "Alert e-mails",
        alert_emails_helper:
          "Recipients of the daily warning when there are failures, stuck processings or cleanup problems. Separate with comma or semicolon. Empty = no warning.",
        errors: {
          max_batch_size: "Enter a batch size greater than zero",
          max_batch_numbers: "Enter a number of batches greater than zero",
          max_retries: "Enter max retries greater than zero",
          max_pending_batch_transactions:
            "Enter max pending transactions greater than zero",
          retention_days_reduced: "Enter a retention greater than zero",
          retention_days_failed: "Enter a retention greater than zero",
          alert_emails: "Enter valid e-mails, separated by comma or semicolon",
        },
      },
      not_found: {
        page_not_found: "Ooops! Page not found",
        server_not_responding: "Server not responding",
        try_again: "Try Again",
        back_to_begin: "Back to home",
        back_to_login: "Back to login",
        something_went_wrong: "Something went wrong",
      },
      dashboard: {
        dashboard: "Very Welcome!",
        account_balance: "Account balance",
        refresh_button: "Refresh",
        idle: "Idle",
        active: "Active",
      },
      register: {
        generics: {
          identifier: "Identifier",
          code: "Code",
          value: "Value",
          generics: "Generics",
          generic: "Generic",
          description: "Description",
          delete_generics: "Delete Generics",
          new_generic: "New Generic",
          search_identifier: "Searh for a identifier",
          edit_generic: "Edit Generic",
          confirm: {
            title: "Delete generic?",
            description: "This will permanently delete the generic",
            cancellationText: "Cancel",
            confirmationText: "Yes, delete",
          },
          errors: {
            identifier: "The identifier is mandatory",
            code: "The code is mandatory",
            value: "The value is mandatory",
          },
        },
        roles: {
          name: "Name",
          establishments: "Establishments",
          full_name: "Full name",
          privileges: "Privileges",
          privileges_tab: "Privileges",
          dashboards_tab: "Dashboards",
          reports_tab: "Reports",
          ticket_default_doc_categories_tab: "Default Protocol Category",
          list_categories_tab: "DList Categories",
          list_classifications_tab: "DList Classifications",
          dashboards_grid_title: "Dashboards",
          search_dashboard: "Search dashboard",
          add_dashboard: "Add dashboard",
          dashboard: "Dashboard",
          reports: "Reports",
          search_report: "Search report",
          add_report: "Add report",
          code: "Code",
          report: "Report",
          report_with_code: "#{{code}} - {{name}}",
          linked_dashboard_remove_title: "Remove linked dashboard?",
          linked_dashboard_remove_description:
            "This only removes the link between this dashboard and the profile.",
          linked_report_remove_title: "Remove linked report?",
          linked_report_remove_description:
            "This only removes the link between this report and the profile.",
          linked_list_category_remove_title: "Remove linked category?",
          linked_list_category_remove_description:
            "This will only remove the link between this category and the profile.",
          linked_list_classification_remove_title:
            "Remove linked classification?",
          linked_list_classification_remove_description:
            "This will only remove the link between this classification and the profile.",
          linked_ticket_default_doc_category_remove_title:
            "Remove linked category?",
          linked_ticket_default_doc_category_remove_description:
            "This only removes the link between this category and the profile.",
          dashboard_link_removed: "Dashboard link removed successfully",
          report_link_removed: "Report link removed successfully",
          ticket_default_doc_categories: "Default Protocol Categories",
          ticket_default_doc_category: "Default Protocol Category",
          search_ticket_default_doc_category: "Search category",
          add_ticket_default_doc_category: "Add category",
          list_categories: "List Categories",
          list_category: "List Category",
          search_list_category: "Search category",
          add_list_category: "Add category",
          list_classifications: "List Classifications",
          list_classification: "List Classification",
          search_list_classification: "Search classification",
          add_list_classification: "Add classification",
          edit_link: "Edit link",
          roles: "Profiles",
          enable: "Enable",
          profiles: "Roles",
          roles_profile: "Roles that will have this profile linked",
          delete_role: "Delete profile",
          search_role: "Search by a profile",
          description: "Description",
          new_role: "New profile",
          software: "Software",
          select_software: "Select a software",
          config_access: "Profile access settings",
          confirm: {
            title: "Delete profile?",
            description: "This will permanently delete the profile",
          },
          errors: {
            name: "The name is mandatory",
            description: "The description is mandatory",
            establishments: "At least one establishment is mandatory",
            privilege: "At least one privilege is mandatory",
            ticket_default_doc_category: "The category is mandatory",
            list_category: "The category is required",
            list_classification: "The classification is required",
            software: "The software is mandatory",
          },
        },
        legalPerson: {
          new_legalPerson: "New Legal Entity",
          legalPersons: "Legal Entities",
          delete_legalPersons: "Delete legal entitys",
          search_legalPerson:
            "Search for document, corporate name or fantasy name",
          add_legalPerson: "Add legal entity",
          document: "Document",
          corporateName: "Company name",
          tradingName: "Fantasy name",
          contacts: "Contacts",
          //
          taxRegime: "Tax Regime",
          fiscalContributor: "Fiscal contributor",
          stateRegistration: "Registro de estado",
          municipalInscription: "Municipal inscription",
          foreigner: "Foreigner",
          country: "Country",
          //
          contactType: "Contact type",
          addContact: "Add Contact",
          //
          addresses: "Adresses",
          add_address: "Add address",
          addressType: "Address Type",
          zip_code: "Zip Code",
          city: "City:",
          province: "State:",
          addressDescription: "Street",
          establishmentId: "Establishment",
          neighborhood: "Neighborhood",
          number: "Number",
          complement: "Complement",
          establishment_tooltip: "See establishment",
          confirm: {
            title: "Delete legal entity?",
            description: "This will permanently delete the legal entity ",
            title_plural: "Delete legal entitys?",
            description_plural:
              "This will permanently delete the legal entitys",
          },
          errors: {
            document: {
              nomempty: "The document is mandatory",
              regex: "Invalid CNPJ Number",
            },
            corporateName: "The name of the company is mandatory",
            country: "The contry is mandatory for foreigners",
            establishment: "The establishment is mandatory",
            fiscal_contribuitor: "The fiscal contributor is mandatory",
            tax_regime: "The tax regime is mandatory",
            contact: {
              contactTypeId: "The type of contact is mandatory",
              phone: "Invalid phone number",
              email: "Invalid e-mail",
              site: "Invalid site",
              other: "The value is mandatory",
            },
            address: {
              zipCode: "Invalid CEP",
              addressTypeId: "Select a type",
              city: "The city is mandatory",
              province: "The state is mandatory",
              addressDescription: "The street is mandatory",
              neighborhood: "The neighborhood is mandatory",
              number: "Invalid number",
            },
          },
        },
        languages: {
          languages: "Languages",
          new_language: "New language",
          edit_language: "Edit language",
          search_language: "Search for a language",
          name: "Name",
          code: "Code",
          establishments: "Establishments",
          establishment_tooltip: "See establishments",
          confirm: {
            title: "Delete language?",
            description: "This will permanently delete the language",
          },
          errors: {
            name: "The name is mandatory",
            establishments: "The establishment is mandatory",
          },
        },
        users: {
          actives: "Actives",
          inactives: "Inactives",
          start_date: "Start date",
          end_date: "End date",
          users: "Users",
          user: "User",
          new_user: "New user",
          username: "CPF",
          full_name: "Full name",
          user_profiles: "User profiles",
          user_roles: "User roles",
          name: "Name",
          enable: "Enable",
          document: "Document",
          email: "Email",
          password: "Password",
          individual: "Individual",
          user_integration_type: "Type",
          integration: "Integration Code",
          add_new_integration: "Add Integration",
          user_integration: "Integration",
          integration_id: "Integration Code",
          resend_mail: "Resend email",
          beneficiary_sync: "Beneficiary Synchronization",
          beneficiary_sync_success: "Beneficiary synchronized successfully",
          beneficiary_sync_no_document:
            "User does not have a registered document",
          email_confirmed_label: "Email status",
          email_confirmed_tag: "Confirmed",
          email_not_confirmed_tag: "Not confirmed",
          main_establishments:
            "Main establishment to which the user has a legal link",
          config: "User access settings",
          establishments_access: "Establishments that the user can access",
          establishments_tooltip: "See establishments",
          establishment_tooltip: "See establishment",
          search_user: "Search for a user",
          add_user: "Add user",
          roles_inherited:
            "Profiles that the user has inherited based on the roles they have",
          none_roles_inherited: "No inherited profile found",
          roles_tooltip: "See profiles",
          email_tasy_warning:
            "This is an informational field. Changes made here have no effect. Please change the email address in Tasy.",
          email_not_confirmed: "Email not confirmed by user",
          email_confirmation_date: "Email confirmation date",
          tooltip_main_estabishment:
            "By default, at the time of creation, the current establishment is defined as the main establishment",
          reset_password: {
            button: "Reset password",
            title:
              "Are you sure you want to reset the password for user {{username}}?",
            title_form: "Reset password for user {{username}}",
            site: "Site",
            site_error: "The site is mandatory",
            sending: "Sending",
            email_sent: "We send a change link of the sign to:",
            confirm: "Reset",
            cancel: "Cancel",
          },
          temporary_password: {
            button: "Temporary password",
            password_copied: "Copied successfully",
            copy: "Copy",
            title: "Temporary password",
          },
          change_pin: {
            button: "Change PIN",
            title: "Change the PIN for user {{username}}",
            pin: "New PIN",
            pin_error: "The PIN must contain exactly 4 digits",
            confirm: "Save",
            cancel: "Cancel",
            success: "PIN changed successfully",
          },
          errors: {
            username: "The CPF is mandatory",
            password: "The password is mandatory",
            individual: "The individual is mandatory",
            user_integration_type: "The type is mandatory",
            integration: "The integration code is mandatory",
            email: "The email is mandatory",
            establishments: "Select at least one establishment",
            establishment_standard:
              "The main establishment to which the user has a legal link is mandatory",
            profiles: "At least one user role must be selected",
          },
          confirm: {
            title: "Delete user?",
            description: "This will permanently delete the user",
          },
        },
        establishmentParams: {
          establishmentParams: "General parameters",
          value: "Value",
          description: "Description",
          public: "Public",
          establishmentParamTypeId: "Param type",
          add_establishmentParam: "Add general parameter",
          search_param: "Search for a param",
          new_param: "New param",
          confirm: {
            title: "Delete general parameter?",
            description: "This will permanently delete the general parameter",
          },
          errors: {
            value: "The value is mandatory",
            description: "The description is mandatory",
            establishmentParamTypeId: "The param type is mandatory",
          },
        },
        individuals: {
          sync_beneficiary: {
            button: "Sync Beneficiaries",
          },
          beneficiary_sync_success: "Beneficiary successfully synced",
          beneficiary_sync_no_document:
            "Individual does not have a registered document",
          individuals: "Individuals",
          individual: "Individual",
          new_individual: "New Individual",
          search_individuals: "Search for an individual",
          add_individual: "Add Individual",
          foreigner: "Foreigner",
          identity_card: "Identity Card",
          name: "Name",
          document: "Document",
          birth_date: "Birth date",
          contacts: "Contacts",
          add_contact: "Add Contact",
          contact_type: "Contact Type",
          addresses: "Addresses",
          add_address: "Add Adress",
          address_type: "Addess Type",
          address_description: "Street",
          number: "Number",
          zip_code: "Zip Code",
          city: "City",
          province: "State",
          complement: "Complement",
          country: "Country",
          neighborhood: "District",
          gender: "Gender",
          family_group: "Family Group",
          add_family_group: "Add Family Group",
          family_individual: "Individual",
          kinship_degree: "Degree of Kinship",
          imports: "Imports",
          confirm: {
            title: "Delete individual?",
            description: "This will permanently delete the individual",
          },
          errors: {
            name: "The name is mandatory",
            document: "The document is mandatory",
            document_regex: "Should be a valid document",
            birth_date: "The birth date is mandatory",
            country: "The country is mandatory",
            gender: "The gender is mandatory",
            contact: {
              contactTypeId: "The type of contact is mandatory",
              phone: "Invalid phone number",
              email: "Invalid e-mail",
              site: "Invalid site",
              other: "The value is mandatory",
            },
            address: {
              addressTypeId: "The address type is mandatory",
              zipCode: "The zip code is mandatory",
              city: "The city is mandatory",
              provincy: "The state is mandatory",
              addressDescription: "The street is mandatory",
              neighborhood: "The neighborhood is mandatory",
              number: "The number is mandatory",
            },
            family_individual: "The individual is mandatory",
            kinship_degree: "The degree of kinship is mandatory",
          },
        },
        individualsImports: {
          imports: "Imports",
          import: "Import",
          search: "Search for an import",
          new_import: "New import",
          file_name: "File Name",
          normalized_file_name: "Normalized File Name",
          status: "Status",
          add_import: "Add import",
          view_individuals: "View Individuals",
          import_individuals: "Importing Individuals",
          import_successfully: "Imported successfully",
          download_model: "Download model",
          search_imports: "Search for an import",
        },
        importList: {
          imports_individuals: "Importing Individuals",
          name: "Name",
          document: "Document",
          status: "Status",
          birth_date: "Birth date",
          gender: "Gender",
          foreigner: "Foreigner",
          yes: "Yes",
          no: "No",
          cns: "CNS",
          address: "Address",
          number: "Number",
          neighborhood: "Neighborhood",
          complement: "Complement",
          city: "City",
          zip_code: "Zip Code",
          country: "Country",
          neighborhood_code: "Neighborhood Code",
          city_ibge_code: "City IBGE Code",
          identity_card: "Identity Card",
          email: "Email",
          phone: "Phone",
          view: "View more",
        },
        documents: {
          documents: "Terms and policies",
          new_document: "New document",
          version: "Version",
          date: "Date",
          document: "Document",
          add_document: "Add document",
          doc_type: "Document type",
          select_doc_type: "Select document type",
          no_docs_selected: "No document type was selected",
          no_docs_version: "Document type does not have any version",
          see_document: "See document",
          table_title: "Version history",
          export_csv: "Export Csv",
          docsVersion: {
            last_version: "Last version",
            new_version: "New version",
            edit_version: "Edit",
          },
          create_document: {
            new_document: "Document",
            add_new_language: "Add new language",
            version: "Version",
            version_date: "Version date",
            add_document: "Add document",
            language: "Language",
            name: "Name",
            content: "Content",
            enable: "Enable",
            language_tooltip: "See language",
          },
          document_modal: {
            version: "Version",
            version_date: "Version date",
            name: "Name",
            language: "Language",
            content: "Content",
          },
          errors: {
            version: "The version is mandatory",
            version_regex: "The version should be a number",
            language: "The language is mandatory",
            name: "The name is mandatory",
            content: "The content is mandatory",
          },
        },
        establishments: {
          establishments: "Establishments",
          establishment: "Establishment",
          new_establishment: "New establishment",
          name: "Name",
          ansCode: "Operator Code in ANS",
          integration: "Customer establishment code",
          domain_admin: "Admin panel domain",
          collector_host: "Collector host",
          parent_host: "Host collector cloud",
          real_time_host: "Real time host",
          search_establishment: "Search for a name",
          add_establishment: "Add establishment",
          company: "Company",
          enable: "Enable",
          config_on_premise: "On premise environment settings",
          notifications: "Notifications",
          critical_communication_emails: "Emails for critical communications",
          critical_communication_emails_info:
            "Enter the email addresses separated by commas",
          languages: "Languages",
          sync: "Sync environment on premise",
          sync_beneficiaries: "Synchronize beneficiaries",
          see_establishments: "See establishment on premise",
          see_params: "See Parameters on premise",
          see_generics: "See Generics on premise",
          see_health: "Synchronized Health Plans",
          see_medic_specialties_on_premise: "See medical specialties",
          see_medical_practice_areas: "See areas of medical practice",
          see_provider_types: "See provider types",
          see_professional_councils: "See professional councils",
          see_extensions: "See extensions on premise",
          synced: "Synced successfully",
          jobs: "Jobs",
          crmDomain: "CRM domain",
          telemedDomain: "4uTelemed domain",
          languages_tooltip: "See languages",
          extensions_on_premise: "Extensions on premise",
          generics_on_premise: "Generics on premise",
          params_on_premise: "Parameters on premise",
          establishment_on_premise: "Establishment on premise",
          health_on_premise: "Synchronized Health Plans",
          medic_specialties_on_premise: "Medical specialties",
          provider_types_on_premise: "Provider types",
          professional_councils_on_premise: "Professional councils",
          medical_practice_areas_on_premise: "Areas of medical practice",
          domain: "Domain",
          filemanager_host: "Filemanager host in cloud",
          softwares: "Applications",
          legal_entity: "Legal Entity",
          confirm: {
            title: "Delete establishment?",
            description: "This will permanently delete the establishment",
          },
          errors: {
            name: "The name is mandatory",
            company: "The company is mandatory",
            languages: "Select at least one language",
            integration:
              "The establishment code in the client must be greater than 1",
            domain_admin: "The admin panel domain is mandatory",
            collector_https:
              "The collector host must starts with 'http://' or 'https://'",
            parent_https:
              "The host collector cloud must starts with 'http://' or 'https://'",
            real_time_https:
              "The real time host must starts with 'http://' or 'https://'",
            domain_admin_https:
              "The admin panel domain must starts with 'http://' or 'https://'",
            filemanager_host_https:
              "The filemanager host in cloud must starts with 'http://' or 'https://'",
            ans_code: "The operator code in ANS is mandatory",
            filemanager_host: "The filemanager host in cloud is mandatory",
            parent_host: "The host collector cloud is mandatory",
            collector_host: "The collector host is mandatory",
            real_time_host: "The real time host is mandatory",
            critical_communication_emails:
              "Enter valid email addresses separated by commas",
          },
        },
        countries: {
          countries: "Countries",
          country: "Country",
          search_country: "Search for a name",
          add_country: "Add country",
          new_country: "New country",
          name: "Name",
          code: "Code",
          enable: "Enable",
          ddi_code: "DDI code",
          phone_mask: "Phone mask",
          phone_mask_help:
            "The mask must be sent as per example: (00)000000000, where the 'zero' represents the telephone numbers",
          confirm: {
            title: "Delete country?",
            description: "This will permanently delete the country",
          },
          errors: {
            code: "The code is mandatory",
            name: "The name is mandatory",
          },
        },
        cities: {
          cities: "Cities",
          city: "City",
          new_city: "New city",
          name: "Name",
          provincy: "state",
          enable: "Enable",
          ibge_code: "IBGE Code",
          correio_code: "Post code",
          search_city: "Search for a city",
          add_city: "Add City",
          errors: {
            name: "The name is mandatory",
            ibge_code: "The IBGE Code is mandatory",
            correio_code: "The Post Code is mandatory",
            provincy: "The state is mandatory",
          },
        },
        neighborhoods: {
          neighborhoods: "Neighborhoods",
          neighborhood: "Neighborhood",
          new_neighborhood: "New neighborhood",
          search_neighborhoods: "Search for a neighborhood",
          add_neighborhood: "Add neighborhood",
          name: "Name",
          code: "Correios code",
          city: "City",
          enable: "Enable",
          errors: {
            name: "The name is mandatory",
            city: "The city is mandatory",
          },
        },
        companies: {
          companies: "Companies",
          company: "Company",
          search_company: "Search for a company",
          add_company: "Add company",
          new_company: "New company",
          name: "Name",
          code: "Code",
          enable: "Enable",
          company_group: "Company Group",
          confirm: {
            title: "Delete company?",
            description: "This will permanently delete the company",
          },
          errors: {
            code: "The code is mandatory",
            name: "The name is mandatory",
            company_group: "The company group is mandatory",
          },
        },
        digital_certificates: {
          digital_certificates: "Digital Certificates",
          digital_certificate: "Digital Certificate",
          search_digital_certificate: "Search for a digital certificate",
          add_digital_certificate: "Add Digital Certificate",
          new_digital_certificate: "New Digital Certificate",
          type_document: "Document type",
          document: "Document",
          useCertillionLocalAgent: "Usar Certillion local",
          name: "Name",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          enable: "Enable",
          created_successfully: "Digital Certificate created successfully",
          digital_certificate_files: "Digital Certificate Files",
          yes: "Yes",
          no: "No",
          digitalCertificateFile: {
            digital_certificate_files: "Digital Certificate Files",
            digital_certificate_file: "Digital Certificate File",
            add_digital_certificate_file: "Add Digital Certificate File",
            new_digital_certificate_file: "New Digital Certificate File",
            search: "Search for a digital certificate file",
            initial_date: "Start Date",
            end_date: "End Date",
            password: "Password",
            password_caption:
              "Password generated during the creation of the digital certificate",
            file: "File",
            confirm: {
              title: "Delete digital certificate file?",
              description:
                "This will permanently delete the digital certificate file",
            },
            errors: {
              initial_date: "The start date is required",
              end_date: "The end date is required",
              password: "The password is required",
              file: "The file is required",
              date: "The end date must be later than the start date",
            },
          },
          confirm: {
            title: "Delete digital certificate?",
            description: "This will permanently delete the digital certificate",
          },
          errors: {
            name: "Name is required",
            type_document: "Document type is required",
            document: "Document is required",
            document_max_length: "Document must be at most 18 characters",
            document_cpf_length: "CPF must have 11 digits",
            document_cnpj_length: "CNPJ must have 14 digits",
          },
        },
        provinces: {
          provinces: "States",
          province: "State",
          search_province: "Search for a state",
          add_province: "Add state",
          new_province: "New state",
          name: "Name",
          code: "Code",
          enable: "Enable",
          country: "Country",
          confirm: {
            title: "Delete state?",
            description: "This will permanently delete the state",
          },
          errors: {
            code: "The code is mandatory",
            name: "The name is mandatory",
            country: "The country is mandatory",
          },
        },
        banks: {
          banks: "Banks",
          bank: "Bank",
          search_bank: "Search for a name",
          add_bank: "Add bank",
          new_bank: "New bank",
          name: "Name",
          short_name: "Short Name",
          ispb_code: "ISPB Code",
          bacen_code: "Bacen Code",
          ibge_city_code: "IBGE City Code",
          confirm: {
            title: "Delete bank?",
            description: "This will permanently delete the bank",
          },
          errors: {
            name: "The name is mandatory",
            ispb_code: "The ISPB code is mandatory",
          },
        },
        totemDevice: {
          totem_devices: "Totem Devices",
          totem_device: "Totem Device",
          new_totem_device: "New Totem Device",
          add_totem_device: "Add Totem Device",
          search: "Search for a totem device",
          name: "Name",
          code: "Code",
          observation: "Observation",
          device_password: "Device Password",
          token_4uBus: "4uBus Token",
          integration_queues: "Integration Queues",
          site_app: "Site or App",
          change_password: "Change Password",
          enable: "Enable",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete the totem device?",
            description: "This will permanently delete the totem device",
          },
          errors: {
            name: "The name is mandatory",
            device_password: "The password is mandatory",
            token_4uBus: "The 4uBus token is mandatory",
            integration_queues: "The integration queue is mandatory",
            site_app: "The site or app is mandatory",
          },
        },
        totem: {
          totems: "Totems",
          totem: "Totem",
          new_totem: "New Totem",
          add_totem: "Add Totem",
          search: "Search for a totem",
          name: "Name",
          type: "Type",
          status: "Status",
          domains: "Domains",
          domain: "Domain",
          domain_type: "Domain Type",
          add_domain: "Add Domain",
          front_config: "Theme Configuration JSON",
          my_totems: "My Totems",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete the totem?",
            description: "This will permanently delete the totem",
          },
          errors: {
            name: "The name is mandatory",
            type: "The type is mandatory",
            status_type: "The status is mandatory",
            domain_type: "The domain type is mandatory",
            front_config: "The theme configuration JSON is mandatory",
            description: "The description is mandatory",
            file: "The file is mandatory",
            domain: "The domain is mandatory",
            domains: "At least one domain is mandatory",
          },
        },
        applications: {
          applications: "Applications",
          application: "Application",
          new_application: "New application",
          add_application: "Add Application",
          search: "Search for a application",
          name: "Name",
          type: "Type",
          app_link: "Enter the app link in the store",
          status: "Status",
          domains: "Domains",
          domain: "Domain",
          domain_type: "Domain type",
          add_domain: "Add domain",
          front_config: "Theme configuration JSON",
          chat_ticket_service: "4uChat Ticket Service",
          full_screen_mode: "Full screen mode",
          chat_profile: "4uChat Profile",
          chat_title: "Title",
          chat_subtitle: "Subtitle",
          chat_bot_name: "Bot name",
          chat_width: "Chat width (px)",
          chat_height: "Chat height (px)",
          chat_primary_color: "Primary color",
          chat_secondary_color: "Secondary color",
          chat_logo: "4uChat logo",
          chat_bot_avatar: "Bot avatar",
          chat_file_empty: "No file",
          chat_file_select: "Select",
          chat_file_change: "Change",
          chat_file_invalid:
            "Invalid file: use .jpg, .jpeg, .png or .webp up to 2 MB",
          chat_file_error: "Could not upload the file",
          chat_preview_message: "Hello! How can I help?",
          chat_preview_hint:
            "Illustrative preview only: chat header (logo, title and subtitle) and bot message.",
          chat_embed_code: "Code for your website",
          chat_embed_code_hint:
            "Paste this code before the closing </body> tag of the website. The script address changes according to the environment.",
          chat_embed_copy: "Copy code",
          chat_embed_update_hint:
            "4uChat profile changed: after saving, update the code on your website to apply the settings.",
          confirm: {
            title: "Delete application?",
            description: "This will permanently delete the application",
          },
          errors: {
            name: "The name is mandatory",
            type: "The type is mandatory",
            status_type: "The status is mandatory",
            domain_type: "The domain type is mandatory",
            front_config: "The theme configuration JSON is mandatory",
            description: "The description is mandatory",
            file: "The file is mandatory",
            domain: "The domain is mandatory",
            domains: "At least one domain is mandatory",
            chat_width: "The chat width must be between 320 and 800 px",
            chat_height: "The chat height must be between 360 and 900 px",
            chat_color: "The color must be hexadecimal (#RGB or #RRGGBB)",
          },
        },
        banners: {
          banners: "Banners",
          banner: "Banner",
          new_banner: "New banner",
          search: "Search for a banner",
          add_banner: "Add banner",
          name: "Name",
          title: "Title",
          alternative_text: "Alternative text",
          display_order: "Display order",
          language: "Language",
          site_apps: "Sites or Apps",
          banner_locals: "Locations where the banner will be displayed",
          active: "Active",
          inactive: "Inactive",
          enable: "Enable",
          status: "Status",
          media_file: "Media file",
          media_file_mobile: "Mobile Media File",
          application: "Application",
          banner_local: "Banner display location",
          targetingLink: "Redirect link",
          confirm: {
            title: "Delete banner?",
            description: "This will permanently delete the banner",
          },
          errors: {
            name: "The name is mandatory",
            targetingLink: "The link is invalid",
            title: "The title is mandatory",
            alternative_text: "The alternative text is mandatory",
            display_order: "The display order is mandatory",
            language: "The language is mandatory",
            site_apps: "At least one site or app is mandatory",
            banner_locals: "At least one location is mandatory",
            file: "The file is mandatory",
            display_order_negative: "Display order cannot be less than 0",
          },
          recommendedSize:
            "Recommended dimensions for desktop {{desktopWidth}}x{{desktopHeight}} pixels. Dimensions recommended for application/mobile {{appWidth}}x{{appHeight}} pixels.",
          freeSize: "Free size",
        },
        faq: {
          faqs: "FAQ areas",
          faq: "FAQ area",
          new_faq: "New FAQ area",
          add_faq: "Add FAQ area",
          search: "Search for a FAQ area",
          question_answer: "Questions and answers",
          active: "Active",
          inactive: "Inactive",
          status: "Status",
          name: "Name",
          enable: "Enable",
          whatsapp_phone_number: "Whatsapp phone number",
          mail: "Email",
          site_app: "Sites or Apps",
          questions_answers: "Questions and Answers",
          display_order: "Display order",
          confirm: {
            title: "Delete the FAQ?",
            description: "This will permanently delete the FAQ",
          },
          errors: {
            name: "The name is mandatory",
            site_app: "At least on site or app is mandatory",
            phone_email: "The whatsapp phone number or email is mandatory",
            mail: "Provide a valid email",
            display_order: "The display order is mandatory",
          },
        },
        questionsAnswers: {
          questions_answers: "Questions and Answers",
          question_answer: "Question and Answer",
          search: "Search by a question and answer",
          add_questions_answers: "Add a question and answer",
          new_question_answer: "New question and answer",
          display_order: "Display order",
          language: "Language",
          question: "Question",
          answer: "Answer",
          enable: "Enable",
          name: "Name",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          was_useful_count: "'Was useful' count",
          confirm: {
            title: "Delete the question and answer",
            description: "This will permanently delete the question and answer",
          },
          errors: {
            display_order: "The display order is mandatory",
            question: "The question is mandatory",
            answer: "The answer is mandatory",
            language: "The language is mandatory",
          },
        },
        news: {
          all_news: "News",
          news: "News",
          search: "Search for news",
          add_news: "Add news",
          new_news: "New news",
        },
        notifications: {
          notifications: "Notifications",
          notification: "Notification",
          add_notification: "Add notification",
          new_notification: "New notification",
          search: "Search for a notification",
          type: "Notification type",
          status: "Notification status",
          start_date: "Start date",
          end_date: "End date",
          title: "Title",
          content: "Content",
          site_app: "Sites or Apps",
          language: "Language",
          language_tooltip: "View language",
          contents: "Notification batch contents",
          add_new_content: "Add content",
          filters: "Notification batch filters",
          add_new_filter: "Add filter",
          minimum_age: "Minimum age",
          maximum_age: "Maximum age",
          payer: "Payer",
          holder: "Holder",
          both: "Both",
          is_payer: "Is payer",
          is_not_payer: "Is not payer",
          is_holder: "Is holder",
          is_not_holder: "Is not holder",
          profiles: "Profiles",
          gender: "Gender",
          users: "Users",
          start_publish: "Start of publication",
          finish_publish: "End of publication",
          registered: "Registered",
          generating: "Generating",
          generated: "Generated",
          canceled: "Canceled",
          error: "Error generating",
          push_notification: "Generate PushNotification",
          enable: "Enable",
          rule_codes: "Rule codes",
          rule_codes_helper: "Enter rule codes separated by commas",
          date_start_rule: "Rule start date",
          content_info: "You can add the variables: {{variables}}",
          active_status: "Status",
          active: "Active",
          inactive: "Inactive",
          cleanFilters: {
            title: "Do you really want to change the notification type?",
            description:
              "When changing the notification type, all filters will be removed",
            confirm: "Yes, change",
            cancel: "Cancel",
          },
          confirm: {
            title: "Delete notification?",
            description: "This will permanently delete the notification",
          },
          errors: {
            type: "The notification type is mandatory",
            site_app: "At least one site or app is mandatory",
            contents: "At least one content is mandatory",
            language: "The language is mandatory",
            title: "The title is mandatory",
            content: "The content is mandatory",
            notification_batch_filter:
              "If the 'Payer' and 'Holder' fields have the value 'Both', at least one of the fields below is mandatory",
            variables:
              "A variable that does not exist in the list was added to one of the contents",
            rule_codes: "The rule codes are mandatory",
            date_start_rule: "The rule start date is mandatory",
          },
        },
        notifiedUsers: {
          notified_users: "Notified Users",
          search: "Search for a user",
          user: "User",
          read_date: "Read date",
          acceptance_date: "Acceptance date",
          acceptance_data: "Acceptance data",
        },
        extensions: {
          extensions: "Extensions",
          search_name: "Search for a name",
          extension: "Extension",
          new_extension: "New extension",
          presentation_order: "Presentation order",
          software: "Software",
          name: "Name",
          title: "Title",
          description: "Description",
          tags: "Tags",
          files: "Files",
          file: "File",
          media_files: "Media files",
          add_media_file: "Add file",
          media_type_code: "Media type",
          extension_dependencies: "Has dependency on extensions",
          extension_targets: "Available for application types",
          enable: "Enable",
          is_required_setup: "Requires setup for installation",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          actions: {
            default_settings: "Default settings",
            price_rules: "Price rules",
          },
          defaultSettings: {
            default_settings: "Default settings for: {{extension}}",
            default_setting: "Default setting",
            identifier: "Identifier",
            property: "Property",
            value: "Value",
            description: "Description",
            search_identifier: "Search for identifier",
            add_default_setting: "Add default setting",
            new_default_setting: "New default setting",
            is_public: "The default extension setting is public",
            errors: {
              identifier: "The identifier is mandatory",
              value: "The value is mandatory",
              property: "The property is mandatory",
              description: "The description is mandatory",
            },
            confirm: {
              title: "Delete price default configuration?",
              description:
                "This will permanently delete the default configuration",
            },
          },
          priceRules: {
            price_rules: "Price rules for: {{extension}}",
            price_rule: "Price rule",
            search_type: "Search for a type",
            add_price_rule: "Add Price Rule",
            type: "Type",
            initial_date: "Start of term",
            end_date: "End of validity",
            value: "Value",
            errors: {
              type: "The type is mandatory",
              initial_date: "The start of term is mandatory",
              end_date: "The end of validity is mandatory",
              value: "The value is mandatory",
            },
            confirm: {
              title: "Delete price rule?",
              description: "This will permanently delete the price rule",
            },
          },
          errors: {
            display_order: "The presentation order is mandatory",
            software: "The software is mandatory",
            name: "The name is mandatory",
            title: "The title is mandatory",
            tags: "At least one tag is mandatory",
            file: "The file is mandatory",
            file_type:
              "Only .jpg, .jpeg, .png and .webp are file types supported",
            file_size: "The allowed maximum size is 5MB",
            extension_targets: "At least one application is mandatory",
          },
        },
        cardsTemplates: {
          cards_templates: "Cards Templates",
          card_template: "Card Template",
          search: "Search for a template",
          new_card_template: "New Card Template",
          add_card_template: "Add Card Template",
          initial_date: "Start of term",
          end_date: "End of term",
          health_plan: "Health plan",
          enable: "Enable",
          establishment_param_type: "Forward establishment parameter type",
          establishment_param_type_back:
            "Establishment parameter type for back",
          confirm: {
            title: "Delete card template?",
            description: "This will permanently delete the card template",
          },
          errors: {
            initial_date: "The start of term is mandatory",
            end_date: "The end of term is mandatory",
            health_plan: "The health plan is mandatory",
            establishment_param_type:
              "The forward establishment parameter type is mandatory",
            establishment_param_type_back:
              "The establishment parameter type for back is mandatory",
          },
        },
        companyGroups: {
          company_groups: "Company Groups",
          company_group: "Company Group",
          new_company_group: "New company group",
          search_company_groups: "Search for a company group",
          add_company_group: "Add company group",
          name: "Name",
          code: "Code",
          is_main: "Main",
          enable: "Enable",
          filter_restriction_type: "Filter Restriction Type",
          confirm: {
            title: "Delete company group?",
            description: "This will permanently delete the company group",
          },
          errors: {
            name: "The name is mandatory",
            code: "The code is mandatory",
            filter_restriction_type: "The filter restriction type is mandatory",
          },
        },
        paramDefaultEstablishment: {
          param_default_establishment: "Standard establishment parameters",
          param_default: "Standard establishment parameter",
          new_param_default: "New establishment default parameter",
          search_param: "Search for a parameter",
          add_param: "Add default parameter",
          establishment_param_type: "Establishment parameter type",
          value: "Value",
          description: "Description",
          confirm: {
            title: "Delete standard establishment parameter",
            description:
              "This will permanently delete the standard establishment parameter",
          },
          errors: {
            param_type: "The establishment parameter type is mandatory",
            value: "The value is mandatory",
            description: "The description is mandatory",
          },
        },
        holidays: {
          holidays: "Holidays",
          holiday: "Holiday",
          new_holiday: "New holiday",
          search_holiday: "Search for a holiday",
          add_holiday: "Add holiday",
          name: "Name",
          description: "Description",
          holiday_type: "Holiday type",
          date: "Date",
          import_holidays: "Import national holidays",
          filter: "Filter",
          confirm: {
            title: "Delete holiday",
            description: "This will permanently delete the holiday",
          },
          errors: {
            name: "The name is mandatory",
            description: "The description is mandatory",
            holiday_type: "The holiday type is mandatory",
            date: "The date is mandatory",
          },
        },
        individualValidation: {
          individual_validations: "Registration Validation PF",
          search: "Search for a registration",
          individual: "Individual",
          name: "Name",
          document: "CPF",
          status: "Status",
          all: "All",
          approved: "Approved",
          disapproved: "Disapproved",
          pending: "Pending Approval",
          created: "Date created",
          photos_sent: "Photos Sent",
          approve_registrations: "Registration Approval",
          not_found: "Oops, registration not found!",
          no_registrations:
            "There are no more registrations to be validated, please try again later.",
          birth_date: "Birthdate",
          email: "Email",
          whatsapp_number: "WhatsApp number",
          approved_by: "Aproved by",
          approved_at: "Aproved at",
          disapproved_by: "Disapproved by",
          disapproved_at: "Disapproved at",
          copy: "Copy",
          copied_successfully: "Copied successfully",
          actions: {
            approved: "Registration approved successfully!",
            disapproved: "Registration disapproved successfully!",
            disapprove_modal: {
              title: "Do you really want to disapprove the registration?",
              description: "This will permanently disapprove the registration.",
              cancel: "Cancel",
              confirm: "Yes, disapprove",
            },
            disapprove: "Disapprove",
            approve: "Approve",
          },
          photo_item: {
            person: "Person",
            front_doc: "Front Document",
            back_doc: "Document Back",
            person_doc: "Person with the Document",
            error: "Oops, there was an error loading the photo!",
          },
        },
      },
      additionalSettings: {
        additionalSettings: "Additional settings",
        search: "Search for a setting",
      },
      extensionsStore: {
        title: "Explore the maximum potential of your plan",
        subtitle:
          "Check out the extensions available for your plan and get an even more complete solution for your business.",
        no_data: "No extensions found!",
        no_data_install:
          "Check your already installed extensions. There are no new extensions to display.",
        no_data_installed:
          "Check what's available in store. There are no extensions installed to display.",
        installed_successfully: "Extension installed successfully",
      },
      noAccess: {
        message:
          "Oops! It looks like you don't have permission to access this page!",
        button: "Back to home",
      },
      user_menu: {
        preferences: "Preferences",
        theme: "Theme",
        theme_description: "Switch between light and dark theme",
        language: "Language",
        language_description: "Select the system language",
        establishment: "Establishment",
        establishment_description:
          "Set the default establishment when logging into the system",
        notifications: "Enable sound and browser notifications",
        notifications_description:
          "Get a sound alert and a browser notification",
        notifications_blocked:
          "Notifications are blocked in your browser settings",
      },
      settings: {
        settings: "Settings",
        general: "General",
        cache: "Cache",
        "4uBus": {
          configs: {
            configs: "General settings",
            config: "General setting",
            new_config: "New general setting",
            search: "Search for a general setting",
            add_config: "Add general setting",
            host_4ubus: "4uBus host",
            host_aws: "AWS host",
            host_postgres_api: "Postgres API host",
            establishment: "Establishment",
            confirm: {
              title: "Delete general setting?",
              description: "This will permanently delete the general setting",
            },
            errors: {
              host_4ubus: "The 4uBus host is mandatory",
              host_aws: "The AWS host is mandatory",
              host_4ubus_https:
                "The 4uBus host must starts with 'http://' or 'https://'",
              host_aws_https:
                "The AWS host must starts with 'http://' or 'https://'",
              host_postgres_api_https:
                "The Postgres API host must starts with 'http://' or 'https://'",
            },
          },
          ipm: {
            generalSettings: {
              general_settings: "IPM general settings",
              general_setting: "IPM general setting",
              new_general_setting: "New IPM general setting",
              search: "Search for a general setting",
              add_general_setting: "Add general setting",
              host: "Host",
              hostAuth: "Host authorization",
              establishment: "Establishment",
              ipm_user: "IPM user",
              ipm_password: "IPM password",
              token_4ubus: "4uBus token",
              token_copy: "Copy token",
              token_copied: "4uBus token copied successfully",
              itens_per_batch: "Itens per batch",
              total_batches: "Total batches",
              ipm_version: "IPM version",
              heart_beat_time_minutes: "Batch verification time in minutes",
              establishment_codes:
                "Code of sending establishments (separated by comma)",
              confirm: {
                title: "Delete general setting?",
                description: "This will permanently delete the general setting",
              },
              errors: {
                host: "The host is mandatory",
                ipm_user: "The IPM user is mandatory",
                ipm_password: "The IPM password is mandatory",
                token_4ubus: "The 4uBus token is mandatory",
                host_https: "The host must starts with 'http://' or 'https://'",
                itens_per_batch: "The itens per batch are mandatories",
                total_batches: "The total batches is mandatory",
                heart_beat_time_minutes:
                  "The batch verification time in minutes is mandatory",
                establishment_codes:
                  "The code of sending establishments is mandatory",
                ipm_version: "The IPM version is mandatory",
              },
            },
          },
          zScan: {
            examSendRule: {
              exam_send_rules: "Exam send rules",
              exam_send_rule: "Exam send rule",
              add_exam_send_rule: "Add exam send rule",
              new_exam_send_rule: "New exam send rule",
              target_machine: "Target machine",
              proc_classification_integration_id: "Procedure Classification Id",
              initial_date: "Initial date",
              end_date: "End date",
              enable: "Enable",
              status: "Status",
              active: "Active",
              inactive: "Inactive",
              errors: {
                target_machine: "The target machine is mandatory",
                proc_classification_integration_id:
                  "The procedure classification id is mandatory",
                initial_date: "The initial date is mandatory",
                end_date: "The end date is mandatory",
                initial_date_bigger:
                  "The initial date cannot be bigger than end",
              },
              confirm: {
                title: "Delete exam send rule?",
                description: "This will permanently delete the exam send rule",
              },
            },
          },
          externalExamPrescription: {
            rules: {
              rules: "External Exam Prescription Rules",
              rule: "External Exam Prescription Rule",
              new_rule: "New external exam prescription rule",
              add_rule: "Add external exam prescription rule",
              search: "Search for an external exam prescription rule",
              medical_procedure_type_code: "Medical Procedure Type Code",
              sector_code: "Sector Code",
              exec_physician_code: "Executing Physician Code",
              patient_insurance_code: "Patient Insurance Code",
              initial_date: "Initial Date",
              end_date: "End Date",
              is_exception: "Is Exception",
              yes: "Yes",
              no: "No",
              if: "If",
              then: "Then",
              exception: "Exception (Does not generate prescription)",
              errors: {
                initial_date: "The initial date is mandatory",
                end_date: "The end date is mandatory",
                initial_date_bigger:
                  "The initial date cannot be bigger than end",
                medical_procedure_type_code:
                  "The medical procedure type code is mandatory",
                sector_code: "The sector code is mandatory",
                execPhysicianCode: "The executing physician code is mandatory",
                max_medical_procedure_type_code:
                  "The medical procedure type code cannot be longer than 3 characters",
                max_sector_code:
                  "The sector code cannot be longer than 5 characters",
                max_exec_physician_code:
                  "The performing physician code cannot be longer than 10 characters",
                max_patient_insurance_code:
                  "The patient's health insurance code cannot be longer than 5 characters",
              },
              confirm: {
                title: "Delete external exam prescription rule?",
                description:
                  "This will permanently delete the external exam prescription rule",
              },
            },
          },
        },
        crm: {
          ticketAutoFinishRules: {
            ticket_auto_finish_rules: "Ticket (Card) Finalization Rules",
            ticket_auto_finish_rule: "Ticket (Card) Finalization Rule",
            add_ticket_auto_finish_rule: "Add ticket (card) finalization rule",
            new_ticket_auto_finish_rule: "New ticket (card) finalization rule",
            search: "Search for a ticket (card) finalization rule",
            message: "Message",
            minutes: "Minutes",
            initial_date: "Initial date1",
            end_date: "End date",
            finish_type: "Finish Type",
            finish_by_time: "By Time",
            finish_end_of_day: "At the End of the Day",
            finish_not_selected: "Not Selected",
            enable: "Active",
            active: "Yes",
            inactive: "No",
            finish_rule: "Finish",
            finish: "Finished",
            end_of_day: "Finish at the end of the day (00:00)",
            finish_indifferent_person:
              "Finish indifferent to the person in the interaction",
            ticket_type: "Ticket (card) type",
            ticket_channel: "Board",
            ticket_channel_step: "Board list",
            ticket_workspace: "Workspace",
            move_finished_to: "Move finished to",
            ticket_channel_step_transfer: "Move finished to list",
            message_helper:
              "The variable {{protocolNumber}} will be replaced by the protocol number assigned to the ticket (card)",
            confirm: {
              title: "Delete ticket (card) finalization rule?",
              description:
                "This will permanently delete the ticket (card) finalization rule",
            },
            errors: {
              minutes: "The minutes are mandatories",
              max_minutes: "The value could not be bigger than 1440",
              ticket_type: "The ticket (card) type is mandatory",
              ticket_channel: "The board is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              end_date_less:
                "The end date cannot be less than the initial date",
              message: "The message is mandatory",
              ticket_workspace: "The workspace is mandatory",
              ticket_channel_step: "The board list is mandatory",
            },
          },
          ticketAutoTransferRules: {
            ticket_auto_transfer_rules: "Ticket(Card) Transfer Rules",
            ticket_auto_transfer_rule: "Ticket(Card) Transfer Rule",
            add_ticket_auto_transfer_rule: "Add Ticket(Card) Transfer Rule",
            new_ticket_auto_transfer_rule: "New Ticket(Card) Transfer Rule",
            search: "Search for a Ticket(Card) Transfer Rule",
            message: "Message",
            minutes: "Minutes",
            initial_date: "Start Date",
            end_date: "End Date",
            transfer_indifferent_person:
              "Transfer indifferent to the person in the interaction",
            transfer: "Transfer",
            transfer_type: "Transfer Type",
            transfer_by_time: "By Time",
            transfer_end_of_day: "At the End of the Day",
            transfer_not_selected: "Not Selected",
            enable: "Active",
            active: "Yes",
            inactive: "No",
            end_of_day: "Transfer at the end of the day (00:00)",
            transfer_to: "Transfer to",
            transfering: "Transferring",
            ticket_type: "Ticket(Card) Type",
            ticket_channel: "Board",
            ticket_channel_step: "Board List",
            ticket_channel_transfer: "Transfer to board",
            ticket_channel_step_transfer: "Transfer to list",
            ticket_workspace: "Workspace",
            ticket_service: "Ticket Service",
            ticket_service_area: "Service Area",
            ticket_auto_transfer_rule_hour_atend: "Service Time Type",
            message_helper:
              "The variable {{protocolNumber}} will be replaced with the protocol number assigned to the ticket(card)",
            confirm: {
              title: "Delete Ticket(Card) Transfer Rule?",
              description:
                "This will permanently delete the Ticket(Card) Transfer Rule",
            },
            errors: {
              minutes: "Minutes are required",
              max_minutes: "The value cannot be greater than 1440",
              ticket_type: "Ticket(Card) type is required",
              ticket_channel: "Board is required",
              initial_date: "Start date is required",
              end_date: "End date is required",
              end_date_less: "End date cannot be earlier than start date",
              message: "Message is required",
              ticket_workspace: "Workspace is required",
              ticket_channel_step: "Board list is required",
              ticket_channel_step_transfer:
                "Board list for transfer is required",
              ticket_service: "Ticket service is required",
              ticket_auto_transfer_rule_hour_atend:
                "Service time type is required",
            },
          },
          sendLimitMonths: {
            send_limits_months: "Monthly Sending Limits (Company Budget)",
            send_limit_months: "Monthly Sending Limit (Company Budget)",
            search: "Search for a monthly sending limit",
            add_send_limit_months: "Add monthly sending limit",
            new_send_limit_months: "New monthly sending limit",
            active: "Active",
            enabled: "Yes",
            disabled: "No",
            enable: "Enable",
            name: "Name",
            ticket_service: "Ticket (Card) Service",
            start_date: "Start Date",
            end_date: "End Date",
            quantity: "Quantity",
            alert_percent_limit: "Alert Percentage",
            alert_mail: "Alert emails (use ; to separate multiple emails)",
            description: "Description",
            confirm: {
              title: "Delete monthly sending limit?",
              description:
                "This will permanently delete the monthly sending limit",
            },
            errors: {
              name: "Name is required",
              ticket_service: "Ticket service is required",
              start_date: "Start date is required",
              end_date: "End date is required",
              end_date_less: "End date cannot be earlier than the start date",
              value_limit: "Limit quantity is required",
              alert_mail: "At least one email is required",
              alert_percent_limit: "Alert percentage must be between 0 and 100",
            },
          },
          sendLimitDiaries: {
            send_limits_diaries: "Daily Sending Limits (Company Budget)",
            send_limit_diaries: "Daily Sending Limit (Company Budget)",
            search: "Search for a daily sending limit",
            add_send_limit_diaries: "Add daily sending limit",
            new_send_limit_diaries: "New daily sending limit",
            active: "Active",
            enabled: "Yes",
            disabled: "No",
            enable: "Enable",
            name: "Name",
            ticket_service: "Ticket (Card) Service",
            start_date: "Start Date",
            end_date: "End Date",
            automation: "Automation (Optional)",
            quantity: "Quantity",
            alert_mail: "Alert emails (use ; to separate multiple emails)",
            description: "Description",
            confirm: {
              title: "Delete daily sending limit?",
              description:
                "This will permanently delete the daily sending limit",
            },
            errors: {
              name: "Name is required",
              ticket_service: "Ticket service is required",
              start_date: "Start date is required",
              end_date: "End date is required",
              end_date_less: "End date cannot be earlier than the start date",
              value_limit: "Limit quantity is required",
              alert_mail: "At least one email is required",
            },
          },
          protocolsDefault: {
            protocols_default: "Standard Guidance Protocols",
            protocol_default: "Standard Guidance Protocol",
            ticket_automation: "Automations",
            button_type: "Button Type",
            add: "Add Button",
            button_title: "Buttons",
            label: "Label",
            value: "Value",
            link: "Link",
            counter_hint: "Current quantity / maximum allowed",
            new_protocol_default: "New standard guidance protocol",
            add_protocol_default: "Add standard guidance protocol",
            search: "Search for a standard guidance protocol",
            title: "Title",
            message: "Message",
            restriction_type: "Restriction type",
            category: "Category",
            workspace: "Workspace",
            workspaces: "Workspaces",
            restriction_type_board: "Board",
            channel: "Channel",
            channels: "Channels",
            file: "File",
            description: "Description",
            media_files: "Media files",
            add_media_file: "Add file",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            buttons_no_integligence_warning:
              "These buttons have no intelligence or automatic action from the 4uHub platform. Their use is entirely the user's responsibility and risk.",
            confirm: {
              title: "Delete standard guidance protocol?",
              description:
                "This will permanently delete the standard guidance protocol",
            },
            errors: {
              title: "The title is mandatory",
              message: "The message is mandatory",
              restriction_type: "The restriction type is mandatory",
              category: "The category is mandatory",
              workspaces: "At least one workspace is mandatory",
              channels: "At least one channel is mandatory",
              description: "The description is mandatory",
              file: "The file is mandatory",
              media_files: "At least one file is mandatory",
              min_description: "The description is mandatory",
              max_description:
                "The description cannot be longer than 1000 characters",
              value: "The value is mandatory",
              label: "The label is mandatory",
              button_link_required:
                "The button must contain a valid link (http or https)",
            },
          },
          ticketDefaultDocCategories: {
            ticket_default_doc_categories:
              "Standard Guidance Protocol Categories",
            ticket_default_doc_category: "Standard Guidance Protocol Category",
            new_ticket_default_doc_category:
              "New standard guidance protocol category",
            add_ticket_default_doc_category:
              "Add standard guidance protocol category",
            search: "Search for a standard guidance protocol category",
            code: "Code",
            name: "Name",
            confirm: {
              title: "Delete standard guidance protocol category?",
              description:
                "This will permanently delete the standard guidance protocol category",
            },
            errors: {
              name: "The name is mandatory",
            },
          },
          events: {
            events: "Events",
            event: "Event",
            new_event: "New event",
            add_event: "Add event",
            search: "Search for an event",
            name: "Name",
            event_type: "Event type",
            code: "Code",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            manage_event_types: "Manage event types",
            ticket_automations: "Automations",
            confirm: {
              title: "Delete event?",
              description: "This will permanently delete the event",
            },
            errors: {
              name: "The name is mandatory",
              event_type: "The event type is mandatory",
              code: "The code is mandatory",
            },
          },
          eventTypes: {
            event_types: "Event Types",
            event_type: "Event Type",
            new_event_type: "New event type",
            add_event_type: "Add event type",
            search: "Search for an event type",
            name: "Name",
            enable: "Enable",
            code: "Code",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete event type?",
              description: "This will permanently delete the event type",
            },
            errors: {
              name: "The name is mandatory",
            },
          },
          externalProcessType: {
            external_process_types: "Types of External Processes",
            external_process_type: "External Process Type",
            add_external_process_type: "Add external process type",
            new_external_process_type: "New external process type",
            search: "Search for an external process type",
            name: "Name",
            confirm: {
              title: "Delete external process type?",
              description:
                "This will permanently delete the external process type",
            },
            errors: {
              name: "The name is mandatory",
            },
          },
          ticketAutoInactivityRules: {
            ticket_auto_inactivity_rules: "Ticket(Card) Inactivity Rules",
            ticket_auto_inactivity_rule: "Ticket(Card) Inactivity Rule",
            add_ticket_auto_inactivity_rule: "Add Ticket(Card) Inactivity Rule",
            new_ticket_auto_inactivity_rule: "New Ticket(Card) Inactivity Rule",
            search: "Search for a Ticket(Card) Inactivity Rule",
            ticket_channel: "Board",
            ticket_channel_step: "Board List",
            minutes: "Minutes",
            initial_date: "Start Date",
            end_date: "End Date",
            ticket_type: "Ticket(Card) Type",
            ticket_workspace: "Workspace",
            message: "Message",
            confirm: {
              title: "Delete Ticket(Card) Inactivity Rule?",
              description:
                "This will permanently delete the Ticket(Card) Inactivity Rule",
            },
            errors: {
              minutes: "Minimum required value is 5 minutes",
              max_minutes: "The value cannot be greater than 1440",
              ticket_type: "Ticket(Card) type is required",
              ticket_channel: "Board is required",
              initial_date: "Start date is required",
              end_date: "End date is required",
              end_date_less: "End date cannot be earlier than start date",
              ticket_workspace: "Workspace is required",
            },
          },
        },
        preventMedicine: {
          workGroupTypes: {
            work_group_types: "Work Group Types",
            work_group_type: "Work Group Type",
            new_work_group_type: "New work group type",
            add_work_group_type: "Add work group type",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            languages: "Languages",
            language: "Language",
            add_language: "Add language",
            name: "Name",
            description: "Description",
            search: "Search by a work group type",
            confirm: {
              title: "Delete work group type?",
              description: "This will permanently delete the work group type",
            },
            errors: {
              name: "The name is mandatory",
              language: "The language is mandatory",
            },
          },
          healthProgramTypes: {
            health_program_types: "Health Program Types",
            health_program_type: "Health Program Type",
            new_health_program_type: "New health program type",
            add_health_program_type: "Add Health Program Type",
            search: "Search for a health program type",
            name: "Name",
            language: "Language",
            description: "Description",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            characters: "characters",
            add_language: "Add language",
            confirm: {
              title: "Delete health program type?",
              description:
                "This will permanently delete the health program type",
            },
            errors: {
              name: "The name is mandatory",
              description: "Description cannot be longer than 500 characters",
            },
          },
        },
        generalSettings: {
          healthChecks: {
            health_checks: "4uHub Microservices Health Checks",
            health_check: "4uHub Microservices Health Check",
            new_health_check: "New 4uHub microservices health check",
            add_health_check: "Add 4uHub Microservices Health Check",
            search: "Search for a 4uHub microservices health check",
            name: "Name",
            uri: "URI",
            establishment: "Establishment",
            payload: "Failure payload",
            restored_payload: "Restore payload",
            webhook_url: "Webhook URL",
            enable: "Permitir",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete health check?",
              description: "This will permanently delete the health check",
            },
            errors: {
              name: "The name is mandatory",
              uri: "The URI is mandatory",
              payload: "The failure payload is mandatory",
              restored_payload: "The restore payload is mandatory",
              webhook_url: "The webhook url is mandatory",
              webhook_url_http:
                "The webhook url must starts with 'http://' or 'https://'",
              establishment: "The establishment is mandatory",
            },
          },
        },
        schedule: {
          scheduleCheckIn: {
            schedule_check_in: "Check In",
            add_schedule_check_in: "Add check in",
            new_schedule_check_in: "New check in",
            meters_approximation: "Approximation in meters",
            time: "Time in minutes",
            meters: "m.",
            min: "min.",
            latitude: "Latitude",
            longitude: "Longitude",
            help_time:
              "Enter the time in minutes before the appointment, when it will be possible to check in for an appointment",
            help_meters:
              "Please inform the approximate distance in meters before the appointment, and you will be able to check in for an appointment",
            confirm: {
              title: "Delete check in?",
              description: "This will permanently delete the check in",
            },
            errors: {
              meters_approximation: "The approximation in meters is mandatory",
              time: "The time in minutes is mandatory",
              latitude: "The latitude is mandatory",
              longitude: "The longitude is mandatory",
            },
          },
          scheduleFilterUser: {
            schedule_filter_user: "User schedule filter",
            add_schedule_filter_user: "Add user schedule filter",
            new_schedule_filter_user: "New user schedule filter",
            user: "User",
            scheduleFilterUserCalendars: "Calendars",
            confirm: {
              title: "Delete user schedule filter?",
              description:
                "This will permanently delete the user schedule filter",
            },
            errors: {
              user: "User is required",
              schedule: "Calendars are required",
            },
          },
          scheduleConfirmation: {
            schedule_confirmation: "Schedule Confirmation",
            add_schedule_confirmation: "Add schedule confirmation",
            new_schedule_confirmation: "New schedule confirmation",
            time: "Time in minutes",
            min: "min.",
            help: "Enter the time in minutes before the appointment, which will allow you to confirm an appointment",
            confirm: {
              title: "Delete schedule confirmation?",
              description:
                "This will permanently delete the schedule confirmation",
            },
            errors: {
              time: "The time in minutes is mandatory",
            },
          },
          tasySchedMenu: {
            menu_scheduling_portal_app: "Portal and App Scheduling Menu",
            add_menu_scheduling_portal_app:
              "Add portal and app scheduling menu",
            new_menu_scheduling_portal_app:
              "New portal and app scheduling menu",
            name: "Name",
            custom_message: "Custom message",
            display_order: "Display order",
            ticket_automation_received_rule: "Automation received rule",
            search: "Search for a portal and app scheduling menu",
            confirm: {
              title: "Delete portal and app scheduling menu?",
              description:
                "This will permanently delete the portal and app scheduling menu",
            },
            errors: {
              name: "The name is mandatory",
              display_order: "The display order is mandatory",
              rule_or_custom_message:
                "Enter an automation received rule or a custom message",
              custom_message_with_rule:
                "The custom message can only be filled when no received rule is selected",
              ticket_automation_received_rule:
                "The automation received rule is mandatory",
            },
          },
        },
        system: {
          executeSql: {
            execute_sql: "Execute SQL",
            execute_successfully: "SQL executed successfully",
            clean: "Clean",
            execute: "Execute",
            errors: {
              sql: "The SQL code is mandatory",
            },
          },
        },
        siteApp: {
          siteAppCheckIn: {
            site_app_check_in: "Check-In of Digital PA Triage",
            add_site_app_check_in: "Add check in",
            new_site_app_check_in: "New check in",
            meters_approximation: "Meters approximation",
            patient_encounter_physician_code:
              "Physician code for the patient's encounter",
            sector_accommodation_type: "Sector accommodation type",
            patient_encounter_origin_code:
              "Origin code of the patient's encounter",
            patient_encounter_type_code: "Type code of the patient's encounter",
            time: "Time in minutes",
            meters: "m.",
            min: "min.",
            latitude: "Latitude",
            longitude: "Longitude",
            help_time:
              "Enter the time in minutes before the appointment, which will be allowed to check in for a schedule",
            help_meters:
              "Enter the meters approximation before the appointment, which will be allowed to check in for a schedule",
            standard_service_sector_code: "Standard Service Sector Code",
            standard_service_unit: "Standard Service Unit",
            insurance_allow_checkin: "Allowed Insurances",
            confirm: {
              title: "Delete check in?",
              description: "This will permanently delete the check in",
            },
            errors: {
              meters_approximation: "Meters approximation is required",
              time: "Time in minutes is required",
              latitude: "Latitude is required",
              longitude: "Longitude is required",
              standard_service_sector_code:
                "The standard service sector code is required",
              standard_service_unit: "The standard service unit is required",
              patient_encounter_origin_code:
                "The origin code of the patient's encounter is required",
              sector_accommodation_type:
                "The sector accommodation type is required",
              patient_encounter_physician_code:
                "The physician code for the patient's encounter is required",
              patient_encounter_type_code:
                "The type code of the patient's encounter is required",
            },
          },
          siteAppConfirmation: {
            site_app_confirmation: "Schedule Confirmation",
            add_site_app_confirmation: "Add schedule confirmation",
            new_site_app_confirmation: "New schedule confirmation",
            time: "Time in minutes",
            min: "min.",
            help: "Enter the time in minutes before the appointment, which will be allowed to confirm a schedule",
            confirm: {
              title: "Delete schedule confirmation?",
              description:
                "This will permanently delete the schedule confirmation",
            },
            errors: {
              time: "Time in minutes is required",
            },
          },
        },
        quickAnswer: {
          quick_answers: "Quick Messages",
          quick_answer: "Quick Message",
          new_quick_answer: "New quick message",
          search: "Search for a quick message",
          add: "Add quick message",
          title: "Title",
          shortcut: "Shortcut",
          message: "Message",
          inactive_quick_answer: "Disable",
          share_type: "Share type",
          user: "User",
          ticket_workspace: "Workspace",
          ticket_channel: "Board",
          inactive: {
            title: "Disable quick message?",
            description: "This will permanently disable the quick message.",
            cancel: "Cancel",
            confirm: "Yes, disable",
            success: "Quick message successfully disabled",
          },
          errors: {
            title: "The title is mandatory",
            message: "The message is mandatory",
            shortcut: "The shortcut is mandatory",
            share_type: "The share type is mandatory",
            user: "The user is mandatory",
            ticket_workspace: "The workspace is mandatory",
            ticket_channel: "The board is mandatory",
          },
        },
      },
      extensionSettings: {
        extension_settings:
          "Extension settings for '{{extension}}' in '{{siteApp}}'",
        add_extension_config: "Add configuration to extension",
        extension_config: "Extension configuration",
        new_extension_config: "New extension configuration",
        search_config: "Search for a configuration",
        identifier: "Identifier",
        property: "Property",
        public: "Public",
        true: "Yes",
        false: "No",
        value: "Value",
        description: "Description",
        is_public: "Extension configuration is public",
        is_public_info:
          "This section handles application security matters. If a configuration is public, it means we can access it without authentication. Data considered confidential, such as a token, should never be marked as public",
        save_in_establishment:
          "Save settings for all merchant websites and apps",
        confirm: {
          title: "Delete extension configuration?",
          description:
            "This will permanently delete the extension's configuration",
        },
        switchEnableDisableConfig: {
          enabled: "Enabled",
          disabled: "Disabled",
        },
        enableDisableConfig: {
          enable: "Enable",
          disable: "Disable",
        },
        errors: {
          identifier: "The identifier is mandatory",
          property: "The property is mandatory",
          value: "The value is mandatory",
          description: "The description is mandatory",
        },
      },
      jobs: {
        title: "You have been redirected to the Jobs dashboard",
        subtitle: "To access again click the button below",
        button: "Access",
      },
      "4uHcp": {
        hcp: {
          healthPrograms: {
            enable: "Enable",
            active: "Active",
            inactive: "Inactive",
            health_programs: "Health Program",
            health_program: "Health Program",
            new_health_program: "New health program",
            search: "Search by a health program",
            add_health_program: "Add health program",
            languages: "Languages",
            health_program_type: "Type of health program",
            health_program_work_groups: "Work groups",
            applications: "Applications",
            work_groups: "Work groups",
            add_language: "Add language",
            name: "Name",
            language: "Language",
            description: "Description",
            participants: "Participants",
            imports: "Imports",
            fundraising: "Fundraising",
            confirm: {
              title: "Delete health program?",
              description: "This will permanently delete the health program",
            },
            errors: {
              health_program_type: "The health program type is mandatory",
              site_apps: "At least one application is mandatory",
              languages: "At least one language is mandatory",
              language: "The language is mandatory",
              name: "The name is mandatory",
            },
          },
          healthProgramsContentRules: {
            health_programs_content_rules: "Health program content rules",
            health_program_content_rule: "Health program content rule",
            new_health_program_content_rule: "New health program content rule",
            search: "Search by a health program content rule",
            add_health_program_content_rule: "Add health program content rule",
            content_view_type_hcp: "Content View Type",
            name: "Name",
            health_program: "Health program",
            initial_date: "Initial date",
            end_date: "End date",
            contents: "Rule contents",
            confirm: {
              title: "Delete health program content rule?",
              description:
                "This will permanently delete the health program content rule",
            },
            errors: {
              name: "The name is mandatory",
              health_program: "The health program is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              initial_date_greater:
                "The end date cannot be less than the initial date",
              content_view_type_hcp: "The content view type is mandatory",
            },
          },
          rulesContents: {
            rules_contents: "Rules Contents",
            rule_content: "Rule Content",
            new_rule_content: "New rule content",
            search: "Search by a rule content",
            add_rule_content: "Add rule content",
            title: "Title",
            publication_date: "Publication date",
            content_status: "Content status",
            published: "Published",
            not_published: "Not published",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete rule content?",
              description: "This will permanently delete the rule content rule",
            },
          },
          workGroups: {
            work_groups: "Work Groups",
            work_group: "Work Group",
            new_work_group: "New work group",
            add_work_group: "Add work group",
            search: "Search for a work group",
            name: "Name",
            languages: "Languages",
            add_language: "Add language",
            language: "Language",
            description: "Description",
            work_group_type: "Work group type",
            work_group_members: "Work group members",
            confirm: {
              title: "Delete work group?",
              description: "This will permanently delete the work group",
            },
            errors: {
              work_group_type: "The work group type is mandatory",
              languages: "At least one language is mandatory",
              name: "The name is mandatory",
              language: "The language is mandatory",
            },
          },
          participants: {
            participants: "Participants",
            participant: "Participant",
            new_participant: "New participant",
            add_participant: "Add participant",
            search: "Search for a participant",
            name: "Name",
            document: "CPF",
            status: "Status",
            history: "Historic",
            active: "Active",
            formerMember: "Former Member",
            membersHistory: {
              title: "Historic",
              initialDate: "entry date",
              endDate: "Exit date",
              noEndDate: "No end date",
            },
            confirm: {
              title: "Delete participant?",
              description: "This will permanently delete the participant",
            },
          },
          fundraising: {
            fundraising: "Fundraising",
            healthProgram: "Health program",
            captation: "Captation",
            add: "Add Captation",
            new_captation: "New captation",
            search: "Search for a fundraising",
            name: "Name",
            individual: "Individual",
            document: "CPF",
            health_program: "Health program",
            captation_type: "Captation type",
            captation_status: "Captation status",
            approve_captation: "Approve captation",
            approved_successfully: "Captation approved successfully",
            disapprove_captation: "Disapprove captation",
            disapproved_successfully: "Captation disapproved successfully",
            denial_reason: "Reason (optional)",
            cancel: "Cancel",
            disapprove: "Disapprove",
            confirm: {
              title: "Delete Captation?",
              description: "This will permanently delete the Captation",
            },
            errors: {
              individual: "The individual person is mandatory",
              health_program_type: "The health program type is mandatory",
              captation_status: "The captation status is mandatory",
            },
          },
          healthProgramImports: {
            imports: "Imports",
            healthProgram: "Health program",
            import: "Import",
            add_import: "Add import",
            new_import: "New import",
            search: "Search for an import",
            file_name: "File name",
            import_person_name: "Import person name",
            origin_of_demand: "Origin of demand",
            error_message: "Error message",
            status: "Status",
            download_template: "Download template",
            health_program: "Health program",
            errors: {
              file: "The file is mandatory",
              import_person_name: "The import person name is mandatory",
              health_program: "The health program is mandatory",
            },
          },
        },
      },
      "4uBus": {
        register: {
          accessTokens: {
            access_tokens: "Extern tokens",
            access_token: "Extern token",
            new_access_token: "New extern token",
            add_access_token: "Add extern token",
            search: "Search for an extern token",
            name: "Name",
            code: "Code",
            privileges: "Privileges",
            token_public: "Public token",
            copied_token: "Public token copied successfully",
            copy: "Copy public token",
            created: "Creation date",
            individual: "Individual",
            legal_entity: "Legal entity",
            software: "Software",
            justification: "Justification",
            description: "Description",
            is_integration: "Integration token",
            restriction_rule_profiles: "Restriction rule profiles",
            extension: "Extension",
            profiles: "Profiles",
            no_extensions_found:
              "It is not possible to register an Extern Token, as it does not have any Bus endpoint extensions installed.",
            confirm: {
              title: "Delete extern token?",
              description: "This will permanently delete the extern token",
            },
            errors: {
              name: "The name is mandatory",
              privileges: "At least one privilege is mandatory",
            },
          },
          profileTasyBus: {
            profile_tasy_bus: "Extern Profile",
            search: "Search for a profile extern",
            add_profile_tasy_bus: "Add profile extern",
            new_profile_tasy_bus: "New profile extern",
            name: "Name",
            extension: "Extension",
            is_global: "Global Profile",
            enable: "Enable",
            users: "Users",
            global: "Yes",
            not_global: "No",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete profile extern?",
              description:
                "This will permanently delete the profile extern, all restriction rules linked to that profile extern will be deleted and all linked users will be unlinked",
            },
            errors: {
              name: "The name is mandatory",
              extension: "The extension is mandatory",
            },
          },
          iProcesse: {
            i_processes: "Processes",
            i_processe: "Process",
            new_i_processe: "New process",
            add_i_processe: "Add process",
            search: "Search for a process",
            processe_name: "Process Name",
            description: "Description",
            code: "Code",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            confirm: {
              title: "Delete process?",
              description: "This will permanently delete the process",
            },
            errors: {
              processe_name: "The process name is required",
            },
          },
          iService: {
            certillion: {
              name: "Certillion",
              is_certillion_cloud: "Use Certillion Cloud",
              authorize_local: "Authorize locally",
              base_url: "Base URL",
              base_url_proxy: "Proxy Base URL",
              client_id: "Client ID",
              client_secret: "Client Secret",
              pscs_accounts_path: "PSCS Accounts Path",
              token_path: "Token Path",
              has_token_path: "Token Verification Path",
              upload_file_path: "File Upload Path",
              signature_path: "Signature Path",
              signature_standard_options: "Standard Signature Options (JSON)",
              signature_position_landscape: "Landscape Signature Positioning",
              signature_position_portrait: "Portrait Signature Positioning",
              signature_horizontal_x: "Position X",
              signature_horizontal_y: "Position Y",
              signature_vertical_x: "Position X",
              signature_vertical_y: "Position Y",
              errors: {
                company_digital_certificate: "Company Digital Certificate",
                method_type: "Method Type",
                cpf: "CPF",
                url: "Invalid URL",
                required_field: "Required field",
                invalid_json: "Invalid JSON",
                name: "Name",
                i_service_type: "iService Type",
              },
            },
            i_services: "Services",
            i_service: "Service",
            new_i_service: "New service",
            add_i_service: "Add service",
            search: "Search for a service",
            name: "Service Name",
            description: "Description",
            configs: "Settings",
            company_digital_certificate: "Digital Certificate",
            u_bus_user: "4uBus User",
            i_service_type: "Service Type",
            method_type: "Method Type",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            u_bus_user_external: "External 4uBus",
            bus_internal_token: "4uBus Token",
            host: "API Host",
            si_pni: "SI-PNI",
            ger_acesso: "GerAcesso - TeletexSul",
            plug_notas: "PlugNotas",
            shift_lis: "Shift LIS",
            protheus: "Protheus",
            sgu: "SGU",
            configuration_under_development:
              "The settings for this service type are still under development. This section will be available soon.",
            select_options: "Select Options",
            selected_options: "Selected Options",
            digital_certificate: "Digital Certificate",
            auth_url: "Authentication URL",
            base_url: "Base URL",
            cpf: "CPF",
            token: "Token",
            default_provider_document: "Default Provider Document",
            define: "Define",
            cancel: "Cancel",
            selected_service: "Selected Service",
            clear_options: "Clear Options",
            confirm_delete_title: "Clear Options",
            confirm_delete_message:
              "Are you sure you want to clear the selected options?",
            confirm_clear: "Confirm",
            service: "Service",
            i_service_type_error: "Select a service",
            confirm: {
              title: "Delete service?",
              description: "This will permanently delete the service",
            },
            errors: {
              name: "The service name is required",
              url: "Enter a valid link (http or https)",
              company_digital_certificate:
                "The digital certificate is required",
              bus_internal_token: "The internal 4uBus token is required",
              cpf: "CPF is required",
              method_type: "The method type is required",
              token: "The token is required",
              host: "The API Host is required",
              required_field: "Required field",
              invalid_json: "Invalid JSON",
            },
          },
          accessTokens4uhub: {
            access_tokens: "4uhub tokens",
            access_token: "4uhub token",
            new_access_token: "New 4uhub token",
            add_access_token: "Add 4uhub token",
            search: "Search for an 4uhub token",
            name: "Name",
            code: "Code",
            privileges: "Privileges",
            token_public: "Public token",
            copied_token: "Public token copied successfully",
            copy: "Copy public token",
            created: "Creation date",
            individual: "Individual",
            legal_entity: "Legal entity",
            software: "Software",
            justification: "Justification",
            description: "Description",
            is_integration: "Integration token",
            restriction_rule_profiles: "Restriction rule profiles",
            extension: "Extension",
            profiles: "Profiles",
            no_extensions_found:
              "It is not possible to register an 4uhub Token, as it does not have any Bus endpoint extensions installed.",
            confirm: {
              title: "Delete 4uhub token?",
              description: "This will permanently delete the 4uhub token",
            },
            errors: {
              name: "The name is mandatory",
              privileges: "At least one privilege is mandatory",
            },
          },
          profile4uhub: {
            profile_tasy_bus: "Profile - 4uhub bus",
            search: "Search for a profile - 4uhub bus",
            add_profile_tasy_bus: "Add profile - 4uhub bus",
            new_profile_tasy_bus: "New profile - 4uhub bus",
            name: "Name",
            extension: "Extension",
            is_global: "Global Profile",
            enable: "Enable",
            users: "Users",
            global: "Yes",
            not_global: "No",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete profile - 4uhub bus?",
              description:
                "This will permanently delete the profile - 4uhub bus, all restriction rules linked to that profile - 4uhub bus will be deleted and all linked users will be unlinked",
            },
            errors: {
              name: "The name is mandatory",
              extension: "The extension is mandatory",
            },
          },
          restrictionRules: {
            restriction_rules: "Restriction Rules",
            restriction_rule: "Restriction Rule",
            search: "Search for a restriction rule",
            add_restriction_rule: "Add restriction rule",
            new_restriction_rule: "New restriction rule",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            restriction_rule_type: "Restriction rule type",
            action_type: "Action type",
            value: "Value",
            description: "Description",
            confirm: {
              title: "Delete restriction rule?",
              description: "This will permanently delete the restriction rule",
            },
            errors: {
              restriction_rule_type: "The restriction rule type is mandatory",
              action_type: "The action type is mandatory",
              value: "The value is mandatory",
              description: "The description is mandatory",
            },
          },
        },
        relationships: {
          defaultRelationships: {
            relationship: "Relationship",
            search: "Search for a realationship",
            add_relationship: "Add relationship",
            relationship_type: "Relationship type",
            direction_type: "Type of targeting",
            origin_name: "Origin name",
            origin_value: "Origin value",
            destiny_name: "Desitny name",
            destiny_value: "Desitiny value",
            enable: "Enable",
            default: "Default",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            is_default: "Yes",
            is_not_default: "No",
            confirm: {
              title: "Delete relationship?",
              description: "This will permanently delete the relationship",
            },
            errors: {
              relationship_type: "The relationship type is mandatory",
              direction_type: "The type of targeting is mandatory",
              origin_name: "The origin name is required",
              origin_value: "The origin value is required",
              destiny_name: "The destination name is required",
              destiny_value: "The destination value is required",
              u_bus_relationship_type: "The relationship type is required",
            },
          },
          relationshipGroup: {
            relationship: "Relationship",
            add_relationship_group: "Add relationship group",
            new_relationship_group: "New relationship group",
            search: "Search for a relationship group",
            name: "Name",
            code: "Code",
            description: "Description",
            u_bus_automation: "4uBus Automation",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            created_successfully: "Relationship group successfully created",
            relationship_group_item: "4uBus Relationship Group Item",
            confirm: {
              title: "Delete relationship group?",
              description:
                "This will permanently delete the relationship group",
            },
            errors: {
              name: "The name is required",
              u_bus_automation: "The 4uBus automation is required",
            },
          },
        },
        restrictions: {
          schedule: {
            schedule: "Schedule",
            add_schedule: "Add schedule",
            search: "Search for a schedule",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            new_schedule: "New schedule",
            enable: "Enable",
            value: "Value",
            restriction_rule_type: "Restriction rule type",
            description: "Description",
            confirm: {
              title: "Delete schedule?",
              description: "This will permanently delete the schedule",
            },
            errors: {
              value: "The value is mandatory",
              restriction_rule_type: "The restriction rule type is mandatory",
              description: "The description is mandatory",
            },
          },
        },
        logs: {
          logFileIntegration: {
            file_integration: "File Integration Log",
            status: "Status",
            robot: "Robots",
            resolved: "Resolved",
            start_date: "Start date",
            end_date: "End date",
            today: "Today",
            yesterday: "Yesterday",
            message_status: "Status Message",
            created: "Date and Time",
            view_logs: "View Files",
            logs: "Files",
            solved: "Mark as Resolved",
          },
          ipmXTasy: {
            ipmxtasy: "IPM - Receive - IPM x Tasy",
            status: "Status",
            message_status: "Message status",
            created: "Created date",
            tasy_individual_identifier: "Individual cd.",
            start_date: "Start date",
            end_date: "End date",
            service_number_search: "Service number",
            service_number: "Service number (IPM)",
            service_number_tasy: "Service number (Tasy)",
            lab_exam_quantity: "Qty Exam Lab",
            exam_nlab: "Exam NLab",
            medicines: "Medicines",
            allergy: "Allergy",
            has_evolution: "Has evolution",
            evolution: "Yes",
            no_evolution: "No",
            search: "Search for status",
            view_logs: "View logs",
            logs: "Logs",
          },
          logTasyImp: {
            status: "status",
            message_status: "Status message",
            created: "Creation date",
            qtyEmrLabExamResult: "Laboratory test QTD",
            qtyEmrNonLaboratoryTests: "Laboratory test QTD",
            start_date: "Start date",
            end_date: "End date",
            qtyEvolution: "Evolution QTD",
            qtyAllergy: "Allergies QTD",
            qtyMedicineInUse: "Medicines QTD",
            ipmtasy: "IPMxTasy",
            tasyipm: "TasyxIPM",
            TasyEncounterIntegrationId: "Tasy Customer Service Number",
            TasyIndividualIntegrationId: "Personal Code Tasy",
            IpmEncounterIntegrationId: "Ipm Customer Service Number",
            IpmIndividualIntegrationId: "Personal Code Ipm",
          },
          tasyXIpm: {
            tasyxipm: "IPM - Send - Tasy x IPM",
            status: "Status",
            message_status: "Message status",
            created: "Created date",
            individual_identifier: "Individual code (Tasy)",
            start_date: "Start date",
            end_date: "End date",
            service_number_search: "Service number",
            service_number: "Service number (Tasy)",
            search: "Search for status",
            view_logs: "View logs",
            logs: "Logs",
            allergies: "Allergies",
            occurrences: "Occurrences",
            exams_lab: "Exams Lab",
            exams_n_lab: "Exams N Lab",
            medicines: "Medicines",
          },
          tasyCalendar: {
            title: "Tasy Calendar",
            type_code: "Code",
            created: "Created",
            identifier: "Identifier",
            validationFilter: "Validation",
            onlyValid: "Only valid",
            invalid: "Invalid",
            calendar_identifier: "Calendar Identifier",
            start_date: "Start date",
            end_date: "End date",
            calendar_date: "Calendar Date",
            status: "Status",
            individual_identifier: "Individual Identifier",
            last_modified: "Last Modified",
          },
          monitoring: {
            title: "Bus Server Monitoring",
            subtitle: "Bus On-Premise Server Statistics              ",
          },
          syncPersons: {
            title: "Sync - People data",
            search_placeholder: "Search by name or CPF...",
            name: "Name",
            cpf: "CPF",
            birth_date: "Birth date",
            email: "Email",
            phone: "Phone",
            cell_phone: "Mobile phone",
            system: "System",
            last_modified: "Last updated",
            start_date: "Start date",
            end_date: "End date",
            view_transactions: "View transactions",
            transactions: "Transactions",
            actions: "Actions",
            logs: "Logs",
            identifier: "Identifier",
            document: "Document",
            status: "Status",
            message: "Message",
            original_value: "Original value",
            new_value: "New value",
            retries: "Retries",
            created: "Created",
            batch_id: "Batch",
            batch_queue_id: "Batch queue",
            success: "Success",
            error: "Error",
            close: "Close",
            no_transactions: "No transactions found.",
            no_actions: "No actions found.",
            no_logs: "No logs found.",
            tasy_identifier: "Tasy Identifier",
            view_all_data: "View all data",
            details_title: "All data",
            details_error: "Could not load the person data.",
            section_identification: "Identification",
            section_contact: "Contact",
            section_origin: "Origin and update",
            section_addresses: "Addresses",
            no_addresses: "This person has no addresses.",
            system_nrec: "Creation system",
            last_modified_nrec: "Creation date",
            address_type: "Type",
            address_street: "Street",
            address_number: "Number",
            address_complement: "Complement",
            address_neighborhood: "Neighborhood",
            address_city: "City",
            address_state: "State",
            address_zip: "ZIP code",
            address_type_unknown: "Type {{code}}",
            address_types: {
              1: "Residential",
              2: "Commercial",
              3: "Guardian's",
              4: "Father's",
              5: "Mother's",
              6: "Spouse's",
              7: "Commercial 2",
              8: "Lodging",
              9: "Additional",
              10: "Postal address",
              20: "Emergency contact",
              30: "Cooperative member only",
            },
          },
          nfeTotvs: {
            title: "Tasy - TOTVS - NFE",
            identifier: "Identifier",
            resync: "Force resend",
            resetedSuccess: "Resend forced successfully",
            totvsIdentifier: "TOTVS Identifier",
            invoice_identifier: "Invoice Identifier",
            status_item: "Status",
            integration_situation: "Integration Status",
            created: "Created Date",
            integrated_date: "Integration Date",
            retries: "Retries",
            last_modified: "Last Modified",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            status: {
              pending: "Pending",
              processing: "Processing",
              finished: "Finished",
              error: "Error",
            },
            view_logs: "View Logs",
            view_details: "View Details",
            logs: "Logs",
            search_placeholder: "Search for NFe TOTVS...",
            details: {
              title: "NFe Details",
              log_id: "Log ID",
              status: "Status",
              created: "Created Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              summary: "Log Summary",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              provider: "Provider",
              cnpj: "CNPJ",
              invoice: "Invoice",
              id: "ID",
              success: "Success",
              error: "Error",
            },
            integration_type: "Integration Type",
            cancellation: "Cancellation",
            integration: "Integration",
          },
          calendarControl: {
            title: "Available Slots Lookup",
            identifier: "Identifier",
            created: "Created at",
            created_start: "Start date",
            created_end: "End date",
            last_modified: "Last modified",
            heart_beat_date: "Last heartbeat",
            document: "Document (CPF)",
            birth_date: "Birth date",
            gender: "Gender",
            individual_identifier: "Person code (Tasy)",
            insurance_code: "Insurance",
            insurance_category_code: "Insurance category",
            procedure_code: "Procedure",
            internal_procedure_code: "Internal procedure",
            procedure_origin_code: "Procedure origin",
            valid_quantity: "Valid slots",
            minimum_quantity: "Minimum quantity",
            type_of_appointment: "Schedule type",
            type_calendar: "Type code",
            type_of_appointment_values: {
              CONSULTA: "Consultation",
              RETORNO: "Follow-up",
              CHECKUP: "Check-up",
              EXAME: "Exam",
            },
            status: "List status",
            status_values: {
              "LISTA EM CRIACAO": "List being created",
              "LISTA CRIADA": "List created",
              "LISTA FINALIZADA": "List finished",
            },
            json: "JSON",
            details: "Details",
            additionalFilters: "More filters",
            view_items: "View evaluated slots",
            view_json: "View request JSON",
            view_details: "View details",
            copy_json: "Copy JSON",
            copy_details: "Copy details (JSON)",
            close: "Close",
            json_modal: {
              title: "Request JSON",
              empty: "No JSON recorded.",
            },
            details_modal: {
              title: "Other search fields",
            },
            items: {
              title: "Search details",
              calendar_identifier: "Calendar",
              slot_identifier: "Slot identifier",
              calendar_date: "Date and time",
              status: "Status",
              is_valid: "Valid",
              message: "Reasons",
            },
            item_status_values: {
              PENDENTE: "Pending",
              PROCESSADO: "Processed",
            },
            is_valid_values: {
              S: "Yes",
              N: "No",
            },
          },
          refund: {
            title: "Refunds",
            holder_document: "Holder Document",
            holder_bank_account_name: "Holder Name",
            protocol_integration_id: "Protocol",
            attempt_count: "Attempts",
            created: "Created Date",
            integrated_at: "Integration Date",
            last_modified: "Last Modified",
            status: "Status",
            start_date: "Start Date",
            end_date: "End Date",
            search_placeholder: "Search by Refunds...",
            view_details: "View details",
            retry: "Retry",
            retry_success: "Retry requested successfully.",
            status_options: {
              pendente: "Pending",
              processando: "Processing",
              processado: "Processed",
              erro: "Error",
              erro_emailenviado: "Error (email sent)",
              retentativa_manual: "Manual Retry",
            },
            details: {
              title: "Refund Details",
              status: "Status",
              created: "Created Date",
              last_modified: "Last Modified",
              message: "Message",
              log_data: "Log Data",
              view_full_log: "View full log",
              close: "Close",
              success: "Success",
              error: "Error",
              protocol_logs_title: "Protocol Logs",
              attachments_title: "Attachments",
              attachment_integrated: "Integrated",
              attachment_pending: "Pending",
              attachment_attempts: "Attempts",
              media_file_retry_success:
                "Attachment retry requested successfully.",
            },
          },
          forubusVaccine: {
            title: "4uBus Vaccines",
            identifier: "Identifier",
            immunization_identifier: "Immunization Identifier",
            resync: "Force resend",
            resetedSuccess: "Resend forced successfully",
            individual_document: "Document",
            vaccine_identifier: "Vaccine Identifier",
            status_item: "Status",
            created: "Creation Date",
            integrated_date: "Integration Date",
            retries: "Retries",
            last_modified: "Last Modified",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            status: {
              pending: "Pending",
              sending: "Sending",
              processing: "Processing",
              finished: "Finished",
              error: "Error",
            },
            view_logs: "View logs",
            view_details: "View details",
            logs: "Logs",
            search_placeholder: "Search for 4uBus vaccines...",
            details: {
              title: "Vaccine Details",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              summary: "Log Summary",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              provider: "Provider",
              cnpj: "CNPJ",
              invoice: "Invoice",
              id: "ID",
              success: "Success",
              error: "Error",
            },
            integration_type: "Integration Type",
            cancellation: "Cancellation",
            integration: "Integration",
          },
          invoiceServiceAgy: {
            title: "Invoice Service Agy",
            identifier: "Identifier",
            invoice_number: "Invoice Number",
            rec_company_name: "Receiver Name",
            rec_company_document: "Receiver CNPJ",
            status_item: "Status",
            created: "Creation Date",
            integrated_date: "Integration Date",
            retries: "Retries",
            last_modified: "Last Modified",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            resync: "Force resend",
            resetedSuccess: "Resend forced successfully",
            status: {
              with_inconsistency: "With Inconsistency",
              awaiting_send: "Awaiting Send",
              sent: "Sent",
              error: "Error",
              success: "Success",
            },
            view_logs: "View logs",
            view_details: "View details",
            logs: "Logs",
            search_placeholder: "Search for Invoice Service Agy...",
            details: {
              title: "Invoice Service Agy Details",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              close: "Close",
              view_full_log: "View Full Log",
            },
          },
          patientEncounterPsTransferRequest: {
            title:
              "Tasy EMR - Generate new ER Encounter, from PA encounter ineligibility",
            original_patient_encounter_number: "Original Encounter No.",
            new_patient_encounter_number: "New Encounter No. (PA)",
            new_prescription_number: "New Prescription No. (PA)",
            individual_beneficiary_id: "Beneficiary ID",
            individual_beneficiary_name: "Beneficiary Name",
            original_doctor_integration_id: "Original Doctor",
            target_doctor_integration_id: "ER Doctor",
            transfer_confirmed_date: "Transfer Date",
            status: "Status",
            status_values: {
              pending: "Pending",
              processing: "Processing",
              success: "Success",
              manual_review: "Manual Review",
            },
            retries: "Retries",
            created: "Creation Date",
            created_start: "Start Date",
            created_end: "End Date",
            additionalFilters: "More filters",
            search: "Search",
            search_placeholder: "Search by Encounter...",
            view_details: "View details",
            reprocess: "Reprocess",
            reprocess_selected: "Reprocess selected",
            reprocessedSuccess: "Records successfully sent for reprocessing",
            details: {
              title: "Transfer Details",
              success: "Status",
              success_true: "Success",
              success_false: "Failure",
              created: "Date",
              log_data: "Log Data",
              last_attempt_date: "Last Attempt",
              payload: "Payload",
              history: "History",
            },
          },
          externalLogError: {
            title: "LogError",
            id: "ID",
            error_date: "Error Date",
            error_code: "Error Code",
            error_message: "Error Message",
            source_class: "Source Class",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            view_details: "View details",
            search_placeholder: "Search for LogError...",
            details: {
              title: "Error Log Details",
              error_date: "Error Date",
              error_code: "Error Code",
              error_message: "Error Message",
              command_text: "SQL Command",
              bind_parameters: "Parameters",
              stack_trace: "Stack Trace",
              source_class: "Source Class",
              copy: "Copy content",
            },
          },
          gerAcessoVisitControlPacient: {
            title: "Patient Companion Access",
            total_time: "Total Time",
            order_by_slowest: "Slowest first",
            order_by_slowest_info:
              "Sorts by total time (from the release in Tasy to the delivery to the GerAcesso API), from longest to shortest.",
            identifier: "Identifier",
            patient_name: "Patient Name",
            visitor_cpf: "Companion CPF",
            service_number: "Service Number",
            visit_date: "Visit Date",
            visitor: "Companion",
            exit_date: "Exit Date",
            status_item: "Status",
            retries: "Retries",
            created: "Creation Date",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            status: {
              pending: "Pending",
              sending: "Sending",
              processing: "Processing",
              finished: "Finished",
              error: "Error",
            },
            view_logs: "View logs",
            view_details: "View details",
            resync: "Force resend",
            partialResyncWarning: "Some records could not be resent.",
            resyncError: "Could not resend the selected records.",
            resetedSuccess: "Resend forced successfully",
            logs: "Logs",
            search_placeholder: "Search for Patient Companion Access...",
            details: {
              title: "Access Details",
              tasy_released: "Released in Tasy",
              tasy_to_capture: "Tasy → Capture",
              capture_to_sent: "Capture → Sent",
              total_time: "Total Time",
              tasy_to_capture_info:
                "Time between the release in Tasy and the capture of the record by our routine.",
              capture_to_sent_info:
                "Time between the capture of the record by our routine and the delivery of the data to the GerAcesso API.",
              total_time_info:
                "Total time between the release in Tasy and the delivery of the data to the GerAcesso API.",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
            integration_type: "Integration Type",
            cancellation: "Cancellation",
            integration: "Integration",
          },
          gerAcessoVisitControlVisitor: {
            title: "Patient Visitor Access",
            total_time: "Total Time",
            order_by_slowest: "Slowest first",
            order_by_slowest_info:
              "Sorts by total time (from the release in Tasy to the delivery to the GerAcesso API), from longest to shortest.",
            identifier: "Identifier",
            patient_name: "Patient Name",
            visitor_cpf: "Visitor CPF",
            service_number: "Service Number",
            visit_date: "Visit Date",
            visitor: "Visitor",
            exit_date: "Exit Date",
            status_item: "Status",
            retries: "Retries",
            created: "Creation Date",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            status: {
              pending: "Pending",
              sending: "Sending",
              processing: "Processing",
              finished: "Finished",
              error: "Error",
            },
            view_logs: "View logs",
            view_details: "View details",
            resync: "Force resend",
            resync_selected: "Resend selected",
            resetedSuccess: "Resend forced successfully",
            bulk_resync_error: "Unable to force resend all selected records",
            select_error_rows: "Select at least one failed record to resend",
            logs: "Logs",
            search_placeholder: "Search for Patient Visitor Access...",
            details: {
              title: "Access Details",
              tasy_released: "Released in Tasy",
              tasy_to_capture: "Tasy → Capture",
              capture_to_sent: "Capture → Sent",
              total_time: "Total Time",
              tasy_to_capture_info:
                "Time between the release in Tasy and the capture of the record by our routine.",
              capture_to_sent_info:
                "Time between the capture of the record by our routine and the delivery of the data to the GerAcesso API.",
              total_time_info:
                "Total time between the release in Tasy and the delivery of the data to the GerAcesso API.",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
            integration_type: "Integration Type",
            cancellation: "Cancellation",
            integration: "Integration",
          },
          gerAcessoVisitControlSector: {
            title: "Sector Visitor Access",
            total_time: "Total Time",
            order_by_slowest: "Slowest first",
            order_by_slowest_info:
              "Sorts by total time (from the release in Tasy to the delivery to the GerAcesso API), from longest to shortest.",
            sector: "Sector",
            identifier: "Identifier",
            patient_name: "Patient Name",
            visitor_cpf: "Visitor CPF",
            service_number: "Service Number",
            access_control_number: "Access Control Number",
            visit_date: "Visit Date",
            visitor: "Visitor",
            exit_date: "Exit Date",
            status_item: "Status",
            retries: "Retries",
            created: "Creation Date",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            status: {
              pending: "Pending",
              processing: "Processing",
              finished: "Finished",
              error: "Error",
            },
            view_logs: "View logs",
            view_details: "View details",
            resync: "Force resend",
            resync_selected: "Resend selected",
            resetedSuccess: "Resend forced successfully",
            bulk_resync_error: "Unable to force resend all selected records",
            select_error_rows: "Select at least one failed record to resend",
            logs: "Logs",
            search_placeholder: "Search for Sector Visitor Access...",
            details: {
              title: "Access Details",
              tasy_released: "Released in Tasy",
              tasy_to_capture: "Tasy → Capture",
              capture_to_sent: "Capture → Sent",
              total_time: "Total Time",
              tasy_to_capture_info:
                "Time between the release in Tasy and the capture of the record by our routine.",
              capture_to_sent_info:
                "Time between the capture of the record by our routine and the delivery of the data to the GerAcesso API.",
              total_time_info:
                "Total time between the release in Tasy and the delivery of the data to the GerAcesso API.",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
            integration_type: "Integration Type",
            cancellation: "Cancellation",
            integration: "Integration",
          },
          invoiceLoweringTotvs: {
            title: "Tasy > TOTVS - Invoice Lowering",
            identifier: "Identifier",
            invoice_identifier: "Invoice Identifier",
            account_payable_identifier: "Account Payable",
            due_date: "Due Date",
            lowering_identifier: "Lowering ID",
            status_item: "Status",
            created: "Created Date",
            integrated_date: "Integration Date",
            retries: "Retries",
            last_modified: "Last Modified",
            start_date: "Start Date",
            end_date: "End Date",
            search: "Search",
            resync: "Force resend",
            resetedSuccess: "Resend forced successfully",
            status: {
              pending: "Pending",
              processing: "Processing",
              finished: "Finished",
              error: "Error",
            },
            view_logs: "View logs",
            view_details: "View details",
            logs: "Logs",
            search_placeholder: "Search for TOTVS Invoice Lowering...",
            details: {
              title: "Invoice Lowering Details",
              log_id: "Log ID",
              status: "Status",
              created: "Created Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              summary: "Log Summary",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
              logs: "Logs",
              titles_totvs: "TOTVS Titles",
              invoice_identifier: "Invoice Identifier",
              id_lan: "Slip ID",
              id_mov: "Movement ID",
              cod_coligada: "Branch Company",
              cod_filial: "Branch",
              due_date: "Due Date",
              totvs_data: "TOTVS Data",
              view_totvs_data: "View TOTVS Data",
            },
            lowering_type: "Lowering Type",
            reversal: "Reversal",
            normal: "Normal",
          },
          tasyToTasyNonLabFilters: {
            additional_filters: "More filters",
            local_group: "Local identifiers",
            external_group: "External identifiers",
          },
          tasyToTasyNonLabExamsAvailable: {
            title: "Tasy <> Tasy - Non-laboratory Exam (Available)",
            identifier: "Identifier",
            service_number: "Service Number",
            patient_cpf: "Patient CPF",
            status_item: "Status",
            prescription_number: "Prescription Number",
            procedure_prescription_number: "Procedure Prescription Number",
            external_prescription_number: "External Prescription Number",
            external_procedure_prescription_number:
              "External Procedure Prescription Number",
            external_service_number: "External Service Number",
            retries: "Retries",
            start_date: "Start Date",
            end_date: "End Date",
            view_details: "View details",
            status: {
              available: "Available",
              downloaded: "Download Complete",
              recognized: "Recognized",
              integrated: "Integrated",
              error: "Error",
              cancelled: "Cancelled",
            },
            details: {
              title: "Result Details",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              status_message: "Message",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
          },
          tasyToTasyNonLabExamsReceived: {
            title: "Tasy <> Tasy - Non-laboratory Exams (Received)",
            identifier: "Identifier",
            service_number: "Service Number",
            patient_cpf: "Patient CPF",
            status_item: "Status",
            prescription_number: "Prescription Number",
            procedure_prescription_number: "Procedure Prescription Number",
            external_prescription_number: "External Prescription Number",
            external_procedure_prescription_number:
              "External Procedure Prescription Number",
            external_service_number: "External Service Number",
            retries: "Retries",
            start_date: "Start Date",
            end_date: "End Date",
            view_details: "View details",
            status: {
              available: "Available",
              downloaded: "Download Complete",
              recognized: "Recognized",
              integrated: "Integrated",
              error: "Error",
              cancelled: "Cancelled",
            },
            details: {
              title: "Result Details",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              status_message: "Message",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
          },
          serviceReceived: {
            title: "Tasy - Receive Appointments",
            identifier: "Identifier",
            generated_service_number: "Generated Service Number",
            establishment_code: "External Establishment Code",
            external_cpf: "External CPF",
            status_item: "Status",
            external_service_number: "External Service Number",
            external_person_code: "External Person Code",
            linked_person_code: "Generated/Linked Person Code",
            external_person_name: "External Person Name",
            view_received_data: "View Received Data",
            retries: "Retries",
            view_details: "View details",
            resync: "Force resend",
            resetedSuccess: "Forced resend successfully completed",
            start_date: "Start Date",
            end_date: "End Date",
            more_filters: "More Filters",
            service_data: "Service Data",
            patient_data: "Patient / Link Data",
            clean_filters: "Clear Filters",
            cancel: "Cancel",
            apply_filters: "Apply Filters",
            encounter_date_entry: "Encounter Date Entry",
            status: {
              received: "Received",
              integrated: "Integrated",
              pending: "Pending",
              error: "Error",
            },
            details: {
              title: "Service Details",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
          },
          tasyToTasyResultsNonLabAvailable: {
            title: "Tasy <> Tasy - Non-Laboratory Exam Results (Available)",
            identifier: "Identifier",
            service_number: "Service Number",
            patient_cpf: "Patient CPF",
            status_item: "Status",
            prescription_number: "Prescription Number",
            procedure_prescription_number: "Procedure Prescription Number",
            external_prescription_number: "External Prescription Number",
            external_procedure_prescription_number:
              "External Procedure Prescription Number",
            external_service_number: "External Service Number",
            start_date: "Start Date",
            end_date: "End Date",
            view_details: "View details",
            status: {
              available: "Available",
              downloaded: "Download Complete",
              recognized: "Recognized",
              integrated: "Integrated",
              error: "Error",
              cancelled: "Cancelled",
            },
            details: {
              title: "Result Details",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              status_message: "Message",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
          },
          tasyToTasyResultsNonLabReceived: {
            title: "Tasy <> Tasy - Non-Laboratory Exam Results (Received)",
            identifier: "Identifier",
            service_number: "Service Number",
            patient_cpf: "Patient CPF",
            status_item: "Status",
            prescription_number: "Prescription Number",
            procedure_prescription_number: "Procedure Prescription Number",
            external_prescription_number: "External Prescription Number",
            external_procedure_prescription_number:
              "External Procedure Prescription Number",
            external_service_number: "External Service Number",
            start_date: "Start Date",
            end_date: "End Date",
            view_details: "View details",
            status: {
              available: "Available",
              downloaded: "Download Complete",
              recognized: "Recognized",
              integrated: "Integrated",
              error: "Error",
              cancelled: "Cancelled",
            },
            details: {
              title: "Result Details",
              log_id: "Log ID",
              status: "Status",
              created: "Creation Date",
              last_modified: "Last Modified",
              log_data: "Log Data",
              status_message: "Message",
              logs_table_title: "Integration Logs",
              close: "Close",
              view_full_log: "View Full Log",
              success: "Success",
              error: "Error",
            },
          },
          syncTransaction: {
            title: "Sync - Transaction Data",
            identifier: "Identifier",
            name: "Name",
            cpf: "CPF",
            external_id: "External ID",
            status_item: "Status",
            start_date: "Start Date",
            end_date: "End Date",
            view_action: "View Action",
            actions: "Actions",
            last_modified: "Last Updated",
            original_value: "Original Value",
            new_value: "New Value",
            message: "Message",
            retries: "Retries",
            created: "Creation Date",
            resend: "Force resend",
            resend_row: "Resend",
            resend_confirm_title: "Force resend",
            resend_confirm_description: "Resend {{quantity}} selected transaction(s)? Only those with Error status go back to the queue; the others will be ignored.",
            resend_confirm_button: "Resend",
            resend_cancel: "Cancel",
            resend_select_rows: "Select at least one transaction.",
            resend_result_title: "Resend result",
            resend_result_summary: "{{restarted}} resent, {{ignored}} ignored by status and {{failed}} failed.",
            resend_result_failed_title: "Transactions with errors",
            resend_result_source_hint: "If the error comes from the source data (for example, an invalid CPF), the transaction will fail again. Fix the data at the source.",
            resend_result_close: "Close",
            individual_last_modified: "Source update",
            origin_system: "Origin system",
            logs: "Logs",
            no_transactions: "No transactions found.",
            no_actions: "No actions found.",
            no_logs: "No logs found.",
            status: {
              error: "Error",
              success: "Success",
              in_process: "In Progress",
              pending: "Pending",
              waiting_action_generation: "Waiting for Action Generation",
            },
          },
        },
        sync: {
          sync: "Synchronization",
          sync_all: "Sync all",
          synced_all: "Synchronization completed successfully",
        },
        uBusAutomationRobot: {
          suffixPrefix: "Suffix/Prefix",
          identificationPosition: "Identification Form Position",
          exam_machine_files: "File Integrations",
          add_exam_machine_files: "Add File Integrations",
          name_table: "Name",
          description_table: "Description",
          search: "Search for a file integration",
          internal_procedure_integration_id: "Internal Procedure Code",
          medical_certificate_content: "Report Message",
          physician_will_report: "Generates Report in Typing",
          path_table: "Path",
          file_integration: "File Integration",
          new_file_integration: "New File Integration",
          ubus_automation: "File Integration Type",
          name: "File Mapping Name",
          machine_mode: "Exam Machine Mode",
          path: "File Monitoring Path",
          path_separator: "Separator",
          description: "Description",
          exam_machine: "Exam Machine Brand/Model",
          software: "Software",
          integration_attribute: "Destination Identification Method in Files",
          minutes: "Execution Minutes",
          generate_pdf_with_images: "Group Images and Generate PDF",
          rotate_images: "Rotate Images Individually",
          rotation_mode: "Image Rotation Setting",
          insert_report_test_pdf: "Include Report PDF in Patient Report",
          minutes_to_group_pdf: "Image Grouping Time (in minutes)",
          insert_report_test_pdf_as_image:
            "Include PDF in Patient Report Attachment",
          insert_image_as_attachment:
            "Include Images in Patient Report Attachment",
          make_copy_files_end_of_process:
            "Make a copy of the files at the end of the process",
          copy_files_path: "Path to save copy of files",
          copy_process: "Copy process",
          rename_file_process: "Rename files",
          ubus_automation_execution: "File Destination",
          enable: "Enable",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete File Integration?",
            description: "This will permanently delete the File Integration",
          },
          errors: {
            name: "The file mapping name is mandatory",
            path: "The file monitoring path is mandatory",
            description: "The description is mandatory",
            exam_machine: "The exam machine brand/model is mandatory",
            software: "The software is mandatory",
            integration_attribute:
              "The destination identification method in files is mandatory",
            minutes: "Execution minutes are mandatory",
            insert_report_test_pdf:
              "The option to group images and generate a PDF is mandatory",
            minutes_to_group_pdf:
              "The image grouping time (in minutes) is mandatory",
            uBusAutomationExecution: "The file destination is mandatory",
            uBusAutomation: "The file integration type is mandatory",
            examMachineModality: "The exam machine modality is mandatory",
            rotation_mode: "The image rotation setting is mandatory",
            external_procedure_integrationId:
              "The internal procedure code is mandatory",
            internal_procedure_integration_id:
              "The internal procedure code is mandatory",
            copy_files_path: "The path to save copy of files is mandatory",
            copy_process: "The copy process is mandatory",
            suffixPrefix: "Suffix/Prefix must be at most 50 characters",
          },
        },
        robots: {
          list: {
            list: "Robots List",
            search: "Search for a robot",
            name: "Name",
            description: "Description",
            code: "Code",
            started: "Started",
            last_success: "Last success",
            last_error: "Las error",
            last_error_message: "Last error message",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            executions_robots: "Executions Robots",
            executions: {
              executions_robots: "Executions Robots",
              job_name: "Job name",
              start_date: "Start date",
              end_date: "End date",
              execution_status: "Execution status",
            },
          },
        },
        zscanExamSendRule: {
          exam_send_rules: "Exam Sending Rules",
          exam_send_rule: "Exam Sending Rule",
          add_exam_send_rule: "Add Exam Sending Rule",
          new_exam_send_rule: "New Exam Sending Rule",
          target_machine: "Target Machine",
          proc_classification_integration_id: "Procedure Classification ID",
          initial_date: "Start Date",
          end_date: "End Date",
          enable: "Enable",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          errors: {
            target_machine: "The target machine is required",
            proc_classification_integration_id:
              "The procedure classification ID is required",
            initial_date: "The start date is required",
            end_date: "The end date is required",
            initial_date_bigger:
              "The start date cannot be greater than the end date",
          },
          confirm: {
            title: "Delete exam sending rule?",
            description: "This will permanently delete the exam sending rule",
          },
        },
        integrationRule: {
          integration_rules: "Integration Rules",
          integration_rule: "Integration Rule",
          add_integration_rule: "Add integration rule",
          new_integration_rule: "New integration rule",
          search: "Search for an integration rule",
          automation: "Automation",
          name: "Name",
          description: "Description",
          u_bus_automation: "4uBus Automation",
          i_processe: "Process",
          start_date: "Start date of validity",
          end_date: "End date of validity",
          initial_date: "Cut-off date",
          filters: "Filters",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          enable: "Enable",
          created_successfully: "Integration rule successfully registered",
          integration_rule_relationship_group: "Relationship Group",
          i_services: "Services",
          transfers: "Movements",
          parameters: "Parameters",
          rules: "Rules",
          suspension_reason_code: "Suspension reason code",
          batch_size: "Maximum batch size",
          max_workers: "Maximum number of concurrent processes",
          only_requestable_lab_exams:
            "Consider only requestable laboratory exams",
          only_requestable_lab_exams_tooltip:
            "When enabled, the automatic internal procedure lookup ignores laboratory exams flagged as not requestable in Tasy (IE_SOLICITACAO different from 'S').",
          reports_tooltip:
            "Use {{NR_LAUDOS}} in the text to replace it with the released reports included in the email.",
          email_copy_recipients_tooltip:
            "In this field you can add emails that will receive a copy of the sent emails. You can add multiple emails separated by commas.",
          integrationRuleRelationshipGroup: {
            integration_rule_relationship_groups: "Relationship Groups",
            integration_rule_relationship_group: "Relationship Group",
            add_integration_rule_relationship_group: "Add relationship group",
            new_integration_rule_relationship_group: "New relationship group",
            search: "Search for a relationship group",

            priority: "Priority",
            u_bus_relationship_group: "4uBus Relationship Group",
            confirm: {
              title: "Delete relationship group?",
              description:
                "This will permanently delete the relationship group",
            },
            errors: {
              u_bus_relationship_group:
                "The 4uBus relationship group is required",
            },
          },
          integrationRuleIService: {
            integration_rule_i_services: "Services",
            integration_rule_i_service: "Service",
            add_integration_rule_i_service: "Add service",
            new_integration_rule_i_service: "New service",
            search: "Search for a service",
            integration_direction_type: "Integration Direction Type",
            i_service: "Service",
            grid_warning:
              'No records will be available in this integration until a rule is created in the field "Integration direction type" with the value "Third-party system input". Access to the data is granted based on this configuration.',
            confirm: {
              title: "Delete service?",
              description: "This will permanently delete the service",
            },
            errors: {
              integration_direction_type:
                "The integration direction type is required",
              i_service: "The service is required",
            },
          },
          integrationRuleMov: {
            integration_rule_movs: "Movements",
            integration_rule_mov: "Movement",
            add_integration_rule_mov: "Add Movement",
            new_integration_rule_mov: "New Movement",
            search: "Search for a movement",
            status: "Status",
            enable: "Enable",
            active: "Active",
            inactive: "Inactive",
            individual_external_id: "Patient External Identifier",
            individual_identifier_message_helper:
              "Values must be separated by commas",
            internal_proc_classification: "Internal Procedure Classification",
            procedure_type: "Procedure Type",
            tasy_ops_if_label: "If",
            tasy_ops_then_label: "Then",
            establishment_external_id: "Establishment",
            provider_external_id: "Provider",
            establishment_external_id_then: "Establishment (Then)",
            patient_encounter_type_external_id_then: "Encounter Type (Then)",
            tiss_attendance_type_external_id_then:
              "Tiss Attendance Type (Then)",
            patient_encounter_origin_external_id_then:
              "Encounter Origin (Then)",
            patient_care_character_external_id_then: "Care Character (Then)",
            patient_care_classification_external_id_then:
              "Care Classification (Then)",
            insurance_type_external_id_then: "Insurance Type (Then)",
            insurance_external_id_then: "Insurance (Then)",
            insurance_category_external_id_then: "Insurance Category (Then)",
            insurance_plan_external_id_then: "Insurance Plan (Then)",
            sector_external_id_then: "Sector (Then)",
            sector_basic_unit_external_id_then: "Sector Basic Unit (Then)",
            sector_compl_unit_external_id_then:
              "Sector Complementary Unit (Then)",
            sector_accommodation_type_external_id_then:
              "Accommodation Type (Then)",
            hvs_upa_ps_if_label: "If",
            hvs_upa_ps_then_label: "Then",
            hvs_upa_ps_job1_label: "Job 1 · Find eligible encounters",
            hvs_upa_ps_job1_description:
              "Defines which discharged encounters enter the transfer queue. The filters below narrow the search; the patient identifier limits the search to a single person (useful for tests).",
            hvs_upa_ps_job2_phase1_label:
              "Job 2 · Phase 1 — Generate new encounter and prescription",
            hvs_upa_ps_job2_phase1_description:
              "Creates a new encounter with the characteristics of the current one (establishment, type, origin, care character, insurance and sector) and a prescription with the procedures below. It lets the original doctor be paid for the initial consultation.",
            hvs_upa_ps_job2_phase2_label:
              "Job 2 · Phase 2 — Transfer the current encounter to the ER",
            hvs_upa_ps_job2_phase2_description:
              "Updates the current encounter with the sector, unit, TISS attendance type and doctor below. The doctor comes from the schedule or from the last encounter of the day; if none is found, the Default Doctor is used.",
            insurance: "Insurance",
            sector: "Sector",
            verify_released_opinion:
              "Check if a released medical opinion exists",
            procedure_area: "Procedure Area",
            procedure_specialty: "Procedure Specialty",
            procedure_group: "Procedure Group",
            lab_exam_classification: "Laboratory Exam Classification",
            plan_operation_type: "Product Operation Type",
            plan_price_formation: "Product Price Formation",
            plan_filters_message_helper:
              "Movements of the same rule must be mutually exclusive: a guide that matches more than one Movement stays only with the first one processed.",
            internal_procedure: "Internal Procedure",
            internal_procedure_then: "Internal Procedure (Then)",
            doctor_obtain_mode: "Doctor obtain mode",
            doctor_obtain_mode_schedule: "According to schedule",
            doctor_obtain_mode_last_encounter_of_day:
              "Doctor of the last encounter of the day",
            schedule_then: "Schedule (Then)",
            default_doctor_external_id_then: "Default Doctor (Then)",
            confirm: {
              title: "Delete Movement?",
              description: "This will permanently delete the Movement",
            },
            errors: {
              establishment_external_id: "Establishment is required",
              provider_external_id: "Provider is required",
              establishment_external_id_then:
                "Establishment (Then) is required",
              patient_encounter_type_external_id_then:
                "Patient encounter type (Then) is required",
              patient_encounter_origin_external_id_then:
                "Patient encounter origin (Then) is required",
              patient_care_character_external_id_then:
                "Patient care character (Then) is required",
              patient_care_classification_external_id_then:
                "Patient care classification (Then) is required",
              insurance_external_id_then: "Insurance (Then) is required",
              insurance_category_external_id_then:
                "Insurance category (Then) is required",
              sector_external_id_then: "Sector (Then) is required",
              sector_basic_unit_external_id_then:
                "Sector basic unit (Then) is required",
              sector_accommodation_type_external_id_then:
                "Accommodation type (Then) is required",
              tiss_attendance_type_external_id_then:
                "Tiss attendance type (Then) is required",
              sector_compl_unit_external_id_then:
                "Sector complementary unit (Then) is required",
              u_bus_integration_rule_mov_internal_procedures_then:
                "Internal procedure (Then) is required",
              u_bus_integration_rule_mov_schedules_then:
                "Schedule (Then) is required",
            },
          },
          integrationRuleParam: {
            integration_rule_params: "Parameters",
            integration_rule_param: "Parameter",
            add_integration_rule_param: "Add Parameter",
            new_integration_rule_param: "New Parameter",
            search: "Search for a parameter",
            inclusion_rule_type: "Inclusion rule type",
            if: "If",
            then: "Then",
            source_name: "Source name",
            source_value: "Source value",
            destination_name: "Destination name",
            destination_value: "Destination value",
            sector: "Sector",
            basic_unit: "Basic Unit",
            complementary_unit: "Complementary Unit",
            insurance: "Insurance",
            category: "Category",
            establishment: "Establishment",
            confirm: {
              title: "Delete Parameter?",
              description: "This will permanently delete the Parameter",
            },
            errors: {
              inclusion_rule_type: "The inclusion rule type is required",
              required_field: "Required field",
            },
          },
          integrationRuleField: {
            integration_rule_fields: "Rules",
            integration_rule_field: "Rule",
            add_integration_rule_field: "Add rule",
            new_integration_rule_field: "New rule",
            search: "Search for a rule",
            automation_field: "Automation field",
            individual_external_id: "Individual External ID",
            if: "If",
            then: "Then",
            softwares: "Softwares",
            confirm: {
              title: "Delete rule?",
              description: "This will permanently delete the rule",
            },
            errors: {
              automation_field: "The automation field is required",
            },
          },
          confirm: {
            title: "Delete integration rule?",
            description: "This will permanently delete the integration rule",
          },
          errors: {
            name: "The name is required",
            start_date: "The start date is required",
            end_date: "The end date is required",
            initial_date: "The cut-off date is required",
            start_date_bigger:
              "The start date cannot be later than the end date",
            u_bus_automation: "The 4uBus automation is required",
            i_processe: "The process is required",
            suspension_reason_code: "Suspension reason code is required",
            batch_size_min: "The maximum batch size must be greater than zero",
            max_workers_min:
              "The maximum number of processes must be greater than zero",
            max_workers_max:
              "The maximum number of processes cannot be greater than 5",
          },
        },
      },
      "4uSiteApp": {
        siteLoginContent: {
          site_login_content: "Login Content",
          search: "Search for a login content",
          add_site_login_content: "Add content",
          name: "Name",
          presentation_order: "Presentation order",
          enable: "Enable",
          link_url: "Link url",
          link_label: "Link label",
          document: "Document",
          language: "Language",
          language_tooltip: "Register a new language",
          add_new_language: "Add new language",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete the login content?",
            description: "This will permanently delete the login content",
          },
          errors: {
            name: "The name is required",
            presentation_order: "The presentation order is required",
            document_text: "The content is required",
            language: "The language is required",
            languages: "Inform at least one language",
          },
        },
        applications: {
          myApplications: {
            my_applications: "My applications",
            search: "Search for an application",
            name: "Name",
            type: "Type",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
          },
        },
        consultationsAndLogs: {
          beneficiarySituation: {
            title: "Beneficiary Situation",
            document: "CPF",
            establishment_code: "Establishment",
            person_code: "Person code",
            name: "Name",
            insured_code: "Insured code",
            plan: "Plan",
            card_code: "Card code",
            card_validity: "Card validity",
            contract_status: "Contract status",
            details: "Full data",
            birth_date: "Birth date",
            accession_date: "Accession date",
            another_plan_qty: "Other plans",
            locks: "Locks",
            lock_code: "Code",
            description: "Description",
            unlock_date: "Unlock date",
            temporary_partial_coverage: "TPC",
            view_details: "View details",
            search_placeholder: "Search beneficiaries...",
            errors: {
              document_required: "CPF is required",
            },
          },
        },
      },
      "4uSalesContract": {
        registers: {
          grantors: {
            active: "Active",
            inactive: "Inactive",
            name: "Name",
            status: "Status",
            grantors: "Grantors",
            add_grantor: "Add Grantor",
            enabled: "Enabled",
            establishments: "Establishments",
            new_grantor: "New Grantor",
            legal_entity: "Legal Entity",
            search_grantors: "Search for a Grantor",
            confirm: {
              title: "Delete grantor?",
              description: "This will permanently delete the grantor",
            },
            errors: {
              name: "The name is mandatory",
              establishment: "At least one establishment is mandatory",
              legal_entity: "The legal entity is mandatory",
            },
          },
          salesContractAttachments: {
            title: "Attachment",
            description: "Description",
            search: "Search Attachments",
            add: "Add Attachment",
            title_form: "Title",
            approval_date: "Approval Date",
            approve: "Approve",
            attachment_date: "Attachment Date",
            new_attachment: "New Attachment",
            attachment_type: "Attachment Type",
            confirm: {
              title: "Delete Attachment?",
              description: "This will permanently delete the Attachment",
            },
            errors: {
              title: "The Title is mandatory",
              description: "The description is mandatory",
              attachment_type: "The attachment type is mandatory",
              attachment_date: "The attachment date is mandatory",
              file: "The file is mandatory",
            },
          },
          salesContractHistories: {
            title: "History",
            situation: "Situation",
            search: "Search Histories",
            add: "Add History",
            contract_title: "History",
            titleForm: "Title",
            name: "Name",
            approval_date: "Approval Date",
            approve: "Approve",
            history_date: "History Date",
            new_history: "New History",
            history: "History",
            confirm: {
              title: "Delete History?",
              description: "This will permanently delete the History",
            },
            errors: {
              title: "The Title is mandatory",
              history: "The History is mandatory",
              historyDate: "The History Date is mandatory",
            },
          },
          contractAttachmentType: {
            title: "Contract Attachment Type",
            search: "Search for a contract attachment type",
            add: "Add Contract Attachment Type",
            new: "New Contract Attachment Type",
            active: "Active",
            inactive: "Inactive",
            contract_type: "Contract Type",
            enabled: "Enable",
            name: "Name",
            status: "Status",
            confirm: {
              title: "Delete contract attachment type?",
              description:
                "This will permanently delete the contract attachment type",
            },
            errors: {
              name: "The name is mandatory",
              contract_type: "The contract type is mandatory",
            },
          },
          contractTerminationReason: {
            title: "Contract Termination Reason",
            search: "Search for a contract termination reason",
            add: "Add Contract Termination Reason",
            new: "New Contract Termination Reason",
            active: "Active",
            code: "Code",
            inactive: "Inactive",
            contract_type: "Contract Type",
            enabled: "Enable",
            name: "Name",
            status: "Status",
            confirm: {
              title: "Delete contract termination reason?",
              description:
                "This will permanently delete the contract termination reason",
            },
            errors: {
              name: "The name is mandatory",
              contract_type: "The contract type is mandatory",
            },
          },
          contract_classifications: {
            name: "Name",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enabled: "Enabled",
            code: "Code",
            contract_type: "Contract Type",
            contract_classification: "Contract Classification",
            search_contract_classification:
              "Search for a Contract Classification",
            add_contract_classification: "Add Contract Classification",
            new_contract_classification: "New Contract Classification",
            confirm: {
              title: "Delete contract classification?",
              description:
                "This will permanently delete the contract classification",
            },
            errors: {
              name: "The name is mandatory",
              contract_type: "The contract type is mandatory",
            },
          },
          baseContracts: {
            title: "Benefits and Advantages Club",
            search: "Search Benefits and Advantages Club",
            add: "Add Benefits and Advantages Club",
            contratation_date: "Contract Date",
            filter: "To filter, it is necessary to provide the dates",
            termination_date: "Termination Date",
            situation_status: "Situation Status",
            situation: "Situation",
            contract_classification: "Contract Classification",
            integration_code: "Integration Code",
            start_date: "Start date",
            end_date: "End date",
            name: "Name",
            code: "Code",
            status: "Status",
            approved: "Approved",
            canceled: "Canceled",
            pending: "Under Review",
            dateFutureFilter:
              "Start date or end date is greater than today's date",
            dateFilter: "Start date is greater than end date",
            terminated: "Terminated",
            approve: "Approve",
            cancel: "Cancel",
            terminate: "Terminate",
            reactivation: "Reactivate",
            contractualObject: {
              substipulant: "Substipulant",
              product: "Product",
            },
            confirm: {
              title: "Delete the benefits and perks club?",
              description:
                "This will permanently delete the benefits and perks club",
            },
            advantagesAndBenefitsClub: {
              title: "Advantages and Benefits Club",
              advantages_and_benefits_club_contract:
                "Advantages and Benefits Club Contracts",
              grantor: "Grantor",
              contract_classification: "Contract Classification",
              contract_number: "Contract Number",
              integration_code: "Integration Code",
              contract_title: "Contract Title",
              renewal_period: "Renewal Period (months)",
              main_contract: "Main Contract",
              situation: "Situation",
              legal_entity: "Legal Entity",
              individual_person: "Individual Person",
              contratation_data: "Contracting Data",
              contract_type: "Contract Type",
              contratation_date: "Contract Date",
              termination_date: "Termination Date",
              approval_date: "Approval Date",
              cancelation_date: "Cancellation Date",
              reactivation_date: "Reactivation Date",
              code: "Code",
              benefit_administrators: "Benefit Administrators",
              additional_data:
                "Additional Data for Advantages and Benefits Club",
              tabs: {
                contractual_object: "Contractual Objects",
                history: "History",
                contract: "Contract",
                payer: "Payers",
                attachment: "Attachment",
                beneficiary: "Beneficiary",
              },
              errors: {
                contract_date: "The contract date is mandatory",
                contract_type: "Contract Type is mandatory",
                individual_person: "The individual person is mandatory",
                legal_entity: "The legal entity is mandatory",
                renew_months: "Renewal Period is mandatory",
                grantor: "The Grantor is mandatory",
                situation: "The situation is mandatory",
                contract_classification: "Contract Classification is mandatory",
                contract_title: "Contract Title is mandatory",
              },
            },
          },
          beneficiaryClassification: {
            title: "Beneficiary Classification",
            new: "New Beneficiary Classification",
            add: "Add Beneficiary Classification",
            search: "Search for Beneficiary Classification",
            name: "Name",
            status: "Status",
            enable: "Enable",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete beneficiary classification?",
              description:
                "This will permanently delete the beneficiary classification",
            },
            errors: {
              name: "The name is mandatory",
            },
          },
          contractProductClassifications: {
            title: "Product Classifications",
            contract_product_classification: "Product Classification",
            search: "Search for a product classifications",
            name: "Name",
            status: "Status",
            active: "Active",
            code: "Code",
            inactive: "Inactive",
            enabled: "Enable",
            add: "Add Product Classification",
            new: "New Product Classification",
            contract_type: "Contract Type",
            confirm: {
              title: "Delete product classification?",
              description:
                "This will permanently delete the product classification",
            },
            errors: {
              name: "Name is mandatory",
              contract_type: "Contract Type is mandatory",
            },
          },
          channelClassifications: {
            title: "Sales Channel Classifications",
            channel_classification: "Sales Channel Classification",
            search: "Search Sales Channel Classification",
            add: "Add Sales Channel Classification",
            new: "New Sales Channel Classification",
            name: "Name",
            code: "Code",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete Sales Channel Classification",
              description:
                "This will permanently delete the sales channel classification",
            },
            errors: {
              name: "Name is mandatory",
              status: "Status is mandatory",
            },
          },
          salesChannel: {
            title: "Sales Channels",
            sales_channel: "Sales Channel",
            search: "Search Sales Channel",
            add: "Add Sales Channel",
            new: "New Sales Channel",
            legal_entity: "Legal Entity",
            individual_person: "Individual Person",
            title_placeholder: "Title",
            name: "Name",
            code: "Code",
            active: "Active",
            inactive: "Inactive",
            suspension: "Suspend",
            inactivation: "Inactive",
            reactivation: "Reactivate",
            approve: "Approve",
            approved: "Approved",
            contract_type: "Contract Type",
            enabled: "Enable",
            reactivation_date: "Reactivation Date",
            inactivation_date: "Inactivation Date",
            suspension_date: "Suspension Date",
            approval_date: "Approval Date",
            situation: "Situation",
            classification: "Classification",
            sales_channel_type: "Sales Channel Type",
            tabs: {
              sales_channel: "Sales Channel",
              seller: "Sellers",
            },
            confirm: {
              title: "Delete sales channel?",
              description: "This will permanently delete the sales channel",
            },
            errors: {
              title: "The title is mandatory",
              situation: "The situation is mandatory",
              legal_entity: "The legal entity is mandatory",
              sales_channel_type: "The sales channel type is mandatory",
              individual_person: "The individual person is mandatory",
              sales_channel_classification: "The classification is mandatory",
            },
          },
          salesContractBeneficiary: {
            title: "Beneficiary",
            search: "Search for Beneficiary",
            add: "Add Beneficiary",
            new: "New Beneficiary",
            individual_person: "Individual Person",
            code: "Code",
            integration_code: "Integration Code",
            approve: "Approve",
            cancel: "Cancel",
            reestablish: "Reestablish",
            rescind: "Rescind",
            suspend: "Suspend",
            approved: "Approved",
            canceled: "Canceled",
            under_analysis: "Under Analysis",
            rescinded: "Rescinded",
            suspended: "Suspended",
            beneficiary_card: "Beneficiary Card",
            substipulant: "Substipulant",
            admission_date: "Admission Date",
            beneficiary_holder: "Primary Beneficiary",
            original_inclusion_date: "Original Inclusion Date",
            beneficiary_classification: "Beneficiary Classification",
            type_of_holder: "Type Of Holder",
            kinship_degree: "Degree of Kinship",
            sales_product: "Product",
            sales_price_list: "Price List",
            sales_payer: "Payer",
            sales_channel: "Sales Channel",
            sales_seller: "Seller",
            reactivation_date: "Reactivation Date",
            inactivation_date: "Inactivation Date",
            suspension_date: "Suspension Date",
            approval_date: "Approval Date",
            situation: "Situation",
            confirm: {
              title: "Delete Beneficiary?",
              description: "This will permanently delete the Beneficiary",
            },
            errors: {
              situation: "The situation is mandatory",
              individual_person: "The Individual Person is mandatory",
              beneficiary_classification:
                "The beneficiary classification is mandatory",
              sales_product: "The product is mandatory",
              sales_price_list: "The price list is mandatory",
              sales_channel: "The sales channel is mandatory",
              sales_payer: "The payer is mandatory",
              sales_seller: "The seller is mandatory",
            },
          },
          salesContractBeneficiaryCard: {
            title: "Beneficiary Card",
            add: "Add Beneficiary Card",
            card_identifier: "Card Identifier",
            initial_date: "Start Date",
            end_date: "End Date",
            integration_code: "Integration Code",
            confirm: {
              title: "Delete Beneficiary Card?",
              description: "This will permanently delete the Beneficiary Card",
            },
            errors: {
              card_identifier: "The card identifier is required",
              initial_date: "The start date is required",
              end_date: "The end date is required",
            },
          },
          salesContractPayerFinantial: {
            title: "Payer Finantial",
            search: "Search for Payer Finantial",
            add: "Add Payer Finantial",
            new: "New Payer Finantial",
            mail: "Mail",
            biling_method: "Biling Method",
            monthly_payment_due_date: "Payday",
            initial_date: "Initial Date",
            end_date: "End Date",
            phone: "Phone",
            enable: "Enabled",
            history: "History",
            new_finantial: "New",
            financial: "Financial",
            whatsapp_number: "Whatsapp Number",
            observation: "Observation",
            confirm: {
              title: "Delete Payer?",
              description: "This will permanently delete the Payer",
            },
            errors: {
              biling_method: "The biling method is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              monthly_payment_due_date: "The payday is mandatory",
            },
          },
          salesContractPayer: {
            title: "Payer",
            search: "Search for Payer",
            add: "Add Payer",
            new: "New Payer",
            payer_finantial: "Payer Finantial",
            legal_entity: "Legal Entity",
            individual_person: "Individual Person",
            title_payer: "Title",
            payer: "Payer",
            address_type: "Address Type",
            address: "Address",
            payerType: "Type",
            integration_code: "Integration Code",
            code: "Code",
            active: "Active",
            inactive: "Inactive",
            suspension: "Suspend",
            inactivation: "Inactivate",
            reactivation: "Reactivate",
            approve: "Approve",
            reactivation_date: "Reactivation Date",
            inactivation_date: "Inactivation Date",
            suspension_date: "Suspension Date",
            approval_date: "Approval Date",
            situation: "Situation",
            confirm: {
              title: "Delete Payer?",
              description: "This will permanently delete the Payer",
            },
            errors: {
              situation: "The situation is mandatory",
              individual_person: "The individual person is mandatory",
              legal_entity: "The legal entity is mandatory",
              address_type: "The address type is mandatory",
              payer_title: "The title is mandatory",
              biling_method: "The biling method is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              date: "The end date must be greater than the start date",
              monthly_payment_due_date: "The payday is mandatory",
            },
          },
          salesContractSubStipulant: {
            title: "Substipulant",
            search: "Search for substipulant",
            add: "Add Substipulant",
            new: "New Substipulant",
            legal_entity: "Legal Entity",
            individual_person: "Individual Person",
            code: "Code",
            active: "Active",
            inactive: "Inactive",
            suspension: "Suspend",
            inactivation: "Inactivate",
            reactivation: "Reactivate",
            approve: "Approve",
            reactivation_date: "Reactivation Date",
            inactivation_date: "Inactivation Date",
            suspension_date: "Suspension Date",
            approval_date: "Approval Date",
            situation: "Situation",
            confirm: {
              title: "Delete Substipulant?",
              description: "This will permanently delete the Substipulant",
            },
            errors: {
              situation: "The situation is mandatory",
              individual_person: "The Individual Person is mandatory",
              legal_entity: "The Legal Entity is mandatory",
            },
          },
          salesContractHcpInclusionRule: {
            title: "Health Programs - Automatic Inclusion",
            search: "Search for an Automatic Inclusion rule",
            add: "Add Automatic Inclusion Rule",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            initial_date: "Initial Date",
            health_program: "Health Program",
            end_date: "End Date",
            confirm: {
              title: "Delete Automatic Inclusion Rule?",
              description:
                "This will permanently delete the Automatic Inclusion Rule",
            },
            errors: {
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              date: "The end date must be mandatory than the initial date",
              health_program: "The health program is mandatory",
            },
          },
          salesContractProducts: {
            title: "Product",
            add: "Add Product",
            new: "New Product",
            code: "Code",
            name: "Name",
            product: "Product",
            price_list: "Price List",
            price_list_product: "Price Lists",
            confirm: {
              title: "Delete Product?",
              description: "This will permanently delete the Product",
            },
            errors: {
              product: "The product is mandatory",
              price_list: "The price list is mandatory",
            },
          },
          salesContractsPriceList: {
            title: "Price Lists",
            price_list: "Price List",
            search: "Search for a price list",
            add: "Add Price List",
            name: "Name",
            initial_date: "Initial Date",
            end_date: "End Date",
            approval_date: "Approval Date",
            approve: "Approve",
            code: "Code",
            new_price_list: "New Price List",
            add_new_item: "Add New Item",
            degree_of_entitlement: "Degree Of Entitlement",
            items: "Items",
            price: "Price",
            initial_age: "Initial Age",
            end_age: "End Age",
            confirm: {
              title: "Delete Price List?",
              description: "This will permanently delete the Price List",
            },
            errors: {
              name: "The name is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              code: "The code is mandatory",
              price: "The price is mandatory",
              degree_of_entitlement: "The degree of entitlement is mandatory",
              sales_contract_price_list_items: "At least one item is mandatory",
            },
          },
          salesSeller: {
            title: "Seller",
            title_seller: "Seller Title",
            search: "Search Seller",
            add: "Add Seller",
            new: "New Seller",
            individual: "Individual",
            active: "Active",
            inactive: "Inactive",
            suspension: "Suspend",
            inactivation: "Inactive",
            code: "Code",
            reactivation: "Reactivate",
            approve: "Approve",
            suspended: "Suspended",
            approved: "Approved",
            reactivation_date: "Reactivation Date",
            inactivation_date: "Inactivation Date",
            suspension_date: "Suspension Date",
            approval_date: "Approval Date",
            situation: "Situation",
            confirm: {
              title: "Delete seller?",
              description: "This will permanently delete the seller",
            },
            errors: {
              title: "The title seller is mandatory",
              situation: "The situation is mandatory",
              individual: "The lindividual is mandatory",
            },
          },
          contractProducts: {
            tabs: {
              products: "Products",
              price: "Price",
              history: "History",
              priceList: "Price Lists",
            },
            products: {
              title: "Products",
              product: "Product",
              situation: "Situation",
              new_product: "New Procuct",
              search: "Search Products",
              add: "Add Product",
              contract_title: "Contract Title",
              name: "Name",
              active: "Active",
              inactive: "Inactive",
              approved: "Approved",
              canceled: "Canceled",
              suspended: "Suspended",
              reactivation_date: "Reactivation Date",
              inactivation_date: "Inactivation Date",
              suspension_date: "Suspension Date",
              approval_date: "Approval Date",
              cancelation_date: "Cancellation Date",
              suspension: "Suspend",
              inactivation: "Inactive",
              reactivation: "Reactivate",
              approve: "Approve",
              cancelation: "Cancelation",
              fantasy_name: "Fantasy Name",
              sales_contract_type: "Contract Type",
              integration_code: "Integration Code",
              sales_product_ctr_classification: "Product Classification",
              sales_grantors: "Grantors",
              code: "Code",
              confirm: {
                title: "Delete product?",
                description: "This will permanently delete the product",
              },
              errors: {
                name: "The name is mandatory",
                fantasy_name: "The fantasy name is mandatory",
                sales_grantors: "At least one grantor is mandatory",
                sales_product_ctr_classification:
                  "The product classification is mandatory",
                sales_contract_type: "The contract type is mandatory",
              },
            },
          },
          salesProductCtrPriceList: {
            title: "Price Lists",
            price_list: "Price List",
            search: "Search for a price list",
            add: "Add Price List",
            name: "Name",
            initial_date: "Initial Date",
            end_date: "End Date",
            approval_date: "Approval Date",
            approve: "Approve",
            code: "Code",
            new_price_list: "New Price List",
            add_new_item: "Add New Item",
            degree_of_entitlement: "Degree Of Entitlement",
            items: "Items",
            price: "Price",
            initial_age: "Initial Age",
            end_age: "End Age",
            confirm: {
              title: "Delete Price List?",
              description: "This will permanently delete the Price List",
            },
            errors: {
              name: "The name is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              code: "The code is mandatory",
              price: "The price is mandatory",
              degree_of_entitlement: "The degree of entitlement is mandatory",
              date: "The end date must be greater than the start date",
              age: "The final age must be greater than the initial age",
              sales_product_ctr_price_list_items:
                "At least one item is mandatory",
            },
          },
          salesProductCtrHistories: {
            title: "History",
            situation: "Situation",
            search: "Search Histories",
            add: "Add History",
            contract_title: "History",
            titleForm: "Title",
            name: "Name",
            approval_date: "Approval Date",
            approve: "Approve",
            history_date: "History Date",
            new_history: "New History",
            history: "History",
            confirm: {
              title: "Delete History?",
              description: "This will permanently delete the History",
            },
            errors: {
              title: "The Title is mandatory",
              history: "The History is mandatory",
              historyDate: "The History Date is mandatory",
            },
          },
          beneficiaryTerminationReasons: {
            title: "Beneficiary Termination Reason",
            search: "Search for Beneficiary Termination Reason",
            add: "Add Beneficiary Termination Reason",
            new: "New Beneficiary Termination Reason",
            name: "Name",
            status: "Status",
            active: "Active",
            code: "Code",
            inactive: "Inactive",
            enabled: "Enable",
            confirm: {
              title: "Delete beneficiary termination reason?",
              description:
                "This will permanently delete the beneficiary termination reason",
            },
            errors: {
              name: "The Name is mandatory",
            },
          },
          beneficiaryCancellationsReason: {
            title: "Beneficiary Cancellation Reason",
            search: "Search by Beneficiary Cancellation Reason",
            add: "Add Beneficiary Cancellation Reason",
            new: "New Beneficiary Cancellation Reason",
            name: "Name",
            status: "Status",
            code: "Code",
            inactive: "Inactive",
            active: "Active",
            enable: "Enable",
            confirm: {
              title: "Delete the beneficiary cancellation reason?",
              description:
                "This will permanently delete the beneficiary cancellation reason",
            },
            errors: {
              name: "The name is mandatory",
            },
          },
          beneficiarySuspensionsReason: {
            title: "Beneficiary Suspension Reason",
            search: "Search for Beneficiary Suspension Reason",
            add: "Add Beneficiary Suspension Reason",
            new: "New Beneficiary Suspension Reason",
            enable: "Enable",
            name: "Name",
            code: "Code",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete the beneficiary suspension reason?",
              description:
                "This will permanently delete the beneficiary suspension reason",
            },
            errors: {
              name: "Name is mandatory",
            },
          },
        },
      },
      assessments: {
        questions: {
          questions: "Questions",
          question: "Question",
          always_visible:
            "Keep justification/comment always visible to the respondent",
          new_question: "New question",
          add_question: "Add question",
          search: "Search for a question",
          question_evaluation_type: "Question evaluation type",
          integration_id: "Integration id",
          title: "Title",
          description: "Description",
          is_required: "Mandatory Answer",
          min_chars: "Minimum Characters",
          question_category: "Question category",
          created: "Created",
          required_justification: "Require/force justification",
          required_justification_less_than: "Require justification below",
          required_justification_options:
            "Require justification for these alternatives (comma-separated)",
          required_justification_options_tooltip:
            "Require justification for the alternatives below based on the `Reference Value` field (comma-separated values)",
          alternatives_integration_id_tooltip:
            "In Tasy, set each alternative's integration ID using two digits (01, 02, 03...), in the same order as the options.",
          required_justification_min_chars: "Minimum number of characters",
          required_justification_message: "Justification text",
          guidance_text_position: "Show guidance text:",
          guidance_text: "Guidance text:",
          category: {
            label: "Category",
            no_options_text: "No categories selected",
            options_button_label: "Search category",
            drawer_props: {
              title: "Select category",
              search_placeholder: "Search categories",
              create_button_label: "Create category",
              apply_button_label: "Apply category",
              input_label: "Category name",
              delete_confirm: {
                title: "Delete category",
                message:
                  "This will delete the category and all related categories",
              },
            },
          },
          confirm: {
            title: "Delete question?",
            description: "This will permanently delete the question",
          },
          errors: {
            integration_id: "The integration id is mandatory",
            title: "The title is mandatory",
            description: "The description is mandatory",
            question_evaluation_type:
              "The question evaluation type is mandatory",
            question_category: "The question category is mandatory",
            required_justification_less_than:
              "The 'required justification below' is mandatory",
            required_justification_options:
              "Enter the reference values separated by commas",
            required_justification_min_chars:
              "The minimum number of characters is mandatory",
            required_justification_message:
              "The justification text is mandatory",
            min_chars: "The minimum number of characters is mandatory",
          },
        },
      },
      logs: {
        dateRange: {
          title: "Date Range",
          today: "Today",
          this_week: "This week",
          this_month: "This month",
          last_month: "Last month",
          last_30_days: "Last 30 days",
          last_6_months: "Last 6 months",
          select_period: "Select period",
          filterBy: "Filter by",
        },
        healthChecks: {
          health_checks: "Health Checks",
          name: "Name",
          data: "Data",
          start_date: "Start date",
          end_date: "End date",
          created: "Creation date",
          search: "Search for a health checks log",
        },
        logRegisterError: {
          errorMessage: "Error message",
          document: "Document",
          title: "Registration errors",
          created: "Date",
          start_date: "Start date",
          end_date: "End date",
          confirm: {
            confirm: {
              title: "Delete error log?",
              description: "This will permanently delete the log",
            },
          },
          placeholder: "Search for some CPF",
        },
      },
      evaluation: {
        forms: {
          forms: "Forms",
          form: "Form",
          new_form: "New form",
          search: "Search for a form",
          add_form: "Add form",
          type_form: "Type Form",
          answered_form: "Way to start filling in the answers",
          layout_form: "Presentation Format",
          title: "Title",
          description: "Description",
          show_link_on_end: "Offer evaluation link to NPS promoters",
          show_link_greater_than: "Minimum score",
          response_time_limit_hours: "Limit response time to hours",
          show_link_link: "Link",
          show_link_description: "Engagement text",
          show_link_button_label: "Button label",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          release_status: "Release status",
          awaiting_release: "Awaiting release",
          released: "Released",
          release_form: "Release Form",
          undo_release: "Undo Release",
          clone_form: "Clone Form",
          cancel_action: "Cancel",
          continue_action: "Continue",
          release_requires_question:
            "The form must have at least one question before it can be released.",
          released_form_warning:
            "This form has been released. Only the title and status can be edited.",
          locked_question_warning:
            "This question is linked to a released form and cannot be edited or deleted.",
          release_confirm: {
            title: "Release form?",
            description:
              "Releasing the form will lock it and its linked questions for editing. Do you want to continue?",
          },
          clone_confirm: {
            title: "Clone form?",
            description:
              "The form and all its linked questions will be cloned. Do you want to continue?",
          },
          extension: "Application/Site/App",
          initial_date: "Start of term",
          end_date: "End of validity",
          domains: {
            domains: "Domains",
            tooltip: "Copy form sharing link for use in templates",
            copied_successfully: "Link copied successfully",
          },
          select_questions: {
            questions: "Questions",
            display_order: "Order",
            title: "Title",
            type: "Type",
            add_button: "Add questions",
            modal_title: "Select questions",
            modal_add_button: "Add questions",
            modal_remove_button: "Remove questions",
            search: "Search for a question",
          },
          confirm: {
            title: "Delete form?",
            description: "This will permanently delete the form",
          },
          errors: {
            type: "The type is mandatory",
            title: "The title is mandatory",
            site_app_extension: "The application/site/app is mandatory",
            initial_date: "The start of term date is mandatory",
            end_date: "The end of validity date is mandatory",
            bigger_date:
              "The start of term date cannot be greater than the end of validity date",
            description: "The description is mandatory",
            questions: "At least one question is mandatory",
            order: "The order must be greater than or equal to 1",
            duplicate_order: "Duplicate orders are not allowed",
            visual_description: "The visual description is mandatory",
            response_time_limit_hours: "Enter an integer greater than zero",
            show_link_greater_than: "The minimum score is mandatory",
            show_link_link: "The link is mandatory",
            show_link_description: "The engagement text is mandatory",
            show_link_button_label: "The button label is mandatory",
            layoutForm: "The presentation format is mandatory",
            answeredForm:
              "The way to start filling in the answers is mandatory",
            typeForm: "The type form is mandatory",
          },
        },
        logs: {
          id: "Evaluation Id",
          title: "Integration logs",
          evaluationForm: "Form",
          ticket: "Ticket (card)",
          attempts: "Attempts",
          start_date: "Start date",
          end_date: "End date",
          shippingDate: "Shipping Date",
          answerDate: "Response date",
          encounterIntegrationId: "Service number",
          errorMessage: "Error message",
          copy: "Copy",
          copied_successfully: "Survey link copied successfully",
          ticketChannel: "Board",
          ticketMembers: "Ticket members",
          externalUrl: "External URL",
        },
      },
      "4uDonation": {
        donors: {
          title: "Donors",
          name: "Name",
          search: "Search for a donor",
          add: "Add Donor",
          new: "New Donor",
          donor: "Donor",
          document: "Document",
          new_donor: "New Donor",
          donor_code: "Donor Code",
          whatsapp_contacts: "WhatsApp Contacts",
          donor_integration_id: "Donor Integration ID",
          attendant_integration_id: "Attendant Integration ID",
          attendant: "Attendant",
          confirm: {
            title: "Delete Donor?",
            description: "This will permanently delete the donor",
          },
          form: {
            name: "Name",
            document: {
              cpf: "CPF",
              cnpj: "CNPJ",
            },
            entityType: "Entity",
            individual_person: "Individual",
            legal_entity: "Legal Entity",
            birth_date: "Date of Birth",
            incorporation_date: "Date of Incorporation",
            donor_type: "Donor Entity",
            gender: "Gender",
            contacts: "Contacts",
            new_contact: "New Contact",
            addresses: "Addresses",
            new_address: "New Address",
            contact_type: "Contact Type",
            ddi: "DDI",
            contact_number: "Contact Number",
            integration_id: "Integration ID",
            attendant: "Attendant",
            attendant_secondary: "Secondary Attendant",
            user_integration_type: "User Integration Type",
            errors: {
              name: "Name is mandatory",
              document: "Document is mandatory",
              user_integration_type: "The user integration type is mandatory",
              value: "Enter a phone number",
              zipCode: "Enter a valid ZIP code",
              addressDescription: "Enter the street",
              number: "Enter the number",
              addressTypeId: "Select the address type",
            },
          },
        },
      },
      "4uDlist": {
        listClassification: {
          title: "Classifications",
          list_classification: "List Classification",
          search: "Search for list classification",
          add: "Add List Classification",
          new: "New List Classification",
          name: "Name",
          description: "Description",
          code: "Code",
          enable: "Enable",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete list classification?",
            description: "This will permanently delete the list classification",
          },
          errors: {
            name: "The name is mandatory",
          },
        },
        listCategory: {
          title: "Categories",
          list_category: "List Category",
          search: "Search for list category",
          add: "Add List Category",
          new: "New List Category",
          name: "Name",
          description: "Description",
          enable: "Enable",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete list category?",
            description: "This will permanently delete the list category",
          },
          errors: {
            name: "The name is mandatory",
          },
        },
        listFiles: {
          title: "Importing Lists",
          list_file: "Lists File",
          search: "Search for lists file",
          add: "Add Lists File",
          new: "New Lists File",
          purposes: "Purposes",
          list_classification: "Classification",
          import_origin: "Import Origin",
          import_api_status: "API Status",
          define: "Change API Status to Definitive",
          integration_type: "Data Source System",
          download: "Download Model",
          model_file_name: "lists_file_model",
          file: "File",
          file_caption: "Only .xls or .xlsx file",
          name: "Name",
          code: "Code",
          import_status: "Import Status",
          total: "Total",
          with_error: "Error",
          with_alert: "Alert",
          converted: "Converted",
          description: "Description",
          status: "Status",
          active: "Active",
          inactive: "Inative",
          list_contacts: "Contacts List",
          convertToList: {
            name: "Name",
            description: "Description",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            convert_to_new_list: "Convert to new List",
            add_to_existing_list: "Add to existing list",
            convert: "Convert",
            converted: "List successfully converted!",
            search: "Search List",
            select_existing_list: "Select Existing List",
            select_list: "Select List",
            cancel: "Cancel",
            createList: {
              title: "List",
              new: "New List",
              name: "Name",
              description: "Description",
              list_categories: "List Categories",
              list_classifications: "List Classifications",
              integration_type: "Integration Type",
              enable: "Enable",
            },
          },
          errors: {
            purposes: "At least one purpose is mandatory",
            file: "The file is mandatory",
            list_classification: "The classification is mandatory",
          },
        },
        listImportAutomation: {
          title: "Automation to Generate Distribution Lists",
          list_import_automation: "List Import Automation",
          search: "Search for list import automation",
          add: "Add List Import Automation",
          new: "New List Import Automation",
          active: "Active",
          enabled: "Yes",
          disabled: "No",
          enable: "Enable",
          name: "Name",
          initial_date: "Start Date",
          end_date: "End Date",
          description: "Description",
          created_successfully: "List Import Automation created successfully",
          classifications: "Classifications",
          dlist_classifications: {
            search: "Search for classification",
            add_classification: "Add Classification",
            list_classification: "Classification",
            title: "Classification",
            new: "New Classification",
            confirm: {
              title: "Delete the Classification?",
              description: "This will permanently delete the Classification",
            },
            errors: {
              list_classification: "The classification is required",
            },
          },
          confirm: {
            title: "Delete list import automation?",
            description:
              "This will permanently delete the list import automation",
          },
          errors: {
            name: "Name is required",
            initial_date: "Start date is required",
            end_date: "End date is required",
            end_date_less: "End date cannot be earlier than the start date",
          },
        },
        list: {
          title: "Distribution List",
          list: "List Control",
          search: "Search for a list control",
          list_contacts: "Contacts List",
          add: "Add List Control",
          new: "New List Control",
          name: "Name",
          integration_type: "Integration Type",
          list_categories: "List Categories",
          list_classifications: "List Classifications",
          created_date: "Created At",
          category: "Category",
          classification: "Classification",
          description: "Description",
          enable: "Enable",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete campaign?",
            description: "This will permanently delete the campaign",
          },
          errors: {
            name: "The name is mandatory",
            name_max_length: "The name must have at most 255 characters",
            type: "The type is mandatory",
            list_categories: "At least one category is required",
            list_classifications: "At least one classification is required",
            integration_type: "Integration type is required",
          },
        },
        listContacts: {
          title: "Contact Listing",
          name: "Name",
          document: "Document",
          mail: "Email",
          whatsapp_number: "WhatsApp",
          phone: "Phone Number",
          search: "Search for a contact",
          contact_detail: "Contact Details",
          modal: {
            title: "Contact Details",
            address_city_name: "City",
            address_complement: "Address Complement",
            address_description: "Street",
            address_neighborhood_name: "Neighborhood",
            address_number: "Address Number",
            address_province_name: "State",
            address_zip_code: "ZIP Code",
            attendant_integration_id: "Attendant Integration Code",
            beneficiary_integration_id: "Beneficiary Integration Code",
            code: "Code",
            date_of_birth: "Date of Birth",
            document: "Document",
            donor: "Donor",
            enable: "Active",
            errors: "Errors",
            disable: "Inactive",
            event_date: "Event Date",
            event_number_control: "Event Number Control",
            facebook: "Facebook",
            instagram: "Instagram",
            linkedin: "LinkedIn",
            list_import_batch: "File",
            list_import_contact_status: "Status",
            mail: "Email",
            name: "Name",
            occurrence_date: "Occurrence Date",
            person_integration_id: "Person Integration Code",
            phone: "Phone",
            telegram_number: "Telegram Number",
            trigger_date: "Trigger Date",
            trigger_priority: "Trigger Priority",
            whats_app_number: "WhatsApp Number",
            is_deleted: "Status",
            warnings: "Warnings",
            donor_integration_id: "Donor Integration Code",
            list: "List Name",
            main_message: "Main Message",
            subject: "Subject",
            comment: "Comment",
            alert: "Alert",
            orientation: "Orientation",
          },
        },
        generationRule: {
          generation_rules: "Generation Rules",
          generation_rule: "Generation Rule",
          search: "Search for generation rules",
          add_generation_rule: "Add Generation Rule",
          new_generation_rule: "New Generation Rule",
          name: "Name",
          data_origin: "Data Origin",
          created_successfully: "Generation rule created successfully!",
          individual_title: "Individual",
          employee_title: "Employee",
          doctor_title: "Doctor",
          beneficiary_title: "Beneficiary",
          schedule_title: "Schedules",
          service_period_title: "Service Period",
          individual: {
            individuals: "Individuals",
            individual: "Individual",
            search: "Search for individual",
            add_individual: "Add Individual",
            new_individual: "New Individual",
            sex: "Sex",
            age: "Age",
            confirm: {
              title: "Delete the individual?",
              description: "This will permanently delete the individual",
            },
            errors: {
              sex: "Sex is required",
              age: "Age is required",
            },
          },
          employee: {
            employees: "Employees",
            employee: "Employee",
            search: "Search for employee",
            add_employee: "Add Employee",
            new_employee: "New Employee",
            sector: "Sector",
            confirm: {
              title: "Delete the employee?",
              description: "This will permanently delete the employee",
            },
            errors: {
              sector: "Sector is required",
            },
          },
          doctor: {
            doctors: "Doctors",
            doctor: "Doctor",
            search: "Search for doctor",
            add_doctor: "Add Doctor",
            new_doctor: "New Doctor",
            sector: "Sector",
            confirm: {
              title: "Delete the doctor?",
              description: "This will permanently delete the doctor",
            },
            errors: {
              sector: "Sector is required",
            },
          },
          beneficiary: {
            beneficiaries: "Beneficiaries",
            beneficiary: "Beneficiary",
            search: "Search for beneficiary",
            add_beneficiary: "Add Beneficiary",
            new_beneficiary: "New Beneficiary",
            ownership: "Ownership",
            confirm: {
              title: "Delete the beneficiary?",
              description: "This will permanently delete the beneficiary",
            },
          },
          schedule: {
            schedules: "Schedules",
            schedule: "Schedule",
            search: "Search for schedule",
            add_schedule: "Add Schedule",
            new_schedule: "New Schedule",
            identifier: "Identifier",
            confirm: {
              title: "Delete the schedule?",
              description: "This will permanently delete the schedule",
            },
            errors: {
              identifier: "The identifier is required",
            },
          },
          servicePeriod: {
            service_periods: "Service Periods",
            service_period: "Service Period",
            search: "Search for service period",
            add_service_period: "Add Service Period",
            new_service_period: "New Service Period",
            start_date: "Start Date",
            end_date: "End Date",
            service_types: "Service Types",
            confirm: {
              title: "Delete the service period?",
              description: "This will permanently delete the service period",
            },
            errors: {
              start_date: "The start date is required",
              end_date: "The end date is required",
              service_type: "Select at least one service type",
            },
          },
          confirm: {
            title: "Delete the generation rule?",
            description: "This will permanently delete the generation rule",
          },
          errors: {
            name: "The name is required",
            data_origin: "The data origin is required",
          },
        },
        listGeneration: {
          lists_generation: "List Generation",
          list_generation: "List Generation",
          search: "Search for list generation",
          add_list_generation: "Add List Generation",
          new_list_generation: "New List Generation",
          generate_list: "Generate List",
          generated_successfully: "List generated successfully!",
          name: "Name",
          generation_rule: "Generation Rule",
          confirm: {
            title: "Delete the list generation?",
            description: "This will permanently delete the list generation",
          },
          errors: {
            name: "The name is required",
            generation_rule: "The generation rule is required",
          },
        },
      },
      "4uMarCom": {
        campaigns: {
          title: "Campaign Registrations",
          campaign: "Campaign",
          search: "Search for a campaign",
          add: "Add Campaign",
          new: "New Campaign",
          name: "Name",
          description: "Description",
          type: "Type",
          enable: "Enable",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          confirm: {
            title: "Delete campaign?",
            description: "This will permanently delete the campaign",
          },
          errors: {
            name: "The name is mandatory",
            type: "The type is mandatory",
          },
        },
        communicationPermissions: {
          title: "Communication Permission",
          communication_permissions: "Communication Permission",
          search: "Search for communication permission",
          name: "Name",
          type: "Type",
          document: "Document",
          birthOfDate: "Date of Birth",
        },
        automationRules: {
          title: "Automation Rules",
          automation_rule: "Automation Rules",
          search: "Search for automation rules",
          add: "Add Automation Rule",
          new: "New Automation Rule",
          created_by: "Created by",
          name: "Name",
          enable: "Enable",
          type: "Type",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          distribution_list: "Distribution List",
          classifications: "Classifications",
          categories: "Categories",
          time_rule: "Time Rule",
          messages: "Messages",
          send_service: "Sending Service",
          marcom_type: "MarCom Type",
          send_ype: "Send Type",
          campaign: "Campaign",
          confirm: {
            title: "Delete automation rule?",
            description: "This will permanently delete the automation rule",
          },
          errors: {
            name: "Name is mandatory",
            type: "Type is mandatory",
            marcom_type: "MarCom type is mandatory",
            send_type: "Send type is mandatory",
            campaign: "Campaign is mandatory",
          },
          ticketautomationRules: {
            automation_rules: "Automation Rules",
            automation_rule: "Automation Rule",
            new_automation_rule: "New automation rule",
            search: "Search for an automation rule",
            add_automation_rule: "Add automation rule",
            name: "Name",
            automation: "Automation",
            ticket_channels: "Boards",
            ticket_channels_subtitle:
              "If no board is specified, the rule will be available for all boards",
            add_ticket_channels: "Boards added",
            automation_message_ticket_automation_template:
              "Template after Response",
            created_by: "Created by",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            event: "Event",
            ticket_service: "Ticket(card) service",
            action_after_24_hours: "Action after 24 hours",
            select_action_after_24_hours: "Select the action after 24 hours",
            restart_conversation: "Restart conversation",
            new_contact_attempt: "New contact attempt",
            both: "Both",
            no_action: "No action",
            initial_date: "Initial date",
            end_date: "End date",
            whatsapp_template: "WhatsApp template",
            automation_message_ticket_defaul_doc: "Default Document",
            automation_tasy_orientation: "Tasy Orientation",
            robot: "Robot",
            attendant: "Attendant",
            pendent: "Pending Submission",
            when_error: "When there is an error when send the template",
            when_blacklist: "When the contact is on the blacklist",
            board: "Board",
            list: "List",
            time_rule: "Time rule",
            automation_message: "Automation message",
            messages: "Messages",
            created_successfully: "Automation rule created successfully",
            confirm: {
              title: "Delete automation rule?",
              description: "This will permanently delete the automation rule",
            },
            errors: {
              name: "The name is mandatory",
              ticket_automation: "The automation is mandatory",
              ticket_event: "The event is mandatory",
              ticket_service: "The ticket(card) service is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              ticket_automation_template: "The WhatsApp template is mandatory",
              ticket_channel_step_robot: "The list for the robot is mandatory",
              ticket_channel_step_attendant:
                "The list for the attendant is mandatory",
              ticket_channel_step_pendent:
                "The list for the pending submission is mandatory",
              action_after_24_hours: "The action after 24 hours is mandatory",
              initial_date_bigger:
                "The initial date must be less than the end date",
            },
          },
          marcom_categories: {
            title: "Categories",
            new: "New Category",
            list_category: "Category",
            add_category: "Add Category",
            search: "Search for category",
            confirm: {
              title: "Delete category?",
              description: "This will permanently delete the category",
            },
            errors: { list_category: "Category is mandatory" },
          },
          marcom_classifications: {
            title: "Classifications",
            new: "New Classification",
            list_classification: "Classification",
            add_classification: "Add Classification",
            search: "Search for classification",
            confirm: {
              title: "Delete classification?",
              description: "This will permanently delete the classification",
            },
            errors: {
              list_classification: "Classification is mandatory",
            },
          },
          marcom_distributionList: {
            title: "Distribution List",
            new: "New Distribution List",
            list: "List",
            add_List: "Add List",
            search: "Search for list",
            confirm: {
              title: "Delete list?",
              description: "This will permanently delete the list",
            },
            errors: { list: "List is mandatory" },
          },
          marcom_message: {
            message: "Message",
            new_message: "New Message",
            name: "Name",
            start_date: "Start Date",
            end_date: "End Date",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            search: "Search for message",
            add_message: "Add Message",
            enable: "Enable",
            exception: "Exception",
            isMoveHumanAttendant: "Move to assigned agent (member)",
            priority: "Priority",
            ticket_flow_pattern: "Ticket flow pattern",
            opened_with_flow_direction: "Opened with flow direction",
            finished_from_start: "Finished from the start of the trigger",
            ticket_channel: "Board",
            ticket_channel_step: "List",
            ticket_automation_received_rule: "Received Rule",
            ticket_automation_received_rule_info:
              "For correct operation, we recommend using a template with Yes/No buttons",
            move_ticket_when_not_identified:
              "Move when the response is not identified",
            confirm: {
              title: "Delete message?",
              description: "This will permanently delete the message",
            },
            errors: {
              name: "Name is mandatory",
              start_date: "Start date is mandatory",
              end_date: "End date is mandatory",
              ticket_channel: "Board is mandatory",
              ticket_channel_step: "List is mandatory",
              ticket_automation_received_rule: "Received rule is mandatory",
              ticket_channel_when_not_identified: "Board is mandatory",
              ticket_channel_step_when_not_identified: "List is mandatory",
            },
          },
          marcom_timerule: {
            time_rule: "Time Rule",
            new_time_rule: "New Time Rule",
            time_classification: "Time Classification",
            type: "Type",
            value: "Value",
            add_time_rule: "Add Time Rule",
            search: "Search for time rule",
            confirm: {
              title: "Delete time rule?",
              description: "This will permanently delete the time rule",
            },
            errors: {
              time_classification: "Time classification is mandatory",
              type: "Type is mandatory",
              value: "Value is mandatory",
            },
          },
        },
      },
    },
    components: {
      usecopy: {
        copied_successfully: "Copied successfully",
        copied_error: "Could not copy",
      },
      copyButton: {
        copy: "Copy",
      },
      content: {
        add_new_content: "Add content",
        add_new_video: "Add videos",
        contents: "Contents",
        content_type: "News type",
        content_status: "News status",
        enable: "Enable",
        reading_time: "Reading time",
        reading_time_info: "Time in minutes",
        site_app: "Applications",
        title: "Title",
        language: "Language",
        language_tooltip: "View language",
        summary: "Summary",
        publication_date: "Publication date",
        content_tags: "News tags",
        is_published: "Publish",
        status: "Status",
        published: "Published",
        not_published: "Not published",
        enabled: "Active",
        inactive: "Inactive",
        link: "Link",
        display_order: "Display Order",
        link_helper: "Add a Youtube link",
        videos: "Videos",
        highlight_end: "Highlight started at",
        highlight_start: "Highlight ended at",
        confirm: {
          title: "Delete news?",
          description: "This will permanently delete the news",
        },
        errors: {
          reading_time: "The reading time is mandatory",
          site_apps: "At least one application is mandatory",
          language: "The language is mandatory",
          link: "The link is invalid.Please add a Youtube link",
          title: "The title is mandatory",
          tags: "At least one news tag is mandatory",
          summary: "The summary is mandatory",
          content: "The content is mandatory",
          contents: "At least one content is mandatory",
          file: "The file is mandatory",
          display_order: "The display order is mandatory",
          highlight_end: "The end date cannot be greater than the start date",
        },
      },
      schedule: {
        selectAll: "Select all",
        seeMore: "View more {{quantity}}",
        day: "Day",
        week: "Week",
        month: "Month",
        today: "Today",
        newSchedule: {
          date: "Data",
          required: "Required field",
          hour: "Time",
          professional: "Professional",
          type: "Type of scheduling",
          duration: "Duration",
          button: "Schedule",
          title: "New scheduling",
          confirm_contact_phone: "Confirm your contact phone",
          main_whatsapp_number: "This is my main WhatsApp",
          phone_number: "Phone Number",
          insurance: {
            add: "Add Agreement",
            edit: "Edit agreement",
            number: {
              label: "Card number (optional)",
              error: "The number is mandatory",
            },
            validity: {
              label: "Card Validity (optional)",
              error: "Validity is mandatory",
            },
            individual: {
              label: "Patient",
              error: "The patient is mandatory",
            },
            insurance: {
              label: "Health insurance",
              error: "The agreement is mandatory",
            },
          },
        },
        menu: {
          source: {
            both: "All",
          },
          exams: "Tests",
          subtitle: {
            title: "Legend",
            someFree: "There are free",
            full: "All busy",
            allFree: "All free",
          },
          period: "Period",
          situation: "Situation",
          both: "Both",
          specialitys: "Specialties",
          professionals: {
            label: "Professionals",
            noOptionsText: "No professionals found",
            loading: "Loading...",
          },
        },

        schedulePopover: {
          copy: "Copy identifier",
          copyCardNumber: "Copy card number",
          insurance: "Insurance",
          cancel: "Cancel Schedule",
          confirm: "Confirm cancellation",
          cancelButton: "Cancel",
          justification: {
            label: "Justification",
            placeholder: "Enter a justification",
            error: "The justification is mandatory",
          },
          reason: {
            label: "Reason",
            placeholder: "Select a reason",
            error: "The reason is mandatory",
          },
          cancelDescription:
            "Cancel query {{pacient}} with {{doctor}} at {{date}}",
        },
      },
      scheduleAssistant: {
        button: "Scheduling assistant",
        insurance: {
          title: "My Agreements",
          subtitle: "Manage your agreements and those of the family group",
          add: "To add",
          insuranceName: "Insurance",
          individual: "Individual",
          cardNumber: "Card number",
          cardValidity: "Validity",
          delete: {
            title: "Delete an agreement?",
            description: "This action is permanent!",
            confirmationText: "Yes, delete",
            cancellationText: "Cancel",
          },
          addInsurance: {
            edit: "Edit agreement",
            add: "Add Agreement",
            buttonSave: "To save",
            buttonEdit: "To edit",
            number: {
              label: "Card number (optional)",
              error: "The number is mandatory",
            },
            validity: {
              label: "Card Validity (optional)",
              error: "Validity is mandatory",
            },
            individual: {
              label: "Patient",
              error: "The patient is mandatory",
            },
            insurance: {
              label: "Health insurance",
              error: "The agreement is mandatory",
            },
          },
        },
        newSchedule: {
          success: "Successful registered scheduling",
          sched: "Schedule",
          notAvaiableModal: {
            button: "Ok",
            description:
              "The time chosen is no longer available, please select another time.",
          },
          next: "Next",
          back: "Back",
          finish: "Finish",
          steps: {
            patient: {
              title: "Select the patient",
              error: "The patient is mandatory",
            },
            insurance: {
              title: "Select the agreement",
              error: "The agreement is mandatory",
            },
            search: {
              title: "Search for an schedule",
              specialityError: "The specialty is mandatory",
              periodError: "The period is mandatory",
              examError: "The exam is mandatoryo",
            },
            schedule: {
              title: "Select a date and time",
              error: "The time is mandatory",
            },
            confirm: "Confirm data",
          },
          insurance: "Health insurance",
          addInsurance: "Add Agreement",
          addFamilyGroup: "Add familiar",
          search: {
            from: "From",
            examGroup: "Exam",
            professional: "Professional (optional)",
            speciality: "Specialty",
            type: "Type of scheduling",
            period: "Period",
          },
          schedule: {
            freeDays: "Days with available dates",
          },
          confirm: {
            descriptionSite: "Professional",
            patient: "Patient",
            insurance: "Health insurance",
            schedule: "Scheduling",
            confirm_contact_phone: "Confirm your contact phone",
            main_whatsapp_number: "This is my main WhatsApp",
            phone_number: "Phone Number",
          },
        },
      },
      panel: {
        add_dashboard: "Add dashboard",
        select: "Select and order the components",
        helper_text: "Dashboard must have at least one component",
        no_data: "No data",
        not_found: "Panel not found",
        no_dashboards: "No dashboard found, add your first dashboard!",
        reviews: "reviews",
        search_placeholder: "Search for a name",
        order: "Ordering",
        name: "Name",
        value: "Value",
        attendant: "Attendant",
        xAxis: "Hours",
        ticketChannelName: "Board",
        count: "Quantity",
        search: "Search for a component",
        select_all: "Select all",
        select_components: "Select the components",
        next: "Next",
        average_asc: "Lowest Grade",
        average_desc: "Highest Grade",
        view_comments: "View comments",
        comments: "Comments",
        delete_dashboard: {
          delete: "Delete dashboard",
          title: "Delete dsahboard {{ name }}",
          description:
            "This will permanently delete your dashboards and your data.",
          cancel: "Cancel",
          confirm: "Yes, delete",
        },
        select_tooltip: "Selecionar e ordenar componentes",
        filters: "Filters:",
        filters_modal: {
          filters: "Applied Filters",
          tooltip: "View applied filters",
        },
        filter: {
          day: "Day",
          week: "Week",
          month: "Month",
          year: "Year",
        },
        helper: {
          title: "Dashboard data information",
          first:
            "Dashboard data is updated automatically once a day, overnight, always covering information up to the previous day.",
          second:
            "<1>Daily:</1> shows the data for a single day. Today's information becomes available the following night.",
          third:
            "<1>Weekly:</1> the week runs from Monday to Sunday. The current week is updated daily with data up to the previous day and becomes complete in the early hours of Monday.",
          fourth:
            "<1>Monthly:</1> the current month is updated daily with data up to the previous day and becomes complete in the early hours of the 1st of the following month.",
          fifth:
            "<1>Yearly:</1> the current year is updated daily with data up to the previous day and becomes complete in the early hours of January 1st.",
          sixth:
            "<1>New dashboards and components:</1> when you add a dashboard or enable a component, its data history is processed in the background and may take a few minutes to be fully displayed.",
        },
        enable_component: {
          title: "Enable component",
          title_all: "Enable all components",
          description:
            "When you enable this component, its entire data history will be processed in the background. It may take a few minutes to be fully displayed on the dashboard. Do you want to continue?",
          description_all:
            "When you enable the components, the data history of each one will be processed in the background. It may take a few minutes to be fully displayed on the dashboard. Do you want to continue?",
          cancel: "Cancel",
          confirm: "Yes, enable",
        },
      },
      selectBool: {
        true: "True",
        false: "False",
      },
      menu: {
        home: {
          home: "Home",
          begin: "Summary",
          dashboard: "Painel",
        },
        myDashboards: {
          myDashboards: "Dashboards",
          dashboards: "KPIs Configuration",
          view: "KPI Dashboards",
          executions: "Execution history",
          generateConfig: "Dashboards Settings",
        },
        reports: {
          reports: "Reports",
          crm: "CRM",
          internal: "Internal",
        },
        people: {
          people: "People",
          individuals: "Physical Person",
          legalEntities: "Legal Entity",
          individualValidations: "Registration Validation PF",
        },
        registers: {
          beneficiaries: "Beneficiaries",
          doctors: "Doctors",
          userProfiles: "User Profiles",
          client: "Client",
          templates: "Templates",
          integrations: "Integrations",
          profile_roles: "Profile Roles",
          documents: "Terms and Policies",
          holidays: "Holidays",
        },
        admSystem: {
          admSystem: "Adm. System",
          users: "Users",
          establishmentParams: "General Parameters",
          roles: "Profile",
          establishments: "Establishments",
          aditionalSettings: {
            aditionalSettings: "Additional Settings",
            cardsTemplates: "Cards Templates",
          },
          companygroups: "Company Groups",
          companies: "Companies",
          companyDigitalCertificates: "Digital Certificates",
        },
        globals: {
          globals: "Global",
          languages: "Languages",
          menus: "Menus",
          generics: "Generic",
          countries: "Countries",
          extensions: "Extensions",
          cities: "Cities",
          neighborhoods: "Neighborhoods",
          provinces: "States",
          banks: "Banks",
          jobs: "Jobs",
          paramsDefaultEstablishment: "Standard Establishment Parameters",
        },
        menu_secondary_item: {
          modal_title: "In development",
          modal_content:
            "We are still working on the development of this screen, soon we will have news.",
        },
        secondary_menu: {
          suport: "Suport",
          configs: "Configs",
          extensions_store: "Extensions Store",
        },
        actions: {
          help: "Help",
          notifications: "Notifications",
          change_theme: "Change Theme",
          settings: "Settings",
        },
        applications: {
          applications: "Applications",
          register: "Register",
        },
        "4uChatBot": {
          templates: {
            templates: "Templates",
            whatsapp: "WhatsApp",
            internal: "CRM Internal",
          },
          createAutomations: {
            createAutomations: "Automations",
            automationRules: "Shipping Rules",
            receivedAutomationRules: "Receiving Rules",
          },
          fluxos: {
            fluxos: "Flows",
            serviceWhatsapp: "Service WhatsApp",
          },
          logs: {
            examManagementNotificationLog: "Exam Report Email Notifications",
            logs: "Logs",
            calendarControl: "Available Slots Lookup",
            ticketsHistory: "Ticket History",
            examSchedulingAttachmentLog: "Exam Scheduling Attachments Log",
          },
          registrationsAndRules: {
            registrationsAndRules: "Registrations and Rules",
            ticketServiceArea: "Service Area",
            ticketServiceDay: "Opening Hours",
            ticketServiceMessage: "Messages",
            blacklist: "Blacklist",
            ticketFinishReason: "Ticket Closure Reason",
            ticketChannelMemberAvailabilityPauseReason: "Pause Reason",
            banList: "BanList",
            appointmentarrivalrule: "Appointment Arrival Times",
          },
        },
        "4uDonation": {
          donors: {
            donors: "Donors",
            register: "Register Donors",
          },
        },
        "4uTotem": {
          applications: {
            applications: "Applications",
            myTotens: "My Totems",
          },
          register: {
            register: "Register",
            totemDevices: "Totem Devices",
          },
        },
        evaluation: {
          evaluation: "Evaluations",
          questions: "Questions",
          evaluationForms: "Forms",
          evaluationLogs: "Integration logs",
          evaluationLogsTicket: "Ticket Satisfaction Survey Logs",
          activeServiceSearchSurvey: "Active Service Search Survey Logs",
        },
        chatBot: {
          register: "Register",
          ticket_service: "Tickets(Cards) Services",
          service: "Service",
          ticket_service_area: "Service Area",
          ticket_protocol_rule: "Protocol Generation Rules",
          ticket_service_day: "Opening Hours",
          ticket_service_message: "Messages",
        },
        logs: {
          logs: "Logs",
          healthcheck: "Health Checks",
          logRegisterError: "Register Errors",
        },
        settings: {
          system: {
            system: "System",
            generalSettings: {
              generalSettings: "Global settings",
              correios: "Correios",
              centralBank: "Banco Central",
              geolocalization: "Geolocalization",
              certillion: "Certillion",
            },
            cache: "Cache",
            paramsDefaultEstablishment: "Standard Establishment Parameters",
            executeSql: "Execute SQL",
          },
          generalSettings: {
            generalSettings: "General",
            holidays: "Holidays",
            establishmentParams: "Establishment Parameters",
            healthChecks: "4uHub Microservices Health Checks",
          },
          applications: {
            applications: "Applications",
            cardsTemplates: "Card Templates",
          },
          crm: {
            crm: "CRM",
            chatBot: {
              chatBot: "ChatBot",
              ticketServiceArea: "Service areas",
              ticketServiceMessage: "Messages",
            },
            ticketProtocolRule: "Protocol Generation Rules",
            ticketService: "Ticket(card) Service",
            ticketAutoFinishRule: "Ticket(card) Finalization Rules",
            ticketAutoTransferRule: "Ticket(card) Transfer Rules",
            ticketDefaultDocs: "Standard Guidance Protocols",
            ticketDefaultDocCategories: "Standard Guidance Protocol Categories",
            events: "Events",
            externalProcessType: "Types of External Processes",
            quickAnswer: "Quick Messages",
            sendLimitMonths: "Monthly Sending Limits (Company Budget)",
            sendLimitDiaries: "Daily Sending Limits (Allowed by WhatsApp)",
            ticketAutoInactivityRule: "Ticket(Card) Inactivity Rules",
          },
          chatBot: {
            chatBot: "ChatBot",
            ticketServiceArea: "Service Areas",
            ticketServiceMessage: "Messages",
            ticketServiceDay: "Opening Hours",
          },
          hcp: {
            hcp: "4uHcP",
            healthProgramTypes: "Types of health programs",
            workGroupTypes: "Types of work groups",
          },
          "4uBus": {
            "4uBus": "4uBus",
            ipm: {
              ipm: "IPM",
              generalSettings: "General settings",
            },
            globals: {
              globals: "General settings",
              sync: "Synchronization",
            },
            zscan: {
              zscan: "ZScan",
              examSendRule: "Exam sending rule",
            },
            externalExamPrescription: {
              externalExamPrescription:
                "Generation of External Examination Request Prescription",
              rules: "Prescription Generation Rules",
            },
          },
          "4uSched": {
            "4uSched": "4uSched",
            menuSchedulingPortalApp: "Portal and App Scheduling Menu",
            tasyCalendar: {
              tasyCalendar: "Tasy - Consultations and exams",
              checkIn: "Check in",
              confirmation: "Schedule Confirmartion",
            },
          },
          "4uSiteApp": {
            "4uSiteApp": "4uSiteApp",
            digitalTriage: {
              digitalTriage: "Check-In of Digital PA Triage",
              checkIn: "Check in",
            },
          },
        },
        "4uSiteApp": {
          applications: {
            applications: "Applications",
            register: "Register",
            myApplications: "My applications",
          },
          communication: {
            communication: "Communication",
            banners: "Banners",
            notifications: "Notifications",
            news: "News",
          },
          privacyAndSecurity: {
            privacyAndSecurity: "Privacy and Security",
            termsAndPolicies: "Terms and policies",
            loginContents: "Login Content",
          },
          sac: {
            sac: "SAC and Ombudsman",
            faq: "FAQ",
          },
          consultationsAndLogs: {
            consultationsAndLogs: "Consultation and Logs",
            beneficiarySituation: "Beneficiary situation",
          },
        },
        "4uHcP": {
          structure: {
            structure: "Program structure",
            healthPrograms: "Health programs",
            workGroups: "Working groups",
          },
          content: {
            content: "Content",
            contentRules: "Content rules",
          },
          captation: {
            captation: "Capture",
            captations: "Captations",
            imports: "Import",
          },
        },
        "4ubus": {
          automations: {
            automations: "Automations",
            fileIntegration: "File Integration",
            zscanExamSendRule: "ZScan Exam Sending Rules",
            integrationRule: "Integration Rules",
          },
          register: {
            register: "Register",
            accessTokens: "Extern tokens",
            profileTasy: "Extern Profile",
            services: "Services",
            accessTokens4uHub: "4uHub tokens",
            profile4uhub: "Profile – 4uHub Bus",
          },
          setRelationships: {
            setRelationships: "Relationships",
            ipm: "IPM x TASY",
            "4uHub": "Tasy - Call Center",
            tasyReceivePatientEncounters: "Tasy - Receive Patient Encounters",
            zscanEvo: "ZScan Evo",
            invoiceLoweringTotvs: "Tasy > TOTVS - Invoice Lowering",
            relationshipGroup: "Tasy > RNDS - SI-PNI Immunization",
            syncPhysicalPerson: "Person Sync",
            tasyToTasy: "Tasy x Tasy",
            tasyOps: "Tasy OPS - (Execução Requisição)",
          },
          restriction: {
            restriction: "Restrictions",
            rule: "Schedule",
          },
          logs: {
            logs: "Logs",
            tasyCalendar: "Tasy Calendar",
            ipmxtasyinternal: "IPM - Receive - IPM x Tasy (Interno)",
            tasyxipminternal: "IPM - Send - Tasy x IPM (Interno)",
            ipmtasy: "IPM - Receive - IPM x Tasy",
            tasyipm: "IPM - Send - Tasy x IPM",
            monitoring: "Bus Server Monitoring",
            examFilesLogIntegration: "Tasy - File Integration Log",
            accessDbObjectErrors: "Tasy object access error",
            externalLogError: "LogError",
            nfeTotvs: "NFe - TOTVS",
            syncPersons: "Sync - People data",
            forubusVaccine: "Tasy > RNDS - SI-PNI Immunization",
            refund: "Refunds",
            invoiceServiceAgy: "Tasy > Invoice Service Agy",
            patientEncounterPsTransferRequest:
              "Tasy EMR - Generate new ER Encounter, from PA encounter ineligibility",
            gerAcessoVisitControlPacient:
              "Tasy GerAcesso - Patient Companion Access Control Submission",
            gerAcessoVisitControlVisitor:
              "Tasy GerAcesso - Patient Visitor Access Control Submission",
            gerAcessoVisitControlSector:
              "Tasy GerAcesso - Sector Visitor Access Control Submission",
            invoiceLoweringTotvs: "Tasy > TOTVS - Invoice Lowering",
            tasyToTasyNonLabExamsAvailable:
              "Tasy <> Tasy - Non-laboratory Exam (Available)",
            tasyToTasyNonLabExamsReceived:
              "Tasy <> Tasy - Non-laboratory Exams (Received)",
            serviceReceived: "Tasy - Receive Appointments",
            tasyToTasyResultsNonLabAvailable:
              "Tasy <> Tasy - Non-Laboratory Exam Results (Available)",
            tasyToTasyResultsNonLabReceived:
              "Tasy <> Tasy - Non-Laboratory Exam Results (Received)",
            syncTransaction: "Sync - Transaction Data",
          },
          robots: {
            robots: "Robots",
            list: "List",
          },
        },
        "4uSalesContract": {
          register: {
            register: "Registers",
            salesGrantors: "Grantors",
            salesContractAttachmentTypes: "Contract Attachment Type",
            salesContractClassifications: "Contract Classification",
            salesProductCtrClassifications: "Product Classifications",
            salesChannelClassifications: "Sales Channel Classifications",
            salesChannels: "Sales Channels",
            salesProductCtrs: "Product",
            salesContractTerminationReason: "Contract Termination Reason",
            beneficiaryContractReasonOfTerminations:
              "Beneficiary Contract Termination Reason",
            salesContractBeneficiaryClassifications:
              "Beneficiary Classification",
            beneficiaryContractReasonOfCancellations:
              "Beneficiary Cancellation Reason",
            beneficiaryContractReasonOfSuspensions:
              "Beneficiary Suspension Reason",
          },
        },
        "4uESign": {
          createAutomations: {
            createAutomations: "Automations",
            automationRules: "Automation Rules",
            emailSendRules: "Email sending",
            signatureGroups: "Signature Groups",
          },
          logs: {
            logs: "Logs",
            forubusSignatureLogs: "Signature logs",
          },
        },
        "4uDlist": {
          register: {
            register: "Registrations",
            classification: "Classifications",
            category: "Categories",
          },
          imports: {
            imports: "Imports",
            listFiles: "Importing Lists",
            listImportAutomation: "Automation to Generate Distribution Lists",
          },
          distributionList: {
            distributionList: "Distribution List",
            list: "Distribution List",
          },
          listGenerator: {
            listGenerator: "List Generator",
            generationRules: "Generation Rules",
            generateList: "List Generation",
          },
        },
        "4uMarCom": {
          campaigns: {
            campaigns: "Campaigns",
            campaignRegister: "Campaign Registration",
          },
          templates: {
            templates: "Templates",
            whatsapp: "WhatsApp",
          },
          automations: {
            automations: "Automations",
            automationRule: "Automation Rules",
          },
          optInOptOut: {
            optInOptOut: "Opt-in / Opt-out",
            permissionCommunication: "Communication Permissions",
            distributionList: {
              distributionList: "Distribution Lists",
              list: "List Controls",
            },
          },
        },
      },
      logs_accordions: {
        user: "User:",
        duration: "Duration",
      },
      logs_table: {
        name: "Name",
        original_value: "Original values",
        new_value: "New values",
        button_see_more: "See more",
      },
      logs_no_data: {
        message: "Data not found!",
      },
      roles: {
        title: "Profile",
        name: "Name",
        establishment: "Establishment",
        search_name: "Search for a name",
        new_role: "New profile",
        privileges_tab: "Privileges",
        dashboards_tab: "Dashboards",
        reports_tab: "Reports",
        dashboard_panel: "Dashboard",
        dashboard_panels: "Dashboards",
        add_dashboard_panel: "Add dashboard",
        search_dashboard_panel: "Search dashboard",
        report: "Report",
        reports: "Reports",
        add_report: "Add report",
        search_report: "Search report",
        code: "Code",
        report_with_code: "#{{code}} - {{name}}",
        edit_link: "Edit",
        delete_link: "Remove",
        cancel: "Cancel",
      },
      roles_basic_data: {
        name: "Name",
        description: "Description",
      },
      roles_establishments: {
        title: "Establishments",
        add_establishments: "Add new establishment",
        name: "The name is mandatory",
        label: "Establishment(s) that may use this profile",
        establishmentsTypeId: "Select a establishment",
        establishments_tooltip: "See establishments",
      },
      roles_privileges: {
        title: "Privileges",
        add_privileges: "Add new privilege",
      },
      private: {
        permission: "Ooops! You don't have permission!",
      },
      forgetPasswordForm: {
        title: "Forgot password?",
        subtitle:
          "Enter your CPF below and we'll send you a code to your email to reset your password.",
        button: "Send",
        sending: "Sending",
        login: "CPF",
        login_required: "CPF is required!",
        notification_email_sent: "Email sent successfully!",
        back_login: "Back to login",
      },
      forgetPasswordModal: {
        title: "Instructions sent!",
        message:
          "We have sent password reset instructions to your email, please check all inboxes and spam folders.",
        close: "Close",
      },
      resetPasswordForm: {
        title: "New password",
        subtitle:
          "Enter the code sent to your email. If you don't find it, check your spam area.",
        password: "Password",
        confirm_password: "Confirm password",
        confirmation_code: "Confirmation code",
        sending: "Sending",
        send: "Send",
        new_password_required: "Password is required.",
        confirm_new_password_required: "Confirm password is required.",
        passwords_match: "Passwords do not match.",
        confirmation_code_required: "The confirmation code is mandatory",
        notification_password_success: "Password changed successfully!",
      },
      noRowsMessage: {
        no_permission: "You do not have permission to view the information",
        no_data: "You do not have registered information",
      },
      onPremiseModal: {
        establishment: {
          establishment_on_premise: "Establishment on premise",
          no_data: "No establishment found",
        },
        params: {
          params_on_premise: "Parameters on premise",
          no_data: "No parameter found",
        },
        generics: {
          generics_on_premise: "Generics on premise",
          no_data: "No generic found",
        },
        health: {
          health_on_premise: "Synchronized Health Plans",
          no_data: "No health plan found",
        },
        medicSpecialties: {
          no_data: "No medical specialties found",
        },
        providerTypes: {
          no_data: "No provider types found",
        },
        professionalCouncils: {
          no_data: "No professional advice found",
        },
        medicalPracticeAreas: {
          no_data: "No medical practice areas found",
        },
      },
      cardMenu: {
        button: "View more",
      },
      paramsFilter: {
        title: "Filters",
        clean_button: "Clean filter",
      },
      extensionsStoreHeader: {
        title: "Extensions store",
        search: "Search by an extension or tag",
        add_extensions: "Add extensions",
        my_extensions: "My extensions",
        back: "Back",
      },
      extensionsCard: {
        details: "Details",
        install: "Install",
        request_install: "Request installation",
        requested: "Installation requested",
        setup_requested: "Requested Setup",
        installing: "Installing",
        installed: "Installed",
        free: "Free",
        select: "Select a website",
        tooltip_install: "Installation",
        tooltip_month: "Monthly payment",
        site_app: "Sites or Apps",
        setup_cancel: "Setup Request Cancelled",
        cancel: "Cancel Setup",
        errors: {
          site_app: "Select at least on site or app to install",
        },
      },
      extensionsStoreDetail: {
        title: "Extension details",
        free: "Free",
        installed: "Installed",
        about: "About the extension",
        available_for: "Available for",
        install: "Install",
        request_install: "Request installation",
        requested: "Installation requested",
        settings: "Settings",
        configure: "Configure on",
        tooltip_install: "Install",
        tooltip_month: "Monthly payment",
        tooltip_uninstall: "Uninstall",
        tooltip_settings: "Settings",
        tags: "Tags",
        dependencies: "Dependencies",
      },
      extensionInstallPopper: {
        title: "Do you really want to install the extension?",
        request_title:
          "Do you really want to request the installation of the extension?",
        cancel: "Cancel",
        install: "Install",
        request: "Request",
      },
      extensionUninstallPopper: {
        title: "Do you really want to uninstall the extension?",
        cancel: "Cancel",
        uninstall: "Uninstall",
        uninstalling: "Uninstallling",
      },
      extensionSettings: {
        title: "Configure extension",
        identifier: "Identifier",
        property: "Property",
        value: "Value",
        description: "Description",
      },
      settingsCorreios: {
        url_token: "URL Token",
        user_token: "User Token",
        access_token: "Access Code Token",
        post_card: "Post Card",
      },
      settingsGeneral: {
        user_token: "correiosTokenUser",
        access_token: "correiosTokenAccessCode",
        post_card: "correiosTokenPostCard",
        correios_url: "Correios URL",
        correios_token_user: "correiosTokenUser",
        correios_authentication: "correiosAuthenticationUrl",
        correios_locations: "correiosLocationsUrl",
        correios_addresses: "correiosAddressesUrl",
        cep_cache_time: "cepCacheTime",
        correios_page_size: "correiosPageSize",
        bank_base: "bankBaseUrl",
        bank_cooperativas: "bankCooperativasUrl",
        bank_bancos: "bankBancosUrl",
        geolocation: "Geolocation",
        api_geocoding_key: "apiGeocodingKey",
        save: "Save",
        saving: "Saving",
        success: "General settings updated successfully",
        errors: {
          user_token: "The correiosTokenUser is mandatory",
          access_token: "The correiosTokenAccessCode is mandatory",
          post_card: "The correiosTokenPostCard is mandatory",
          correios_url: "The Correios URL is mandatory",
          correios_token_user: "The correiosTokenUser is mandatory",
          correios_authentication: "The correiosAuthenticationUrl is mandatory",
          correios_locations: "The correiosLocationsUrl is mandatory",
          correios_addresses: "The correiosAddressesUrl is mandatory",
          cep_cache_time: "The cepCacheTime is mandatory",
          bank_base: "The bankBaseUrl is mandatory",
          bank_cooperativas: "The bankCooperativasUrl is mandatory",
          bank_bancos: "The bankBancosUrl is mandatory",
          correios_page_size: "The correiosPageSize is mandatory",
          api_geocoding_key: "The apiGeocodingKey is mandatory",
        },
      },
      certillionSettings: {
        title: "Certillion Configs",
        base_url: "Base url",
        client_secret: "Client secret",
        seconds_to_find_signed_files: "Second to find signed files",
        token_path: "Token path",
        upload_file_path: "Upload file path",
        pscs_accounts_path: "Pscs accounts path",
        client_id: "Client id",
        default_minutes_signature_session: "Default minutes signature session",
        authorize_path: "Authorize path",
        signature_path: "Signature path",
        client_token_path: "Client token path",
        save: "Save",
        saving: "Saving",
        success: "Config updated",
        paths: "Paths",
        errors: {
          base_url: "Base url is mandatory",
          client_secret: "Client secret is mandatory",
          seconds_to_find_signed_files:
            "Second to find signed files is mandatory",
          token_path: "Token path is mandatory",
          upload_file_path: "Upload file path is mandatory",
          pscs_accounts_path: "Pscs accounts path is mandatory",
          client_id: "Client id is mandatory",
          default_minutes_signature_session:
            "Default minutes signature session is mandatory",
          authorize_path: "Authorize path is mandatory",
          signature_path: "Signature path is mandatory",
          client_token_path: "Client token path is mandatory",
        },
      },
      settingsCache: {
        settingsCacheTotal: {
          clean_all_cache: "Full Cache Clear (except Hangfire)",
          clean_all_description:
            "It cleans the platform's entire cache, with the exception of those managed by HangFire, our job manager.",
          clean_all_button: "Clean",
          clean_all_success: "Successfully cleared cache",
        },
        settingsCacheKey: {
          clean_key_cache: "Cache Clearing by Key (accepts partial key)",
          clean_key_description:
            "Clears the cache according to the key entered. It also accept to provide a partial key. Example: If EF_ is specified, it will clear the platform's entire Entity Framework cache. If hangfire* is informed, it will clear all cache related to our job manager.",
          clean_key: "Key",
          clean_key_button: "Clean",
          clean_key_success: "Successfully cleared cache for key '{{key}}'",
          errors: {
            cache_key: "The key is mandatory",
          },
        },
        searchCacheKey: {
          search_cache_key: "Search Cache by Key",
          search_cache_description:
            "Searches the cache according to the key entered. It also accept to provide a partial key. Example: If *EF_* is specified, it will search the platform's entire Entity Framework cache. If *HANGFIRE* is informed, it will search all cache related to our job manager.",
          search: "Search",
          search_key: "Key",
          results: "Search results for key",
          no_data: "No information found",
          errors: {
            cache_key: "The key is mandatory",
          },
        },
      },
      neighborhood: {
        neighborhood: "Neighborhood",
        other: "I didn't find my neighborhood and I want to enter a new one",
        cep: "Enter a zip code first",
      },
      addressContent: {
        cep_first: "Enter a zip code first",
      },
      appDomain: {
        domain: "Domain",
        title: "Copy domain",
      },
      nationalHolidays: {
        import_holidays: "Import national holidays",
        select_all: "Select all",
      },
      cepInput: {
        zip_code: "CEP",
        helper_text: "Enter a zip code to search",
        city: "City",
        province: "State",
      },
      daysOfWeek: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
      notificationInformations: {
        status: "Status",
        is_published: "Publication status",
        start_publish: "Start of publication",
        finish_publish: "End of publication",
        published: "Published",
        not_published: "Not published",
      },
      notificationBatchActions: {
        generate: "Generate batch",
        cancel: "Cancel batch",
        batch_generated: "Batch generated successfully",
        batch_canceled: "Batch canceled successfully",
        cancel_popover_title:
          "When canceling the batch, it will no longer be possible to generate batches for this notification.",
        users: "Notified users",
      },
      searchResults: {
        no_data: "No results found",
      },
      yearSelect: {
        label: "Filter by year",
      },
      syncSection: {
        sync: "Synchronize",
        view_data: "View integrated data",
      },
      syncEstablishment: {
        title: "Establishment",
        description:
          "Synchronize the Establishment’s data with the 4uBus environment",
        synced: "Establishment data synchronized successfully",
        modal_title: "Integrated establishment data",
      },
      syncGeneric: {
        title: "Generic",
        description:
          "Synchronize the Generic's data with the 4uBus environment",
        synced: "Generic data synchronized successfully",
        modal_title: "Integrated generic data",
      },
      syncUsers: {
        title: "User",
        description: "Synchronize the User's data with the 4uBus environment",
        synced: "User data synchronized successfully",
        modal_title: "Integrated user data",
      },
      syncPrivilege: {
        title: "Privilege",
        description:
          "Synchronize the Privilege's data with the 4uBus environment",
        synced: "Privilege data synchronized successfully",
        modal_title: "Integrated privilege data",
      },
      syncEstablishmentParam: {
        title: "Establishment param",
        description:
          "Synchronize the Establishment param's data with the 4uBus environment",
        synced: "Establishment param data synchronized successfully",
        modal_title: "Integrated establishment param data",
      },
      syncRelationshipType: {
        title: "Realationship type",
        description:
          "Synchronize the Realationship type's data with the 4uBus environment",
        synced: "Realationship type data synchronized successfully",
        modal_title: "Integrated relationship type data",
      },
      syncRelationship: {
        title: "Realationship",
        description:
          "Synchronize the Realationship's data with the 4uBus environment",
        synced: "Realationship data synchronized successfully",
        modal_title: "Integrated relationship data",
      },
      syncExtension: {
        title: "Extension",
        description:
          "Synchronize the Extension's data with the 4uBus environment",
        synced: "Extension data synchronized successfully",
        modal_title: "Integrated extension data",
      },
      integratedData: {
        no_data: "No integrated data found",
      },
      filtersActions: {
        filter: "Filter",
        clean: "Clean filters",
        refresh: "Refresh",
      },
      callToActionsButtons: {
        call_to_action: "Call to action",
        change_buttons_order: "Change the button grouping order",
      },
      quickAnswerButtons: {
        quick_aswer: "Quick answer",
        change_buttons_order: "Change the button grouping order",
      },
      buttonSetting: {
        action_type: "Action type",
      },
      accessSiteAction: {
        static: "Static",
        dynamic: "Dynamic",
        text: "Button text",
        url_type: "URL type",
        payload: "Site url",
        url_placeholder: "https://www.exemplo.com",
        url_tooltip:
          "Adding a variable creates a custom link for the customer to view their information. Only one variable can be added to the end of a URL.",
      },
      callAction: {
        text: "Button text",
        country: "Country",
        payload: "Phone",
      },
      copyOfferCodeAction: {
        text: "Button text",
        info: {
          title: "Add sample offer code",
          subtitle:
            "To help us analyze your message template, please add an example offer code.",
        },
        payload: "Offer code",
      },
      selectWhatsButtons: {
        tooltip_limit:
          "Button limit reached, to add another type of button, delete a button first",
        generate_automatically:
          "Buttons are automatically determined according to the selected automation",
        add_button: "Add a button",
        quick_answer_buttons: "Quick response buttons",
        call_to_action_buttons: "Call to action buttons",
        help: "If you add more than 3 buttons, they will appear in a list.",
        buttons_no_integligence_warning:
          "These buttons have no intelligence or automatic action from the 4uHub platform. Their use is entirely the user's responsibility and risk.",
      },
      whatsButtonsOptions: {
        personalized: {
          name: "Personalized",
        },
        access_site: {
          name: "Access site",
          description: "2 buttons maximum",
        },
        call: {
          name: "Call",
          description: "1 button maximum",
        },
        call_whats: {
          name: "Call on WhatsApp",
          description: "1 button maximum",
        },
        copy_offer_code: {
          name: "Copy offer code",
          description: "1 button maximum",
        },
      },
      customButton: {
        text: "Button text",
      },
      addVariablesButton: {
        variables: "Variables",
        variable: "Variable",
        cancel: "Cancel",
        add: "Add",
        add_variables: "Add variables",
      },
      variablesContainer: {
        title: "Example of body content",
        description:
          "To help us analyze your message template, please include an example of each variable in the body text. Do not use real customer information. The Cloud API hosted by Meta analyzes variable models and parameters to protect the security and integrity of our services.",
      },
      variableField: {
        label: "Insert content to ",
        character_limit: "Character limit",
        exceeded: "The content exceeds the character limit",
      },
      bodyInput: {
        error: "All variables must be valid",
      },
      timeRules: {
        add_time_rule: "Add time rule",
        time_classification: "Time Classification",
        type: "Type",
        value: "Value",
        search: "Search for a time rule",
        confirm: {
          title: "Delete time rule?",
          description: "This will permanently delete the time rule",
        },
        errors: {
          type: "The type is mandatory",
          time_classification: "The time classification is mandatory",
          value: "The value is mandatory",
        },
      },
      automationMessages: {
        automation_message: "Automation Message",
        new_automation_message: "New automation message",
        add_automation_message: "Add automation message",
        search: "Search for an automation message",
        automation_message_type: "Automation message type",
        message: "Message",
        send_rule_message: "Send message",
        yes: "Yes",
        no: "No",
        confirm: {
          title: "Delete automation message?",
          description: "This will permanently delete the automation message",
        },
        errors: {
          automation_message_type: "The automation message type is mandatory",
          message: "The message is mandatory",
        },
      },
      messages: {
        message: "Message",
        new_message: "New message",
        add_message: "Add message",
        search: "Search for a message",
        name: "Name",
        enable: "Enable",
        exception: "Exception",
        send: "Send",
        initial_date: "Initial date",
        end_date: "End date",
        evaluation_form: "Form",
        preference: "Preferences",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        rounded_schedules_date: "Date Rounding",
        arrival_time_rule: "Arrival Time Rule",
        e_sign_rules: "4ue-Sign Automation Rules",
        schedule_reminder_filter_type: "Restrict to",
        establishment: "Establishment",
        schedule_records: "Schedules",
        active_service_search_survey_type: "Search Survey Type",
        evaluation_link_same_as_template:
          "The evaluation link will be the same as the one registered in the template.",
        schedule_classifications: "Schedule classifications",
        schedule_types: "Schedule type",
        schedule_health_insurances: "Health insurance",
        if: "If",
        then: "Then",
        move_ticket:
          "Move ticket(card) if person answer other than SIM / OK / CONFIRMAR",
        move_ticket_cancel: "Move ticket(card) if the person replies CANCELAR",
        move_ticket_not_me:
          "Move ticket(card) if the person replies NÃO SOU EU",
        move_ticket_confirm:
          "Move ticket(card) if the person replies CONFIRMAR",
        move_ticket_attendant:
          "Move ticket(card) if the person replies FALAR COM ATENDENTE",
        warning:
          "When enabling the exception, at least one of the fields below is mandatory.",
        qty_pacient_sent: "Number of patients to send",
        priority: "Priority",
        origin: "Origins",
        schedulingMethod: "Scheduling methods",
        originMessageHelper: "Values ​​must be separated by commas",
        schedulingMethodMessageHelper: "Values ​​must be separated by commas",
        serviceClassification: "Classification",
        serviceSector: "Sectors",
        serviceType: "Service type",
        serviceComplaint: "Complaint/Reason for service",
        groupingIdentifier: "Scheduling group",
        integrationType: "Integration Type",
        tasyAuthStatuses: "Authorization",
        tasyCalendarStatuses: "Schedule Status",
        surgeryTypes: "Surgery Type",
        surgeryPortes: "Surgical Size",
        surgeryCareCharacters: "Care Character",
        surgeryServiceSectors: "Surgery Service Sector",
        surgeryHealthInsurances: "Surgery Health Insurance",
        calendarHistoryType: "History Type Code",
        cancellationReasonCode: "Cancellation reason code(s) of consultation",
        cancellationReasonHelpText:
          "Enter the reason codes separated by commas. If only one is registered, it will be applied directly; if more than one is registered, the user will be able to choose which one to use.",
        cancellationReasonDescription:
          "Cancellation reason description of consultation",
        cancellationReasonDescHelpText:
          "Enter an alternative description for the selected reason.",
        examCancellationReasonCode: "Cancellation reason code(s) of exam",
        examCancellationReasonHelpText:
          "Enter the reason codes separated by commas. If only one is registered, it will be applied directly; if more than one is registered, the user will be able to choose which one to use.",
        examCancellationReasonDescription:
          "Cancellation reason description of exam",
        examCancellationReasonDescHelpText:
          "Enter an alternative description for the selected reason.",
        surgeryCancellationReasonCode: "Surgery cancellation reason code(s)",
        surgeryCancellationReasonHelpText:
          "Enter the reason codes separated by commas. If only one is registered, it will be applied directly; if more than one is registered, the user will be able to choose which one to use.",
        surgeryCancellationReasonDescription:
          "Description of the surgery cancellation reason",
        surgeryCancellationReasonDescHelpText:
          "Enter an alternative description for the selected reason.",
        qtyMessageSendingAttempts: "Resend attempts",
        missing_status: "Status da Agenda",
        internalProcedure: "Internal procedure",
        individualIdentifier: "Individual identifier",
        indicationSequence: "Patient encounter indication (NR_SEQ_INDICACAO)",
        indicationSequenceHelper: "Values must be separated by commas",
        usePatientEncounterInfoPhone:
          "Send to the phone from the patient encounter additional information",
        serviceClassificationMessageHelper:
          "Values ​must be separated by commas",
        serviceSectorMessageHelper: "Values ​​must be separated by commas",
        serviceTypeMessageHelper: "Values ​​must be separated by commas",
        serviceComplaintMessageHelper: "Values ​​must be separated by commas",
        groupingIdentifierMessageHelper: "Values ​​must be separated by commas",
        integrationTypeMessageHelper: "Values ​​must be separated by commas",
        internalProcedureMessageHelper: "Values ​​must be separated by commas",
        individualIdentifierMessageHelper:
          "Values ​​must be separated by commas",
        sendToConfimed: "Send to confirmed",
        confirmScheduleWithOk: "When clicking OK, confirm the schedule",
        noReplyActionsWarning:
          'Action options unavailable, as the template "{{template}}" has no reply option configured in its buttons. The ticket will be finished right after the message is sent.',
        confirm: {
          title: "Delete message?",
          description: "This will permanently delete the message",
        },
        errors: {
          name: "The name is mandatory",
          evaluation_form: "The form is mandatory",
          initial_date: "The initial date is mandatory",
          active_service_search_survey_type:
            " The search survey type is mandatory",
          end_date: "The end date is mandatory",
          initial_date_bigger:
            "The initial date must be less than the end date",
          qty_pacient_sent: "The number of patients to send is mandatory",
          ticket_channel_when_not: "The board is mandatory",
          ticket_channel_step_when_not: "The list is mandatory",
          calendarHistoryType: "The history type code is mandatory",
          ticket_channel_when_cancel: "The board is mandatory",
          ticket_channel_step_when_cancel: "The list is mandatory",
          ticket_channel_when_not_me: "The board is mandatory",
          ticket_channel_step_when_not_me: "The list is mandatory",
          ticket_channel_when_confirm: "The board is mandatory",
          ticket_channel_step_when_confirm: "The list is mandatory",
          ticket_channel_when_attendant: "The board is mandatory",
          ticket_channel_step_when_attendant: "The list is mandatory",
          cancellationReasonCode: "The code is mandatory",
          cancellationReasonDescription: " The description is mandatory",
          examCancellationReasonCode: "The code is mandatory",
          examCancellationReasonDescription: "The description is mandatory",
          surgeryCancellationReasonCode: "The code is mandatory",
          surgeryCancellationReasonDescription: "The description is mandatory",
        },
      },
      boardList: {
        board: "Board",
        list: "List",
      },
      ticketServiceAreaDays: {
        ticket_service_area_days: "Service days",
        ticket_service_area_day: "Service day",
        add_ticket_service_area_day: "Add service day",
        new_ticket_service_area_day: "New service day",
        edit_ticket_service_area_day: "Edit service day",
        day_of_week: "Day of week",
        initial_time: "Initial time",
        end_time: "End time",
        enable: "Enable",
        search: "Search for a service day",
        confirm: {
          title: "Delete service day?",
          description: "This will permanently delete the service day",
        },
        errors: {
          day_of_week: "The day of week is mandatory",
          initial_time: "The initial time is mandatory",
          end_time: "The end time is mandatory",
          initial_time_bigger:
            "The initial time must not be bigger than the end time",
        },
      },
      selectCategories: {
        label: "Select categories",
        no_options_text: "No categories selected",
        options_button_label: "Search categories",
        drawer_props: {
          title: "Select Categories",
          create_button_label: "Create new category",
          input_label: "Category name",
          apply_button_label: "Select categories",
        },
      },
      viewModeSelect: {
        list: "List Mode",
        grid: "Grid Mode",
      },
    },
    chatBot: {
      page: {
        register: {
          ticketService: {
            id: "Service Id",
            allowDistributionList: "Allow distribution list",
            ticket_service: "Ticket(card) service",
            new_ticket_service: "New ticket(card) service",
            ticket_channel_donor_work: "Donors Board",
            enable: "Enable",
            name: "Name",
            phoneNumber: "Telephone",
            qualityRating: "Quality Rating",
            ticket_service_type: "Ticket(card) service type",
            search: "Search for a ticket(card) service",
            add_ticket_service: "Add ticket(card) service",
            site_app_extensions: "Sites or Apps",
            ticket_channel_initial: "Initial board",
            whats_settings: "Whatsapp settings",
            typebot_settings: "TypeBot settings",
            external_chat_site_app:
              "Site / Application for Internal Chat (4uChat)",
            full_screen_mode: "Full Screen Mode",
            send_protocol_number:
              "Send Protocol when closing the ticket upon transfer to internal chat (4uChat)",
            ticket_message_received_rvent: "List for messages",
            config_title: "Settings",
            show_message_disable_area:
              "Display a message informing that some options are unavailable because it is outside business hours and requires an in-person attendant",
            show_badge_name_color:
              "Show badge with service name on ticket(card)",
            badge_background_name_color: "Select badge background color",
            badge_name_color: "Select badge text color",
            confirm: {
              title: "Delete ticket(card) service?",
              description:
                "This will permanently delete the ticket(card) service",
            },
            copied_successfully: "Copied successfully",
            errors: {
              name: "The name is mandatory",
              ticket_service_type: "The ticket(card) service type is mandatory",
              site_app_extensions: "At least one site or app is mandatory",
              ticket_channel_initial: "The initial board is mandatory",
              badge_background_name_color:
                "The badge background color is mandatory",
              badge_name_color: "The badge text color is mandatory",
            },
            sync_whats: "Sync with Whatsapp",
            sync_whats_success: "Synchronized successfully",
            sync_whats_error: "An error occurred during synchronization",
          },
          ticketServiceWhats: {
            ticket_service_whats: "Whatsapp Configuration",
            new_ticket_service_whats: "New Whatsapp Configuration",
            business_phone_number: "Whatsapp Business Phone Number Id",
            business_account: "Whatsapp Business Account Id",
            whatsapp_business: "Whatsapp Business App Id",
            access_token: "Access Token",
            webhook_link: "Webhook Link",
            webhook_link_tooltip: "Copy link",
            verify_token: "Verify Token",
            verify_token_tooltip: "Copy verify token",
            webhook_updated: "Webhook updated successfully!",
            phone_number_registered: "Phone number registered successfully!",
            register_succesfully:
              "Registration complete! Your phone number ID is {{phoneNumberId}} and WABA ID is {{whatsAppBusinessAccountId}}.",
            sync_error:
              "There was an error synchronizing information, please review it in your Meta account.",
            register_cancel:
              "The WhatsApp connection process has been canceled.",
            register_error:
              "An error occurred while registering: {{error_message}}",
            button_update_webhook: "Update webhook",
            button_register_phone_number: "Register number",
            button_business_profile: "Whatsapp Business Profile",
            button_phone_profile: "Number Profile",
            errors: {
              business_phone_number:
                "The Whatsapp Business phone number id is mandatory",
              business_account: "The Whatsapp Business account id is mandatory",
              whatsapp_business: "The Whatsapp Business App id is mandatory",
              access_token: "The access token is mandatory",
              webhook_updated: "There was an error updating wehook!",
              phone_number_registered:
                "There was an error registering the phone number!",
            },
            whatsappProfilePath: {
              whatsappProfileModalTitle: "Whatsapp Business Profile",
              description: "Description",
              about: "About",
              email: "Email",
              websites: "Websites",
              address: "Address",
              websites_help_text: "Press enter to add the websites",
              vertical: "Category",
              profile_picture: "Profile picture",
              profileUpdated: "Whatsapp business profile updated successfully",
              select_file: "Select a file",
              error: {
                profileUpdated:
                  "An error occurred while updating the Whatsapp business profile",
              },
            },
            whatsappNamePath: {
              nameUpdated: "New display name submitted for review",
              whatsappNameModalTitle: "Phone Number Profile",
              verifiedName: "Verified name",
              newDisplayName: "New display name",
              qualityRating: "Quality Rating",
              messagingLimitTier: "Messaging Limit",
              waiting_update:
                "Wait for the approval of the last change request to change again!",
              error: {
                nameUpdated:
                  "An error occurred while submitting the new display name for review",
              },
            },
          },
          ticketServiceTypebot: {
            ticket_service_typebot: "TypeBot Settings",
            new_ticket_service_typebot: "New TypeBot Configuration",
            typebot_viewer_host: "TypeBot Host Viewer",
            errors: {
              viewer_host: "The typeBot host viewer is mandatory",
            },
          },
        },
        logs: {
          ticketHistories: {
            title: "Ticket History",
            start_date: "Start date",
            end_date: "End date",
            occurrence_type: "Occurrence Type",
            ticket_service: "Ticket Service",
            search: "Search message",
            created: "Date/time",
            message: "Message",
            ticket_id: "Ticket",
            view_full_message: "View full message",
            full_message_title: "Full message",
            close: "Close",
            open_ticket: "Open ticket in CRM",
            retry: "Retry",
            errors: {
              period_required:
                "Provide a date range before searching the logs.",
              invalid_period: "Start date cannot be greater than end date.",
              start_date_required: "Start date is required",
              end_date_required: "End date is required",
              invalid_date_range:
                "End date must be greater than or equal to start date",
              occurrence_type_required: "Occurrence type is required",
              filters_load: "Unable to load the screen filters.",
              ticket_redirect: "Unable to open the ticket in CRM.",
            },
          },
          examSchedulingAttachmentLog: {
            title: "Exam Scheduling Attachments Log",
            date_start: "Start Date",
            date_end: "End Date",
            status: "Status",
            sync: "Synchronized",
            not_sync: "Not Synchronized",
            identifier: "Identifier",
            ticket_id: "Ticket ID",
            protocol_number: "Protocol Number",
            ticket_number: "Ticket Number",
            integration_id: "Integration ID",
            error_message: "Error Message",
            retries: "Retries",
            force_retry: "Force Retry",
            reseted_success: "Retry forced successfully",
          },
        },
        service: {
          ticketFinishReason: {
            ticket_finish_reasons: "Ticket finish reasons",
            ticket_finish_reason: "Ticket finish reason",
            new_ticket_finish_reason: "New ticket finish reason",
            add_ticket_finish_reason: "Add ticket finish reason",
            search: "Search for a ticket finish reason",
            name: "Name",
            enable: "Enable",
            code: "Code",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "Delete ticket finish reason?",
              description:
                "This will permanently delete the ticket finish reason",
            },
            errors: {
              name: "The name is mandatory",
            },
          },
          memberAvailabilityPauseReason: {
            member_availability_pause_reason: "Member pause reasons",
            member_availability_pause_reasons: "Member pause reason",
            new_member_availability_pause_reason: "New member pause reason",
            add_member_availability_pause_reason: "Add member pause reason",
            search: "Search for a member pause reason",
            name: "Name",
            code: "Code",
            confirm: {
              title: "Delete member pause reason?",
              description:
                "This will permanently delete the member pause reason",
            },
            errors: {
              name: "Name is required",
            },
          },
          protocolGenerateRule: {
            protocol_generate_rules: "Protocol generate rules",
            protocol_generate_rule: "Protocol generate rule",
            new_protocol_generate_rule: "New protocol generate rule",
            name: "Rule name",
            enable: "Enable",
            initial_date: "Start of term",
            end_date: "End of validity",
            search: "Search for a protocol generate rule",
            add_protocol_generate_rule: "Add Protocol Generate Rule",
            protocol_rule_details: "Protocol generation rule details",
            add_protocol_rule_details: "Add protocol generation rule detail",
            order: "Order",
            field_type: "Type",
            fixed_code: "Fixed value",
            mask: "Mask",
            mask_information:
              "The mask is used to format the value of the '{{type}}' field in the protocol, in cases where the length is smaller than the accepted limit.",
            mask_no_information:
              "The mask is used to format the value of the 'type' field in the protocol, in cases where the length is smaller than the accepted limit.",
            confirm: {
              title: "Delete protocol generate rule?",
              description:
                "This will permanently delete the protocol generate rule",
            },
            errors: {
              name: "The rule name is mandatory",
              initial_date: "The start of term is mandatory",
              end_date: "The end of validity is mandatory",
              fixed_code: "The fixed value is mandatory",
              protocol_rule_details:
                "At least one detail of the protocol generation rule is mandatory",
            },
          },
          ticketServiceWhats: {
            ticket_service_whats: "Whatsapp Configuration",
            new_ticket_service_whats: "New Whatsapp Configuration",
            business_phone_number: "Whatsapp Business Phone Number Id",
            business_account: "Whatsapp Business Account Id",
            whatsapp_business: "Whatsapp Business Id",
            access_token: "Access Token",
            errors: {
              business_phone_number:
                "The Whatsapp Business phone number id is mandatory",
              business_account: "The Whatsapp Business account id is mandatory",
              whatsapp_business: "The Whatsapp Business id is mandatory",
              access_token: "The access token is mandatory",
            },
          },
          ticketServiceArea: {
            ticket_service_areas: "Service areas",
            ticket_service_area: "Service area",
            search: "Search for a service area",
            add_ticket_service_area: "Add service area",
            new_ticket_service_area: "New service area",
            ticket_service_area_parent: "Parent Service Area",
            ticket_default_doc: "Default Protocol",
            ticket_event: "Trigger Event",
            ticket_event_type: "Event Type",
            name: "Name",
            code: "Code",
            enable: "Enable",
            identification: "Requires identification",
            enable_all_the_time: "24/7 service",
            enable_special_time: "Special opening hours",
            display_order: "Display order",
            summary: "Summary",
            ticket_services: "Tickets(Cards) Service",
            ticket_channel: "Board to Transfer",
            ticket_channel_step: "List to Transfer",
            service_type: "Type of Service",
            show_outside_business_day:
              "Mostrar Área Fuera del Horario de Atención",
            message_outside_business_day:
              "Mensaje Mostrado al Usuario Fuera del Horario de Atención",
            summary_outside_business_day:
              "Resumen Mostrado al Usuario Fuera del Horario de Atención",
            ticket_automation_received_rule: "Receiving Rule",
            received_rule_caption:
              "Whenever a receiving rule is selected, patient identification will be required.",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            yes: "Yes",
            no: "No",
            actions: "Actions",
            time: "Time",
            action_type: "Action Type",
            no_action: "Menu Without Action",
            trigger_event: "Trigger an Event",
            default_protocol: "Send a Default Protocol",
            channel_transfer: "Transfer to a List/Board",
            received_rule: "Follow a Receiving Rule",
            direct_to_internal_chat: "Direct to internal chat (4uChat)",
            external_chat_site_app:
              "Site / Application for Internal Chat (4uChat)",
            full_screen_mode: "Full Screen Mode",
            send_protocol_number:
              "Send Protocol when closing the ticket upon transfer to internal chat (4uChat)",
            automatic_external_chat_alert:
              "This ticket service has automatic redirection enabled for internal chat (4uChat) of Site \"{{siteAppName}}\"",
            enableModal: {
              disable: "Disable service area?",
              enable: "Enable service area?",
              disable_message:
                "By disabling this service area, all dependent service areas will be disabled as well.",
              enable_message:
                "By enabling this service area, all dependent service areas will be enabled as well.",
              cancel_button: "Cancel",
              confirm_button: "Confirm",
            },
            confirm: {
              title: "Delete service area?",
              description: "This will permanently delete the service area",
            },
            errors: {
              name: "The name is mandatory",
              display_order: "The display order is mandatory",
              code: "The code is mandatory",
              ticket_services: "The ticket(card) service is mandatory",
              summary: "The summary is mandatory",
              summary_characteres:
                "The summary cannot be longer than 72 characters",
              name_characteres: "The name cannot be longer than 24 characters",
              summary_outside_characteres:
                "The summary cannot be longer than 72 characters",
              message_outside_characteres:
                "The outside business hours message cannot be longer than 500 characters",
              message_outside_business_day:
                "The outside service day message is required",
              ticket_channel_step: "List is required when a board is selected",
            },
          },
          ticketServiceMessage: {
            ticket_service_messages: "Messages",
            ticket_service_message: "message",
            search: "Search for a message",
            message: "Mensage",
            message_type: "Message type",
            ticket_service: "Ticket(card) service",
            target: "Target",
            add_message: "New Message",
            errors: {
              message: "The message is mandatory",
              message_type: "The message type is mandatory",
              ticket_service: "The ticket(card) service is mandatory",
              target: "The target is mandatory",
            },
          },
          serviceDay: {
            service_days: "Opening hours",
            service_day: "Opening hours",
            new_service_day: "New opening hours",
            search: "Search by opening hours",
            add_service_day: "Add opening hours",
            day_of_week: "Day of week",
            start_time: "Start time",
            end_time: "End time",
            ticket_service: "Ticket(card) service",
            enable: "Enable",
            confirm: {
              title: "Delete opening hours?",
              description: "This will permanently delete the opening hours",
            },
            errors: {
              day_of_week: "The day of week is mandatory",
              ticket_service: "The ticket(card) service is mandatory",
              start_time: "The start time is mandatory",
              end_time: "The end time is mandatory",
            },
          },
          blacklist: {
            blacklist_registrations: "Blacklist Registrations",
            blacklist_registration: "Blacklist Registration",
            name: "Name",
            active: "Active",
            inactive: "Inactive",
            status: "Status",
            phone_number: "Phone",
            creation_date: "Blacklist Date",
            search: "Search blacklist record",
            add_button: "Add Record to Blacklist",
            enable: "Enable",
            individual: "Individual",
            contact_number: "Contact Number",
            ddi: "DDI",
            confirm: {
              title: "Delete blacklist record?",
              description: "This will permanently delete the blacklist record",
            },
            errors: {
              phone_number_value: "Contact number is required",
              ddi: "DDI is required",
              individual: "Select a person",
            },
          },
          banList: {
            ban_lists: "Lists of Banned Phone Numbers by Service",
            ban_list: "List of Banned Phone Numbers by Service",
            add_ban_list: "Add List of Banned Phone Numbers by Service",
            new_ban_list: "New List of Banned Phone Numbers by Service",
            search: "Search for a list of banned phone numbers by service",
            phone_number: "Phone Number",
            phone_info:
              "Enter the number with country code and area code (numbers only). Example: 5547912345678",
            ticket_service: "Ticket Service (card)",
            type: "Type",
            observation: "Observation",
            created: "Date and time",
            confirm: {
              title: "Delete list of banned phone numbers by service?",
              description:
                "This will permanently delete the list of banned phone numbers by service",
            },
            errors: {
              phone_number: "Phone number is required",
              only_phone_numbers: "Enter numbers only",
              ticket_service: "Ticket service (card) is required",
            },
          },
          appointmentArrivalRule: {
            appointment_arrivals: "Appointment Arrival Times",
            appointment_arrival: "Appointment Arrival Time",
            new_appointment_arrival: "New Appointment Arrival Time",
            add_appointment_arrival: "Add Appointment Arrival Time",
            search: "Search for an appointment arrival time",
            name: "Name",
            description: "Description",
            created_successfully:
              "Appointment arrival time created successfully",
            confirm: {
              title: "Delete appointment arrival time?",
              description:
                "This will permanently delete the appointment arrival time",
            },
            errors: {
              name: "Name is required",
            },
            appointment_arrival_config: "Arrival Times",
            appointmentArrivalConfig: {
              appointment_arrival_configs: "Arrival Times",
              appointment_arrival_config: "Arrival Time",
              new_appointment_arrival_config: "New Arrival Time",
              add_appointment_arrival_config: "Add Arrival Time",
              search: "Search for an arrival time",
              from: "From",
              to: "To",
              arrival_time: "Arrival Time",
              if: "If",
              then: "Then",
              appointments: "Appointments:",
              arrival_time_description: "Inform the patient to arrive at:",
              confirm: {
                title: "Delete arrival time?",
                description: "This will permanently delete the arrival time",
              },
              errors: {
                from: "Start date is required",
                to: "End date is required",
                arrival_time: "Arrival time is required",
              },
            },
          },
        },
        templates: {
          whatsapp_template: {
            category: "Category",
            whatsapp_templates: "Whatsapp templates",
            whatsapp_template: "Whatsapp template",
            new_whatsapp_template: "New Whatsapp template",
            header_type: "Header type",
            search: "Search for a Whatsapp template",
            action_type: "Action Type",
            add_whatsapp_template: "Add Whatsapp template",
            dynamic: "Dynamic",
            name: "Name",
            enable: "Enable",
            automation: "Automation",
            ticket_service: "Ticket(card) service",
            no_ticket_service:
              "You must have at least one ticket(card) service registered to be able to register a Whatsapp template",
            template_meta_name: "Template name in Meta",
            automation_status: "Automation status",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            message_preview: "Message preview",
            preview_button: "View template preview",
            optional: "Optional",
            header: "Header",
            internal_template: "Internal Template CRM",
            header_sub:
              "Add a title or choose which type of media you will use for this header.",
            file_sending_mode: "File Sending Mode",
            send_contact_related_file:
              "Always send the file linked to the list contact",
            send_contact_related_file_info:
              "If this option is checked, we will not send the file above. We will send the file that is sent via API at the moment the contact is created",
            send_selected_file: "Always send the selected file",
            send_selected_file_info:
              "If this option is checked, we will not send the file above. We will send the file that will be attached when creating the ticket.",
            send_template_related_file:
              "Always send the file linked to this template",
            send_template_related_file_info:
              "If this option is checked, we will always send the same file, which is the file linked to this template",
            title: "Title",
            body: "Body",
            body_sub: "Enter the text of your message.",
            body_placeholder: "Enter the body of your message...",
            footer: "Footer",
            footer_sub:
              "Add a small line of text at the bottom of your message template.",
            buttons: "Buttons",
            buttons_sub:
              "Create buttons for customers to respond to your message or take action.",
            resend: "Reesend",
            resend_success: "Template resent successfully",
            whatsappTemplateAutomation: {
              title: "Change automation?",
              description:
                "Changing the automation will cause all fields to be cleared",
              cancel: "Cancel",
              change: "Change",
            },
            confirm: {
              title: "Delete Whatsapp template?",
              description: "This will permanently delete the Whatsapp template",
            },
            errors: {
              name: "The name is mandatory",
              ticket_service: "Ticket(card) service is mandatory",
              ticket_automation: "The automation is mandatory",
              body: "The body must have at least 1 character",
              media_file: "At least one file is mandatory",
              body_invalid_variables: "All variables must be valid",
              body_max: "The body must have a maximum of 1024 characters",
              body_max_550: " The body must have a maximum of 550 characters",
              custom_button_text: "Button text must have at least 1 character",
              custom_button_text_max:
                "Button text must have have a maximum of 25 characters",
              url_type: "URL type is mandatory",
              country: "The country is mandatory",
              text: "The button text must have at least 1 character",
              text_max: "The button text must have a maximum of 25 characters",
              payload: "Field mandatory",
              url_payload:
                "The button must contain a valid link (http or https)",
              example: "The example is mandatory",
              whatsMetaCategory: "The category is mandatory",
              action_type: "The action type is mandatory",
              file_fixed: "Select a file sending mode",
            },
          },
          internalCrm: {
            internal_crm: "CRM Internal",
            new_variable: "New Variable",
            new_category: "New Category",
            new_template: "New Template",
            search_category: "Search category",
            search_variable: "Search variable",
            search_template: "Search template",
            add_automation_rule: "Add automation rule",
            categories: "Categories",
            variables: "Variables",
            templates: "Templates",
            character_limit: "Character limit",
            add_new_item: "Add new field",
            fields: "Fields",
            status: "Status",
            label: "Label",
            screen_order: "Screen Order",
            is_required: "Required",
            name: "Name",
            active: "Active",
            inactive: "Inactive",
            category: "Category",
            data_type: "Data type",
            enable: "Enable",
            code: "Code",
            confirm: {
              title_variable: "Delete variabble?",
              description_variable: "This will permanently delete the variable",
              title_category: "Delete category?",
              description_category: "This will permanently delete the category",
              title_template: "Delete template?",
              description_template: "This will permanently delete the template",
            },
            errors: {
              name: "The name is mandatory",
              label: "The label is mandatory",
              screen_order: "The screen order is mandatory",
              categories: "The category is mandatory",
              data_type: "The data type is mandatory",
              variable: "The variable is mandatory",
              fields: "At least one field is mandatory",
            },
          },
        },
        automations: {
          automationRuleEncMessage: {
            message: "Message",
            new_message: "New message",
            add_message: "Add message",
            search: "Search for a message",
            name: "Name",
            enable: "Enable",
            exception: "Exception",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            send: "Send",
            if: "If",
            then: "Then",
            priority: "Priority",
            qtyMessageSendingAttempts: "Resend attempts",
            missing_status: "Status da Agenda",
            establishment: "Establishment",
            initial_date: "Start date",
            end_date: "End date",
            individualIdentifier: "Individual identifier",
            ticketAutomationRuleEncMessageSectors: "Patient encounter sectors",
            ticketAutomationRuleEncMessagePrescriptionSectors:
              "Prescription sectors",
            ticketAutomationRuleEncMessageEncounterTypes: "Service types",
            ticketAutomationRuleEncMessageInProcClassifics: "Classification",
            ticketAutomationRuleEncMessageMedProcTypes:
              "Internal procedure types",
            sendTypeEmrResult: "Report result",
            templateGeneral: "Template",
            sendTypePasswordEmrResult: "Report password",
            individualIdentifierMessageHelper:
              "Values ​​must be separated by commas",
            confirm: {
              title: "Delete message?",
              description: "This will permanently delete the message",
            },
            errors: {
              name: "Name is required",
              establishments: "The establishment is required",
              initial_date: "The start date is required",
              end_date: "The end date is required",
              templateGeneral: "The template is required",
            },
          },
          automationReceivedRules: {
            automation_received_rules: "Receiving Rules",
            automation_received_rule: "Receiving Rule",
            search: "Search for a receiving rule",
            new_automation_received_rule: "New Receiving Rule",
            name: "Name",
            created_by: "Created by",
            created_successfully: "Created successfully",
            insurance: "Insurance / Category",
            private_insurance: "Private Insurance",
            cancelation_reasons: "Cancellation Reasons",
            slot: "Draw Slot",
            file: "Files",
            days_ahead: "Days Ahead",
            messages: "Messages",
            custom_message: "Customs Messages",
            establishment: "Establishments",
            add_automation_received_rule: "Add Receiving Rule",
            ticket_default_doc: "Default Protocols",
            tasy_orientation: "Tasy Orientation",
            offer_classification: "Offer Classification",
            allowed_actions: "Allowed Actions",
            preferences: "Preferences",
            unchosenProfessionalPriorities: "Unchosen Professional Priorities",
            confirm: {
              title: "Delete Receiving Rule?",
              description: "This will permanently delete the receiving rule",
            },
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            code: "Code",
            initial_date: "Start date",
            end_date: "End date",
            when_error: "Transfer to (When an error occurs during the flow):",
            when_finished: "Transfer to (When scheduling is finished):",
            transfer_message: "Transfer message",
            error_message: "Transfer message when an error occurs",
            automation: "Automation",
            enable: "Enable",
            appointment_arrival_consultation: "Consultation Arrival Time",
            appointment_arrival_exam: "Exam Arrival Time",
            ticketAutRecRuleTasyOrientation: {
              ticket_autrecrule_tasy_orientation: "Tasy Orientation",
              new_ticket_autrecrule_tasy_orientation: "New Tasy Orientation",
              enable: "Enable",
              type_tasy_orientation: "Tasy orientation type",
              send_when: "Send when",
              status: "Status",
              active: "Active",
              inactive: "Inactive",
              add_ticket_autrecrule_tasy_orientation: "Add Tasy Orientation",
              confirm: {
                title: "Delete Tasy orientation?",
                description:
                  "This will permanently delete the Tasy orientation",
              },
              errors: {
                type_tasy_orientation: "The Tasy orientation type is mandatory",
                send_when: "The 'Send when' field is mandatory",
              },
            },
            automationRecRuleTicketDefDoc: {
              ticket_default_doc: "Default Protocol",
              new_ticket_default_doc: "New Default Protocol",
              add_ticket_default_doc: "Add Default Protocol",
              send_when: "Send When",
              description: "Description",
              status: "Status",
              active: "Active",
              inactive: "Inactive",
              enable: "Enable",
              ticketAutRecRuleTicketDefDocsInsurances: "Insurances",
              ticketAutRecRuleTicketDefDocsInternalProcedures:
                "Internal Procedures",
              procedure_caption: "Type at least 3 letters to search",
              ticketAutRecRuleTicketDefDocsCalendars: "Calendars",
              confirm: {
                title: "Delete Default Protocol?",
                description:
                  "This will permanently delete the Default Protocol",
              },
              errors: {
                send_when: "The 'send when' field is required",
                ticket_default_doc: "The default protocol is required",
              },
            },

            automationReceivedDaysAhead: {
              days_ahead: "Day Ahead",
              new_days_ahead: "New  Day Ahead",
              add_days_ahead: "Add  Day Ahead",
              qtd_days: "Number of Days",
              procedure_caption: "Type at least 3 letters to search",
              search_internal_procedures: "Search Internal Procedures",
              ticketAutomationReceivedDaysAheadCalendars: "Calendars",
              ticketAutomationReceivedDaysAheadInsurances: "Insurances",
              ticketAutomationReceivedDaysAheadProcedures: "Procedures",
              status: "Status",
              enable: "Enable",
              active: "Active",
              inactive: "Inactive",
              if: "If",
              then: "Then",
              limit_final_date: "Limit offer end date",
              time_limit_type: "Time limit type",
              limit_days: "Limit quantity",
              confirm: {
                title: "Confirm Day Ahead",
                description: "This will permanently delete the Day Ahead",
              },
              errors: {
                destination_calendar_file: "Save location is required",
                ticketAutomationReceivedDaysAheadCalendars:
                  "The calendar is required",
                ticketAutomationReceivedDaysAheadInsurances:
                  "The insurance is required",
                ticketAutomationReceivedDaysAheadProcedures:
                  "The procedure is required",
                qtd_days: "The number of days is required",
              },
            },
            automationReceivedConfFile: {
              file: "File",
              new_file: "New file",
              add_file: "Add file",
              destination_calendar_file: "Save location",
              display_order: "Display order",
              displayOrder: "Display order",
              wait_limit_time: "Maximum Wait Time in Minutes",
              ticketAutomationReceivedConfFileCalendars: "Schedules",
              ticketAutomationReceivedConfFileCalePreferences:
                "Schedule Preferences",
              ticketAutomationReceivedConfFileCaleProcedures: "Procedures",
              message: "Message",
              messageErro: "Error message",
              calendar_slot_sort_type: "Slot sort type",
              ticketAutomationReceivedConfFileCaleInsurances: "Insurance",
              confirm: {
                title: "Confirm action",
                description: "Are you sure you want to continue?",
              },
              ticketAutomationReceivedConfFileCaleInsuranceTypes:
                "Insurance Types",
              procedure_caption: "Type at least 3 letters to search",
              search_internal_procedures: "Search Internal Procedures",
              errors: {
                destination_calendar_file: "Save location is required",
                ticketAutomationReceivedConfFileCalendars:
                  "Calendar is mandatory",
                ticketAutomationReceivedConfFileCalePreferences:
                  "Preference is mandatory",
                ticketAutomationReceivedConfFileCaleProcedures:
                  "Procedure is mandatory",
                displayOrder: "Display order is mandatory",
                message: "Message is mandatory",
                messageError: "Error message is mandatory",
              },
            },
            automationReceivedCustomMessage: {
              custom_message: "Custom Message",
              new_custom_message: "New Custom Message",
              add_custom_message: "Add Custom Message",
              message: "Message",
              ticket_channel: "Board",
              ticket_channel_step: "List",
              ticketAutomationReceivedCustomMessageCalendars: "Calendars",
              ticketAutomationReceivedCaleExamGroupings: "Calendar Grouping",
              confirm: {
                title: "Delete Custom Message?",
                description: "This will permanently delete the Custom Message",
              },
              errors: {
                message: "Message is mandatory",
                ticket_channel: "Board is mandatory",
                ticket_channel_step: "List is mandatory",
                ticketAutomationReceivedCaleExamGroupings:
                  "The calendar grouping is mandatory",
              },
            },
            automationReceivedRuleInsuranceCategory: {
              insurance: "Insurance",
              new_insurance: "New Insurance",
              enable: "Enable",
              add_insurance: "Add Insurance",
              insuranceExternalId: "Insurance External ID",
              insuranceExternalName: "Insurance Name",
              status: "Status",
              active: "Active",
              inactive: "Inactive",
              confirm: {
                title: "Delete Insurance?",
                description: "This will permanently delete the insurance",
              },
              errors: {
                insurance_register: "The Insurance is required",
              },
            },
            automationReceivedRulePriceInsurance: {
              insurance: "Insurance Price",
              new_insurance: "New Insurance Price",
              enable: "Enable",
              add_insurance: "Add Insurance Price",
              external_id: "Insurance External ID",
              external_name: "Insurance Name",
              insurance_field: "Insurance",
              confirm: {
                title: "Delete Insurance Price?",
                description: "This will permanently delete the Insurance Price",
              },
              errors: {
                insurance_field: "Insurance is required",
              },
            },
            automationReceivedRuleCancelationReason: {
              cancelation_reason: "Cancellation Reason",
              new_cancelation_reason: "New Cancellation Reason",
              add_cancelation_reason: "Add Cancellation Reason",
              external_id: "External Code",
              external_name: "External Name",
              cancelation_reason_field: "Cancellation Reason",
              confirm: {
                title: "Delete Cancellation Reason?",
                description:
                  "This will permanently delete the cancellation reason",
              },
              errors: {
                cancelation_reason_field: "The Cancellation Reason is required",
              },
            },
            automationReceivedRuleEstablishment: {
              establishment_id: "Establishment ID",
              establishment_name: "Establishment Alias",
              original_establishment_name: "Original Establishment Name",
              add_establishment: "Add Establishment",
              confirm_title: "Establishment",
              confirm_description:
                "Are you sure you want to permanently delete this establishment?",
              establishment: "Establishment",
              new_establishment: "New Establishment",
              establishment_field: "Establishments",
              establishment_name_field: "Establishment Alias",
            },
            automationReceivedMessagePrivateInsurance: {
              private_insurance: "Private Insurance",
              new_private_insurance: "New Private Insurance",
              add_private_insurance: "Add Private Insurance",
              external_private_id: "External Private Insurance ID",
              external_private_name: "External Private Insurance Name",
              confirm: {
                title: "Delete Private Insurance?",
                description:
                  "This will permanently delete the private insurance",
              },
              errors: {
                external: "Private Insurance is required",
              },
            },
            automationReceivedSlot: {
              slot_schedule: "Draw Slot",
              new_slot_schedule: "New Draw Slot",
              add_slot_schedule: "Add Draw Slot",
              enable: "Enable",
              if: "If",
              ticketAutomationReceivedSlotCalendars: "Schedule",
              priority: "Priority",
              then: "Then",
              slots_available: "Number of Available Slots",
              calendar_slot_sort_type: "Draw method",
              status: "Status",
              active: "Active",
              inactive: "Inactive",
              confirm: {
                title: "Delete Draw Slot?",
                description: "This will permanently delete the Draw Slot",
              },
              errors: {
                calendar_slot_sort_type: "The Draw method is required",
                ticketAutomationReceivedSlotCalendars:
                  "The Schedule is required",
                slots_available: "The Number of Available Slots is required",
                priority: "Priority is required",
              },
            },
            automationReceivedMessages: {
              message: "Message",
              new_message: "New Message",
              add_message: "Add Message",
              search: "Search for a message",
              active: "Active",
              inactive: "Inactive",
              status: "Status",
              enable: "Enable",
              show_app_and_online_calendar: "Only Online Schedule",
              if: "If",
              then: "Then",
              return_days: "Return Days",
              calendar_classification: "Agenda Classifications",
              preference: "Preferences",
              consultation_grouping_register: "Agenda Groupings",
              calendar_specialties: "Agenda Specialties",
              agendas: "Agendas",
              confirm: {
                title: "Delete Message?",
                description: "This will permanently delete the Message",
              },
              errors: {
                return_days: "The number of return days is required",
              },
            },
            ticketAutomationReceivedRuleOfferClassif: {
              offer_classification: "Offer Classification",
              add_offer_classification: "Add Offer Classification",
              new_offer_classification: "New Offer Classification",
              classifications: "Classifications",
              default_classification: "Default Classification",
              require_turn_slot_classif: "Require classification in turn/slot",
              update_slot_classif:
                "When scheduling, update the classification in the slot",
              confirm: {
                title: "Delete Offer Classification?",
                description:
                  "This will permanently delete the Offer Classification",
              },
              errors: {
                classifications: "Classification is required",
                default_classification: "Default classification is required",
              },
            },
            ticketAutomationReceivedRuleAllowedAction: {
              allowed_action: "Allowed Action",
              add_allowed_action: "Add Allowed Action",
              new_allowed_action: "New Allowed Action",
              new_schedule: "New Appointment",
              confirm_field: "Confirm",
              cancel: "Cancel",
              check_in: "Check-in",
              reschedule: "Reschedule",
              reschedule_fields_caption:
                "Enter in the fields below the rules that will be used for rescheduling according to the appointment type",
              featured_received_rule: "Featured Receiving Rule",
              return_received_rule: "Return Receiving Rule",
              exam_received_rule: "Exams Receiving Rule",
              consultation_received_rule: "Consultations Receiving Rule",
              yes: "Yes",
              no: "No",
              confirm: {
                title: "Delete Allowed Action?",
                description: "This will permanently delete the Allowed Action",
              },
            },
            appointmentArrival: {
              appointment_arrival_consultation: "Consultation Arrival Time",
              new_appointment_arrival_consultation:
                "New Consultation Arrival Time",
              add_appointment_arrival_consultation:
                "Add Consultation Arrival Time",
              appointment_arrival_exam: "Exam Arrival Time",
              new_appointment_arrival_exam: "New Exam Arrival Time",
              add_appointment_arrival_exam: "Add Exam Arrival Time",
              search_consultation: "Search for a Consultation Arrival Time",
              search_exam: "Search for an Exam Arrival Time",
              if: "If",
              then: "Then",
              establishments: "Establishments",
              insurances: "Insurance Plans",
              calendars: "Schedules",
              classifications: "Schedule Classifications",
              internal_procedures: "Internal Procedures",
              procedure_caption: "Enter at least 3 letters to search",
              appointment_arrival_rule: "Arrival Time Rule",
              confirm: {
                title_consultation: "Delete Consultation Arrival Time?",
                description_consultation:
                  "This will permanently delete the Consultation Arrival Time",
                title_exam: "Delete Exam Arrival Time?",
                description_exam:
                  "This will permanently delete the Exam Arrival Time",
              },
              errors: {
                appointment_arrival_rule: "Arrival time rule is required",
              },
            },
            ticketAutomationReceivedRulePreference: {
              preference: "Preference",
              add_preference: "Add Preference",
              new_preference: "New Preference",
              enable: "Enable",
              active: "Active",
              inactive: "Inactive",
              medical_specialty: "Medical Specialty",
              status: "Status",
              calendar_preferences: "Preferences",
              confirm: {
                title: "Delete Preference?",
                description: "This will permanently delete the Preference",
              },
              errors: {
                medical_specialty: "Medical specialty is required",
              },
            },
            ticketAutRecRuleUnchosenProfessionalRule: {
              unchosenProfessionalPriority: "Unchosen Professional Priority",
              new_unchosenProfessionalPriority:
                "New Unchosen Professional Priority",
              add_unchosenProfessionalPriority:
                "Add Unchosen Professional Priority",
              status: "Status",
              active: "Active",
              inactive: "Inactive",
              enable: "Enable",
              if: "If",
              then: "Then",
              name: "Name",
              priority: "Priority",
              initial_age: "Initial Age",
              final_age: "Final Age",
              unchosen_professional_criterion: "Criterion",
              specialties: "Specialties",
              insurances: "Insurance Plans",
              calendars: "Schedules",
              physicians: "Physicians",
              add_priority: "Add Priority",
              confirm: {
                title: "Delete Unchosen Professional Priority?",
                description:
                  "This will permanently delete the Unchosen Professional Priority",
              },
              errors: {
                name: "Name is required",
                unchosen_professional_criterion: "Criterion is required",
                offers: "Select at least one schedule or physician",
                offer_priority: "Priority is required",
                offer_priority_duplicated:
                  "Priority is already used by another item. Please use a different value",
              },
            },
          },
          templateGeneral: {
            title: "Template General",
            new: "New Template General",
            add: "Add Template General",
            editor: "Editor",
            html: "HTML",
            insert_html: "Enter the HTML for {{section_name}}",
            content_header: "Header",
            content_footer: "Footer",
            template_general_type: "Template General Type",
            status: "Status",
            name: "Name",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            confirm: {
              title: "Delete Template General?",
              description: "This will permanently delete the Template General",
            },
            errors: {
              name: "The name is mandatory",
              templateGeneralType: "The template general type is mandatory",
            },
          },
          automationMessageTicketDefaulDoc: {
            title: "Default Document",
            new: "New default document",
            add: "Add default document",
            send_when: "Send When",
            ticket_default_doc: "Default Document",
            enable: "Enable",
            description: "Description",
            schedules: "Schedules",
            insurances: "Insurances",
            internalProcedures: "Internal proc",
            active: "Active",
            inactive: "Inactive",
            status: "Status",
            schedulesMessageHelper: "Values ​​must be separated by commas",
            insurancesMessageHelper: "Values ​​must be separated by commas",
            internalProceduresMessageHelper:
              "Os valores devem ser separados por vírgula",
            confirm: {
              title: "Delete the default document?",
              description: "This will permanently delete the default document",
            },
            errors: {
              ticket_default_doc: "The default document is mandatory",
              send_when: "Send when is mandatory",
            },
          },
          ticketAutomationMsgTicketAutTemplate: {
            title: "Template after Response",
            new: "New template after Response",
            add: "Add template after Response",
            send_when: "Send When",
            ticket_automation_template: "Template",
            schedules: "Schedules",
            insurances: "Insurances",
            schedulesMessageHelper: "Values ​​must be separated by commas",
            insurancesMessageHelper: "Values ​​must be separated by commas",
            confirm: {
              title: "Delete the Template after Response?",
              description:
                "This will permanently delete the Template after Response",
            },
            errors: {
              ticket_default_doc: "The Template after Response is mandatory",
              send_when: "Send when is mandatory",
              schedules: "Schedules or Insurances is mandatory",
              insurances: "Schedules or Insurances is mandatory",
            },
          },
          AutomationTasyOrientation: {
            title: "Tasy Orientation",
            new: "New Tasy orientation",
            add: "Add Tasy orientation",
            send_when: "Send When",
            type_tasy_orientation: "Tasy Process",
            enable: "Enable",
            active: "Active",
            inactive: "Inactive",
            status: "Status",
            confirm: {
              title: "Delete the Tasy orientation?",
              description: "This will permanently delete the Tasy orientation",
            },
            errors: {
              send_when: "Send when is mandatory",
              type_tasy_orientation: "Tasy Process is mandatory",
            },
          },
          automationRules: {
            automation_rules: "Shipping Rules",
            automation_rule: "Shipping Rule",
            new_automation_rule: "New shipping rule",
            search: "Search for a shipping rule",
            add_automation_rule: "Add shipping rule",
            name: "Name",
            automation: "Automation",
            ticket_channels: "Boards",
            ticket_channels_subtitle:
              "If no board is specified, the rule will be available for all boards",
            add_ticket_channels: "Boards added",
            automation_message_ticket_automation_template:
              "Template after Response",
            created_by: "Created by",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            enable: "Enable",
            event: "Event",
            ticket_service: "Ticket(card) service",
            action_after_24_hours: "Action after 24 hours",
            select_action_after_24_hours: "Select the action after 24 hours",
            initial_date: "Initial date",
            end_date: "End date",
            whatsapp_template: "WhatsApp template",
            automation_message_ticket_defaul_doc: "Default Document",
            automation_tasy_orientation: "Tasy Orientation",
            robot: "Robot",
            attendant: "Attendant",
            pendent: "Pending Submission",
            when_error: "When there is an error when send the template",
            when_blacklist: "When the contact is on the blacklist",
            board: "Board",
            list: "List",
            time_rule: "Time rule",
            automation_message: "Automation message",
            messages: "Messages",
            created_successfully: "Automation rule created successfully",
            confirm: {
              title: "Delete shipping rule?",
              description: "This will permanently delete the shipping rule",
            },
            errors: {
              name: "The name is mandatory",
              ticket_automation: "The automation is mandatory",
              ticket_event: "The event is mandatory",
              ticket_service: "The ticket(card) service is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              ticket_automation_template: "The WhatsApp template is mandatory",
              ticket_channel_step_robot: "The list for the robot is mandatory",
              ticket_channel_step_attendant:
                "The list for the attendant is mandatory",
              ticket_channel_step_pendent:
                "The list for the pending submission is mandatory",
              action_after_24_hours: "Select the action after 24 hours",
              initial_date_bigger:
                "The initial date must be less than the end date",
              list: "The list is required",
            },
          },
        },
        flows: {
          serviceWhatsapp: {
            title: "You have been redirected to the stream manager",
            subtitle: "To access again click on the button below",
            button: "Access",
          },
        },
      },
    },
    "4uESign": {
      page: {
        automations: {
          automationRules: {
            signOnly: "Signature filter",
            periodInDays: "Period in days",
            attendantTypeHelperText: "Values must be separated by commas",
            wordFile: "Word file",
            model_file: "Template file",
            download_model: "Download model",
            model_files: {
              guia_sp_sadt: "SP-SADT guide",
              ficha_paciente: "Patient form",
            },
            active: "Active",
            inactive: "Inactive",
            establishment: "Establishments",
            esignAttendantType: "Attendance type",
            insuranceType: "Insurance type",
            external_medical_certificate_types: "Prescription type",
            header_footer_type: "Default header and footer template",
            esignStoragePlace: "Storage location",
            additionalData: "Additional data to save the file",
            requiredSignatures: "Required signatures",
            technicalManagerCode: "Technical manager code",
            direction: "Direction",
            interoperability: "Interoperability",
            service: "Service",
            documents: "Documents",
            document: "Document",
            new_document: "New document",
            edit_document: "Edit document",
            new_service: "New service",
            edit_service: "Edit service",
            addVariables: "Add variables",
            available_variables: "Available variables",
            available_variables_button: "Variables",
            available_variables_tooltip: "View available variables",
            available_variables_helper:
              "Use the variables below in this rule's Word document.",
            no_available_variables:
              "No variables are available for this automation.",
            variables_load_error: "Unable to load the available variables.",
            variables_automation_not_found:
              "Unable to identify the automation linked to this rule.",
            copy_variable: "Copy variable",
            close: "Close",
            try_again: "Try again",
            add_automation_rule: "Add automation rule",
            qrCodeEnable: "Enable QRCode",
            enable: "Enable",
            esign_automation: "Automation",
            priority: "Priority",
            tasy_automation_warning:
              "This automation will group all rules regarding the attendance record to collect the patient's signature only once, so if there are multiple rules, it will collect a single signature from the patient.",
            file_generation: "File generation and integration",
            file_type: "File Type",
            add_service: "Add service",
            add_document: "Add document",
            automation_rules: "Automation Rules",
            automation_rule: "Automation Rule",
            search: "Search for an automation rule",
            name: "Name",
            code: "Code",
            created_by: "Created by",
            status: "Status",
            new_automation_rule: "New automation rule",
            initial_date: "Initial date",
            end_date: "End date",
            observation: "Observation",
            header_pdf: "Header PDF",
            footer_pdf: "Footer PDF",
            created_successfully: "Automation rule created successfully",
            automation: "Automation",
            physicians: "Physicians",
            insuranceTypes: "Insurance Type",
            authorizationTypes: "Authorization type",
            guideTypes: "Guide type",
            authorizationStages: "Authorization stage",
            insurances: "Insurance",
            document_search: "Search for a document",
            interroperability_search: "Search for a service",
            tabs: {
              general: "General Data",
              documents: "Documents",
              interoperability: "Interoperability",
            },
            order: "Order",
            body_pdf: "PDF body",
            interroperability_delete: {
              title: "Do you want to delete this service?",
              description: "This will permanently delete this service",
            },
            document_delete: {
              title: "Do you want to delete this document?",
              description: "This will permanently delete this document",
            },
            additionalInfo: "Additional data is required",
            media_files: "Documents",
            add_media_file: "Add document",
            body: "Document body",
            confirm: {
              title: "Delete automation rule?",
              description: "This will permanently delete the automation rule",
            },
            errors: {
              headerFooterType:
                "The default header and footer template is required",
              direction: "Direction is required",
              signOnlyPeriod: "The period in days is required",
              signOnlyRequired: "Signature filter is required",
              name: "The name is mandatory",
              automation: "The automation is mandatory",
              priority: "The priority is mandatory",
              initial_date: "The initial date is mandatory",
              end_date: "The end date is mandatory",
              initial_date_bigger:
                "The initial date must be less than the end date",
              order: "Order must be greater than or equal to 1",
              requiredSignatures: "At least one signature is required",
              requiredSignatures_empty:
                "Select at least one required signature",
              technicalManagerCode: "The technical manager code is required",
              establishment: "Establishment is required",
              physicians: "Select at least one physician",
              insuranceTypes: "Select at least one insurance type",
              esignLocationSaveFile: "Storage location is required",
              service: "Service is required",
            },
          },
          emailSendRules: {
            title: "Email send rules",
            form_title: "Email send rule",
            new: "New email send rule",
            add: "Add email send rule",
            search: "Search for an email send rule",
            name: "Name",
            initial_date: "Start date",
            end_date: "End date",
            subject: "Subject",
            body: "Content",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            variables_button: "Variables",
            variables_tooltip: "View available variables",
            available_variables: "Available variables",
            copy_variable: "Copy variable",
            close: "Close",
            overlap_error:
              "An email send rule with an overlapping validity period already exists.",
            variables: {
              patient_name: "Patient name",
              encounter_number: "Encounter number",
            },
            confirm: {
              title: "Delete email send rule?",
              description: "This will permanently delete the email send rule",
            },
            errors: {
              name: "Name is required",
              initial_date: "Start date is required",
              end_date: "End date is required",
              subject: "Subject is required",
              body: "Content is required",
              end_date_less:
                "End date must be greater than or equal to start date",
            },
          },
          signatureGroups: {
            title: "Signature Groups",
            edit: "Edit signature group",
            name: "Name",
            linkedRules: "Linked rules",
            search: "Search for a signature group",
            errors: { name: "Name is required" },
          },
        },
        logs: {
          forubusSignatureLogs: {
            identifier: "Identifier",
            signature_type: "Signature Type",
            first_integration_id: "Identifier",
            first_integration_id_hint:
              "It can be the prescription, medical certificate, or encounter number",
            document_code: "Document Code",
            ged_integration_id: "GED Integration",
            finish_date: "Finish Date",
            search_placeholder: "Search...",
            view_details: "View details",
            start_date: "Start date",
            end_date: "End date",
            emailSend: {
              action: "Patient email",
              title: "Patient email",
              identification:
                "Document {{documentCode}} • Encounter {{encounterNumber}}",
              close: "Close",
              loading: "Loading email status...",
              not_sent: "Email not sent",
              not_sent_description:
                "There is no email delivery record for this envelope yet.",
              load_error: "Unable to load email status",
              load_error_description:
                "The delivery status could not be loaded. Please try again.",
              retry: "Try again",
              status: "Status",
              statusValues: {
                pending: "Awaiting delivery",
                sending: "Sending",
                sent: "Sent",
                error: "Delivery error",
                unknown: "Unknown status",
              },
              send_details: "Delivery details",
              recipient: "Recipient",
              sent_at: "Sent at",
              not_sent_yet: "Not sent yet",
              attachments_count: "Number of attachments",
              attempts: "Number of attempts",
              error_message: "Error message",
              no_error_message: "No error message",
            },
            details: {
              title: "Signature Details",
              close: "Close",
              record_info: "Digital signature record",
              signed: "Signed",
              pending: "Pending",
              section_identification: "Identification",
              section_integrations: "Integrations",
              section_dates: "Dates",
              section_qrcode: "QR Code",
              document_code: "Document Code",
              file_name: "File Name",
              file_path: "File Path",
              mime_type: "MIME Type",
              file_size: "File Size",
              first_integration_id: "Prescription / Certificate ID",
              second_integration_id: "Second Integration",
              third_integration_id: "Third Integration",
              ged_integration_id: "GED Integration",
              created: "Created At",
              last_modified: "Last Modified",
              send_date: "Send Date",
              finish_date: "Completion Date",
              qr_code: "QR Code Data",
            },
          },
        },
      },
    },
  },
};

export default en_US;
